(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb360"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb360"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ap0Jw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $792ccec6b5d943e1$export$71511d61b312f219; });
function $792ccec6b5d943e1$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $792ccec6b5d943e1$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $792ccec6b5d943e1$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $792ccec6b5d943e1$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("jRMQN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e768dc3fc959ab77$export$71511d61b312f219; });
function $e768dc3fc959ab77$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});

parcelRegister("e6mbt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a442d583aa7dd23e$export$71511d61b312f219; });

var $avvz3 = parcelRequire("avvz3");

var $WHfHR = parcelRequire("WHfHR");

var $jsaCH = parcelRequire("jsaCH");

var $lhr0B = parcelRequire("lhr0B");
function $a442d583aa7dd23e$export$71511d61b312f219(arr) {
    return (0, $avvz3._)(arr) || (0, $WHfHR._)(arr) || (0, $lhr0B._)(arr) || (0, $jsaCH._)();
}

});
parcelRegister("avvz3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7a6548ae98c4734a$export$71511d61b312f219; });

var $4gXCX = parcelRequire("4gXCX");
function $7a6548ae98c4734a$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $4gXCX._)(arr);
}

});
parcelRegister("4gXCX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $31c6e8c60fad3330$export$71511d61b312f219; });
function $31c6e8c60fad3330$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("WHfHR", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b06f7e7f640b300$export$71511d61b312f219; });
function $0b06f7e7f640b300$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("jsaCH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e298df5d1943e412$export$71511d61b312f219; });
function $e298df5d1943e412$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("lhr0B", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f7e022dc72c51eb9$export$71511d61b312f219; });

var $4gXCX = parcelRequire("4gXCX");
function $f7e022dc72c51eb9$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $4gXCX._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $4gXCX._)(o, minLen);
}

});


parcelRegister("lNXv7", function(module, exports) {

$parcel$export(module.exports, "animate", function () { return $3aedbbed9d648c0c$export$e3607ec2d7a891c4; });

var $81JKW = parcelRequire("81JKW");

var $f7oRS = parcelRequire("f7oRS");

var $9Bgw6 = parcelRequire("9Bgw6");

var $5HMvq = parcelRequire("5HMvq");

var $jvOJ1 = parcelRequire("jvOJ1");

var $kfMw2 = parcelRequire("kfMw2");
function $3aedbbed9d648c0c$var$isSequence(value) {
    return Array.isArray(value) && value.some(Array.isArray);
}
/**
 * Creates an animation function that is optionally scoped
 * to a specific element.
 */ function $3aedbbed9d648c0c$export$c17e592002be9b90() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var scope = options.scope, reduceMotion = options.reduceMotion, skipAnimations = options.skipAnimations;
    /**
     * Implementation
     */ function scopedAnimate(subjectOrSequence, optionsOrKeyframes, options) {
        var animations = [];
        var animationOnComplete;
        var inherited = {};
        if (reduceMotion !== undefined) inherited.reduceMotion = reduceMotion;
        if (skipAnimations !== undefined) inherited.skipAnimations = skipAnimations;
        if ($3aedbbed9d648c0c$var$isSequence(subjectOrSequence)) {
            var _ref = optionsOrKeyframes || {}, onComplete = _ref.onComplete, sequenceOptions = (0, $f7oRS._)(_ref, [
                "onComplete"
            ]);
            if (typeof onComplete === "function") animationOnComplete = onComplete;
            animations = (0, $jvOJ1.animateSequence)(subjectOrSequence, (0, $81JKW._)({}, inherited, sequenceOptions), scope);
        } else {
            // Extract top-level onComplete so it doesn't get applied per-value
            var _ref1 = options || {}, onComplete1 = _ref1.onComplete, rest = (0, $f7oRS._)(_ref1, [
                "onComplete"
            ]);
            if (typeof onComplete1 === "function") animationOnComplete = onComplete1;
            animations = (0, $kfMw2.animateSubject)(subjectOrSequence, optionsOrKeyframes, (0, $81JKW._)({}, inherited, rest), scope);
        }
        var animation = new (0, $9Bgw6.GroupAnimationWithThen)(animations);
        if (animationOnComplete) animation.finished.then(animationOnComplete);
        if (scope) {
            scope.animations.push(animation);
            animation.finished.then(function() {
                (0, $5HMvq.removeItem)(scope.animations, animation);
            });
        }
        return animation;
    }
    return scopedAnimate;
}
var $3aedbbed9d648c0c$export$e3607ec2d7a891c4 = $3aedbbed9d648c0c$export$c17e592002be9b90();

});
parcelRegister("81JKW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5d81e8f62e10ca47$export$71511d61b312f219; });

var $inKFz = parcelRequire("inKFz");
function $5d81e8f62e10ca47$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $inKFz._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("inKFz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d61e93935e56369c$export$71511d61b312f219; });
function $d61e93935e56369c$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("f7oRS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b01accb523500147$export$71511d61b312f219; });

var $e0oqK = parcelRequire("e0oqK");
function $b01accb523500147$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $e0oqK._)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("e0oqK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a3240423dd750555$export$71511d61b312f219; });
function $a3240423dd750555$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("9Bgw6", function(module, exports) {

$parcel$export(module.exports, "GroupAnimationWithThen", function () { return $e316a0a192742633$export$77cf9b7b4d0397cf; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $goUpr = parcelRequire("goUpr");

var $eehIE = parcelRequire("eehIE");
var $e316a0a192742633$export$77cf9b7b4d0397cf = /*#__PURE__*/ function(GroupAnimation) {
    "use strict";
    (0, $goUpr._)(GroupAnimationWithThen, GroupAnimation);
    function GroupAnimationWithThen() {
        (0, $6vyh9._)(this, GroupAnimationWithThen);
        return (0, $enHBd._)(this, GroupAnimationWithThen, arguments);
    }
    (0, $l6JfT._)(GroupAnimationWithThen, [
        {
            key: "then",
            value: function then(onResolve, _onReject) {
                return this.finished.finally(onResolve).then(function() {});
            }
        }
    ]);
    return GroupAnimationWithThen;
}((0, $eehIE.GroupAnimation));

});
parcelRegister("enHBd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a785088dc1d58454$export$71511d61b312f219; });

var $j5BSo = parcelRequire("j5BSo");

var $6kNb6 = parcelRequire("6kNb6");

var $h38BI = parcelRequire("h38BI");
function $a785088dc1d58454$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $j5BSo._)(derived);
    return (0, $h38BI._)(_this, (0, $6kNb6._)() ? Reflect.construct(derived, args || [], (0, $j5BSo._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("j5BSo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $de5bdd6bec912574$export$71511d61b312f219; });
function $de5bdd6bec912574$export$71511d61b312f219(o) {
    $de5bdd6bec912574$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $de5bdd6bec912574$export$71511d61b312f219(o);
}

});

parcelRegister("6kNb6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $49cac21318f65b09$export$71511d61b312f219; });
function $49cac21318f65b09$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($49cac21318f65b09$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("h38BI", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c69964bc2b833cb0$export$71511d61b312f219; });

var $jXapY = parcelRequire("jXapY");

var $cQSqJ = parcelRequire("cQSqJ");
function $c69964bc2b833cb0$export$71511d61b312f219(self, call) {
    if (call && ((0, $cQSqJ._)(call) === "object" || typeof call === "function")) return call;
    return (0, $jXapY._)(self);
}

});
parcelRegister("jXapY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e86b9bca3b843a3e$export$71511d61b312f219; });
function $e86b9bca3b843a3e$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("cQSqJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $95b490098770cbcb$export$71511d61b312f219; });
function $95b490098770cbcb$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("6vyh9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4bd039c07ff87b2c$export$71511d61b312f219; });
function $4bd039c07ff87b2c$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("l6JfT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f5dd4342c917a997$export$71511d61b312f219; });
function $f5dd4342c917a997$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f5dd4342c917a997$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $f5dd4342c917a997$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f5dd4342c917a997$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("goUpr", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bf0aa4f9100b744d$export$71511d61b312f219; });

var $jvBnt = parcelRequire("jvBnt");
function $bf0aa4f9100b744d$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $jvBnt._)(subClass, superClass);
}

});
parcelRegister("jvBnt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e33de80036d82669$export$71511d61b312f219; });
function $e33de80036d82669$export$71511d61b312f219(o, p) {
    $e33de80036d82669$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e33de80036d82669$export$71511d61b312f219(o, p);
}

});


parcelRegister("eehIE", function(module, exports) {

$parcel$export(module.exports, "GroupAnimation", function () { return $c15f9151f1d95edb$export$63bc083c14074060; });

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");
var $c15f9151f1d95edb$export$63bc083c14074060 = /*#__PURE__*/ function() {
    "use strict";
    function GroupAnimation(animations) {
        var _this = this;
        (0, $6vyh9._)(this, GroupAnimation);
        // Bound to accomadate common `return animation.stop` pattern
        this.stop = function() {
            return _this.runAll("stop");
        };
        this.animations = animations.filter(Boolean);
    }
    (0, $l6JfT._)(GroupAnimation, [
        {
            key: "finished",
            get: function get() {
                return Promise.all(this.animations.map(function(animation) {
                    return animation.finished;
                }));
            }
        },
        {
            /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ key: "getAll",
            value: function getAll(propName) {
                return this.animations[0][propName];
            }
        },
        {
            key: "setAll",
            value: function setAll(propName, newValue) {
                for(var i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this = this;
                var subscriptions = this.animations.map(function(animation) {
                    return animation.attachTimeline(timeline);
                });
                return function() {
                    subscriptions.forEach(function(cancel, i) {
                        cancel && cancel();
                        _this.animations[i].stop();
                    });
                };
            }
        },
        {
            key: "time",
            get: function get() {
                return this.getAll("time");
            },
            set: function set(time) {
                this.setAll("time", time);
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.getAll("speed");
            },
            set: function set(speed) {
                this.setAll("speed", speed);
            }
        },
        {
            key: "state",
            get: function get() {
                return this.getAll("state");
            }
        },
        {
            key: "startTime",
            get: function get() {
                return this.getAll("startTime");
            }
        },
        {
            key: "duration",
            get: function get() {
                return $c15f9151f1d95edb$var$getMax(this.animations, "duration");
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                return $c15f9151f1d95edb$var$getMax(this.animations, "iterationDuration");
            }
        },
        {
            key: "runAll",
            value: function runAll(methodName) {
                this.animations.forEach(function(controls) {
                    return controls[methodName]();
                });
            }
        },
        {
            key: "play",
            value: function play() {
                this.runAll("play");
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.runAll("pause");
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                this.runAll("cancel");
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.runAll("complete");
            }
        }
    ]);
    return GroupAnimation;
}();
function $c15f9151f1d95edb$var$getMax(animations, propName) {
    var max = 0;
    for(var i = 0; i < animations.length; i++){
        var value = animations[i][propName];
        if (value !== null && value > max) max = value;
    }
    return max;
}

});


parcelRegister("5HMvq", function(module, exports) {

$parcel$export(module.exports, "addUniqueItem", function () { return $770ab5ba017c2af8$export$20e507e47fae79fd; });
$parcel$export(module.exports, "removeItem", function () { return $770ab5ba017c2af8$export$fe2d9b4e03920b4c; });

var $3GNpW = parcelRequire("3GNpW");

var $43MQb = parcelRequire("43MQb");
function $770ab5ba017c2af8$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $770ab5ba017c2af8$export$fe2d9b4e03920b4c(arr, item) {
    var index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $770ab5ba017c2af8$export$ec937e64de6c1257(param, fromIndex, toIndex) {
    var _param = (0, $43MQb._)(param), arr = _param.slice(0);
    var startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        var endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        var _arr_splice = (0, $3GNpW._)(arr.splice(fromIndex, 1), 1), item = _arr_splice[0];
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

});
parcelRegister("3GNpW", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2afba09b8d1f6d53$export$71511d61b312f219; });

var $bPXXw = parcelRequire("bPXXw");

var $bnd0b = parcelRequire("bnd0b");

var $5l6uJ = parcelRequire("5l6uJ");

var $lhr0B = parcelRequire("lhr0B");
function $2afba09b8d1f6d53$export$71511d61b312f219(arr, i) {
    return (0, $bPXXw._)(arr) || (0, $bnd0b._)(arr, i) || (0, $lhr0B._)(arr, i) || (0, $5l6uJ._)();
}

});
parcelRegister("bPXXw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $89e2f7b81174b7ee$export$71511d61b312f219; });
function $89e2f7b81174b7ee$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("bnd0b", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $847bed9a7442c97c$export$71511d61b312f219; });
function $847bed9a7442c97c$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("5l6uJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3e33f39c858b4b97$export$71511d61b312f219; });
function $3e33f39c858b4b97$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("43MQb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2f4d53f6d9e7dea9$export$71511d61b312f219; });

var $bPXXw = parcelRequire("bPXXw");

var $WHfHR = parcelRequire("WHfHR");

var $5l6uJ = parcelRequire("5l6uJ");

var $lhr0B = parcelRequire("lhr0B");
function $2f4d53f6d9e7dea9$export$71511d61b312f219(arr) {
    return (0, $bPXXw._)(arr) || (0, $WHfHR._)(arr) || (0, $lhr0B._)(arr) || (0, $5l6uJ._)();
}

});


parcelRegister("jvOJ1", function(module, exports) {

$parcel$export(module.exports, "animateSequence", function () { return $7f3b4da250136cb2$export$82a013c5b12ef57f; });

var $e6mbt = parcelRequire("e6mbt");

var $4WU07 = parcelRequire("4WU07");
var $8T39o = parcelRequire("8T39o");

var $fve4q = parcelRequire("fve4q");

var $kfMw2 = parcelRequire("kfMw2");
function $7f3b4da250136cb2$export$82a013c5b12ef57f(sequence, options, scope) {
    var animations = [];
    /**
     * Pre-process: replace function segments with MotionValue segments,
     * subscribe callbacks immediately
     */ var processedSequence = sequence.map(function(segment) {
        if (Array.isArray(segment) && typeof segment[0] === "function") {
            var callback = segment[0];
            var mv = (0, $4WU07.motionValue)(0);
            mv.on("change", callback);
            if (segment.length === 1) return [
                mv,
                [
                    0,
                    1
                ]
            ];
            else if (segment.length === 2) return [
                mv,
                [
                    0,
                    1
                ],
                segment[1]
            ];
            else return [
                mv,
                segment[1],
                segment[2]
            ];
        }
        return segment;
    });
    var animationDefinitions = (0, $fve4q.createAnimationsFromSequence)(processedSequence, options, scope, {
        spring: (0, $8T39o.spring)
    });
    animationDefinitions.forEach(function(param, subject) {
        var keyframes = param.keyframes, transition = param.transition;
        var _animations;
        (_animations = animations).push.apply(_animations, (0, $e6mbt._)((0, $kfMw2.animateSubject)(subject, keyframes, transition)));
    });
    return animations;
}

});
parcelRegister("4WU07", function(module, exports) {

$parcel$export(module.exports, "motionValue", function () { return $eb7f0a55f1283fa1$export$ce8bdc721e76545f; });

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $hIgjE = parcelRequire("hIgjE");
var $iky9o = parcelRequire("iky9o");

var $jEChV = parcelRequire("jEChV");

var $jQwB6 = parcelRequire("jQwB6");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ var $eb7f0a55f1283fa1$var$MAX_VELOCITY_DELTA = 30;
var $eb7f0a55f1283fa1$var$isFloat = function(value) {
    return !isNaN(parseFloat(value));
};
var $eb7f0a55f1283fa1$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ var $eb7f0a55f1283fa1$export$8cea36d14ee64562 = /*#__PURE__*/ function() {
    "use strict";
    function MotionValue(init) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $6vyh9._)(this, MotionValue);
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = function(v) {
            var currentTime = (0, $jEChV.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (_this.updatedAt !== currentTime) _this.setPrevFrameValue();
            _this.prev = _this.current;
            _this.setCurrent(v);
            // Update update subscribers
            if (_this.current !== _this.prev) {
                var _this_events_change;
                (_this_events_change = _this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(_this.current);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (_this.dependents) try {
                    for(var _iterator = _this.dependents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dependent = _step.value;
                        dependent.dirty();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    (0, $l6JfT._)(MotionValue, [
        {
            key: "setCurrent",
            value: function setCurrent(current) {
                this.current = current;
                this.updatedAt = (0, $jEChV.time).now();
                if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $eb7f0a55f1283fa1$var$isFloat(this.current);
            }
        },
        {
            key: "setPrevFrameValue",
            value: function setPrevFrameValue() {
                var prevFrameValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.current;
                this.prevFrameValue = prevFrameValue;
                this.prevUpdatedAt = this.updatedAt;
            }
        },
        {
            /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ key: "onChange",
            value: function onChange(subscription) {
                return this.on("change", subscription);
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                var _this = this;
                if (!this.events[eventName]) this.events[eventName] = new (0, $hIgjE.SubscriptionManager)();
                var unsubscribe = this.events[eventName].add(callback);
                if (eventName === "change") return function() {
                    unsubscribe();
                    /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $jQwB6.frame).read(function() {
                        if (!_this.events.change.getSize()) _this.stop();
                    });
                };
                return unsubscribe;
            }
        },
        {
            key: "clearListeners",
            value: function clearListeners() {
                for(var eventManagers in this.events)this.events[eventManagers].clear();
            }
        },
        {
            /**
     * Attaches a passive effect to the `MotionValue`.
     */ key: "attach",
            value: function attach(passiveEffect, stopPassiveEffect) {
                this.passiveEffect = passiveEffect;
                this.stopPassiveEffect = stopPassiveEffect;
            }
        },
        {
            /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ key: "set",
            value: function set(v) {
                if (!this.passiveEffect) this.updateAndNotify(v);
                else this.passiveEffect(v, this.updateAndNotify);
            }
        },
        {
            key: "setWithVelocity",
            value: function setWithVelocity(prev, current, delta) {
                this.set(current);
                this.prev = undefined;
                this.prevFrameValue = prev;
                this.prevUpdatedAt = this.updatedAt - delta;
            }
        },
        {
            /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ key: "jump",
            value: function jump(v) {
                var endAnimation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                this.updateAndNotify(v);
                this.prev = v;
                this.prevUpdatedAt = this.prevFrameValue = undefined;
                endAnimation && this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        },
        {
            key: "dirty",
            value: function dirty() {
                var _this_events_change;
                (_this_events_change = this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(this.current);
            }
        },
        {
            key: "addDependent",
            value: function addDependent(dependent) {
                if (!this.dependents) this.dependents = new Set();
                this.dependents.add(dependent);
            }
        },
        {
            key: "removeDependent",
            value: function removeDependent(dependent) {
                if (this.dependents) this.dependents.delete(dependent);
            }
        },
        {
            /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ key: "get",
            value: function get() {
                if ($eb7f0a55f1283fa1$export$67fcd818a264039d.current) $eb7f0a55f1283fa1$export$67fcd818a264039d.current.push(this);
                return this.current;
            }
        },
        {
            /**
     * @public
     */ key: "getPrevious",
            value: function getPrevious() {
                return this.prev;
            }
        },
        {
            /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ key: "getVelocity",
            value: function getVelocity() {
                var currentTime = (0, $jEChV.time).now();
                if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $eb7f0a55f1283fa1$var$MAX_VELOCITY_DELTA) return 0;
                var delta = Math.min(this.updatedAt - this.prevUpdatedAt, $eb7f0a55f1283fa1$var$MAX_VELOCITY_DELTA);
                // Casts because of parseFloat's poor typing
                return (0, $iky9o.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
            }
        },
        {
            /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ key: "start",
            value: function start(startAnimation) {
                var _this = this;
                this.stop();
                return new Promise(function(resolve) {
                    _this.hasAnimated = true;
                    _this.animation = startAnimation(resolve);
                    if (_this.events.animationStart) _this.events.animationStart.notify();
                }).then(function() {
                    if (_this.events.animationComplete) _this.events.animationComplete.notify();
                    _this.clearAnimation();
                });
            }
        },
        {
            /**
     * Stop the currently active animation.
     *
     * @public
     */ key: "stop",
            value: function stop() {
                if (this.animation) {
                    this.animation.stop();
                    if (this.events.animationCancel) this.events.animationCancel.notify();
                }
                this.clearAnimation();
            }
        },
        {
            /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ key: "isAnimating",
            value: function isAnimating() {
                return !!this.animation;
            }
        },
        {
            key: "clearAnimation",
            value: function clearAnimation() {
                delete this.animation;
            }
        },
        {
            /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ key: "destroy",
            value: function destroy() {
                var _this_dependents, _this_events_destroy;
                (_this_dependents = this.dependents) === null || _this_dependents === void 0 ? void 0 : _this_dependents.clear();
                (_this_events_destroy = this.events.destroy) === null || _this_events_destroy === void 0 ? void 0 : _this_events_destroy.notify();
                this.clearListeners();
                this.stop();
                if (this.stopPassiveEffect) this.stopPassiveEffect();
            }
        }
    ]);
    return MotionValue;
}();
function $eb7f0a55f1283fa1$export$ce8bdc721e76545f(init, options) {
    return new $eb7f0a55f1283fa1$export$8cea36d14ee64562(init, options);
}

});
parcelRegister("hIgjE", function(module, exports) {

$parcel$export(module.exports, "SubscriptionManager", function () { return $16a7f2a7509c16fb$export$e7dff9482a5fd23c; });

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $5HMvq = parcelRequire("5HMvq");
var $16a7f2a7509c16fb$export$e7dff9482a5fd23c = /*#__PURE__*/ function() {
    "use strict";
    function SubscriptionManager() {
        (0, $6vyh9._)(this, SubscriptionManager);
        this.subscriptions = [];
    }
    (0, $l6JfT._)(SubscriptionManager, [
        {
            key: "add",
            value: function add(handler) {
                var _this = this;
                (0, $5HMvq.addUniqueItem)(this.subscriptions, handler);
                return function() {
                    return (0, $5HMvq.removeItem)(_this.subscriptions, handler);
                };
            }
        },
        {
            key: "notify",
            value: function notify(a, b, c) {
                var numSubscriptions = this.subscriptions.length;
                if (!numSubscriptions) return;
                if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
                else for(var i = 0; i < numSubscriptions; i++){
                    /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ var handler = this.subscriptions[i];
                    handler && handler(a, b, c);
                }
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.subscriptions.length;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.subscriptions.length = 0;
            }
        }
    ]);
    return SubscriptionManager;
}();

});

parcelRegister("iky9o", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $70dbab12b3120ff6$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second
*/ /*#__NO_SIDE_EFFECTS__*/ var $70dbab12b3120ff6$export$eab0632f7ad4f9d7 = function(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
};

});

parcelRegister("jEChV", function(module, exports) {

$parcel$export(module.exports, "time", function () { return $85171a1f3c74df89$export$2da9be4cfdb689b1; });

var $jdEmz = parcelRequire("jdEmz");

var $jQwB6 = parcelRequire("jQwB6");
var $85171a1f3c74df89$var$now;
function $85171a1f3c74df89$var$clearTime() {
    $85171a1f3c74df89$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ var $85171a1f3c74df89$export$2da9be4cfdb689b1 = {
    now: function() {
        if ($85171a1f3c74df89$var$now === undefined) $85171a1f3c74df89$export$2da9be4cfdb689b1.set((0, $jQwB6.frameData).isProcessing || (0, $jdEmz.MotionGlobalConfig).useManualTiming ? (0, $jQwB6.frameData).timestamp : performance.now());
        return $85171a1f3c74df89$var$now;
    },
    set: function(newTime) {
        $85171a1f3c74df89$var$now = newTime;
        queueMicrotask($85171a1f3c74df89$var$clearTime);
    }
};

});
parcelRegister("jdEmz", function(module, exports) {

$parcel$export(module.exports, "MotionGlobalConfig", function () { return $8da9116fd5d8ed39$export$dd826089e3c5e502; });
var $8da9116fd5d8ed39$export$dd826089e3c5e502 = {};

});

parcelRegister("jQwB6", function(module, exports) {

$parcel$export(module.exports, "frame", function () { return $c2069941ea48e2b0$export$2cef06c20297c17d; });
$parcel$export(module.exports, "cancelFrame", function () { return $c2069941ea48e2b0$export$ec99c0ef4978dccb; });
$parcel$export(module.exports, "frameData", function () { return $c2069941ea48e2b0$export$fff89137e9e818ce; });

var $jXHGJ = parcelRequire("jXHGJ");

var $7HpLF = parcelRequire("7HpLF");
var /* @__PURE__ */ $c2069941ea48e2b0$var$_createRenderBatcher = (0, $7HpLF.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $jXHGJ.noop), true), $c2069941ea48e2b0$export$2cef06c20297c17d = $c2069941ea48e2b0$var$_createRenderBatcher.schedule, $c2069941ea48e2b0$export$ec99c0ef4978dccb = $c2069941ea48e2b0$var$_createRenderBatcher.cancel, $c2069941ea48e2b0$export$fff89137e9e818ce = $c2069941ea48e2b0$var$_createRenderBatcher.state, $c2069941ea48e2b0$export$1811c3a7e3af92f0 = $c2069941ea48e2b0$var$_createRenderBatcher.steps;

});
parcelRegister("jXHGJ", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $1bedd58c8a062ade$export$8793edee2d425525; });
/*#__NO_SIDE_EFFECTS__*/ var $1bedd58c8a062ade$export$8793edee2d425525 = function(any) {
    return any;
};

});

parcelRegister("7HpLF", function(module, exports) {

$parcel$export(module.exports, "createRenderBatcher", function () { return $2ada8430064ea3b9$export$510b0596a933801a; });

var $jdEmz = parcelRequire("jdEmz");

var $8giUG = parcelRequire("8giUG");

var $kt6mw = parcelRequire("kt6mw");
var $2ada8430064ea3b9$var$maxElapsed = 40;
function $2ada8430064ea3b9$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    var runNextFrame = false;
    var useDefaultElapsed = true;
    var state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    var flagRunNextFrame = function() {
        return runNextFrame = true;
    };
    var steps = (0, $8giUG.stepsOrder).reduce(function(acc, key) {
        acc[key] = (0, $kt6mw.createRenderStep)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    var setup = steps.setup, read = steps.read, resolveKeyframes = steps.resolveKeyframes, preUpdate = steps.preUpdate, update = steps.update, preRender = steps.preRender, render = steps.render, postRender = steps.postRender;
    var processBatch = function() {
        var useManualTiming = (0, $jdEmz.MotionGlobalConfig).useManualTiming;
        var timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $2ada8430064ea3b9$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    var wake = function() {
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    var schedule = (0, $8giUG.stepsOrder).reduce(function(acc, key) {
        var step = steps[key];
        acc[key] = function(process) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    var cancel = function(process) {
        for(var i = 0; i < (0, $8giUG.stepsOrder).length; i++)steps[(0, $8giUG.stepsOrder)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}

});
parcelRegister("8giUG", function(module, exports) {

$parcel$export(module.exports, "stepsOrder", function () { return $336dddb61909ecb7$export$71ecace0a033b35a; });
var $336dddb61909ecb7$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];

});

parcelRegister("kt6mw", function(module, exports) {

$parcel$export(module.exports, "createRenderStep", function () { return $335c649c8a52d698$export$b995e5e85f5c8289; });

var $2crQf = parcelRequire("2crQf");
function $335c649c8a52d698$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ var thisFrame = new Set();
    var nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ var isProcessing = false;
    var flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ var toKeepAlive = new WeakSet();
    var latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    var numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    var step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: function(callback) {
            var keepAlive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, immediate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var addToCurrentFrame = immediate && isProcessing;
            var queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: function(callback) {
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: function(frameData) {
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            var prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $2crQf.statsBuffer).value) (0, $2crQf.statsBuffer).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

});
parcelRegister("2crQf", function(module, exports) {

$parcel$export(module.exports, "statsBuffer", function () { return $a460b9563c4f5f8d$export$84ce9a476f53d110; });
var $a460b9563c4f5f8d$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};

});






parcelRegister("8T39o", function(module, exports) {

$parcel$export(module.exports, "spring", function () { return $cef5d73e8b0b1845$export$b36281d89752ae66; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $cQSqJ = parcelRequire("cQSqJ");

var $21URL = parcelRequire("21URL");
var $cxm77 = parcelRequire("cxm77");
var $boJRf = parcelRequire("boJRf");

var $6RDNP = parcelRequire("6RDNP");

var $4UKlY = parcelRequire("4UKlY");

var $irpDt = parcelRequire("irpDt");
var $cef5d73e8b0b1845$var$springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function $cef5d73e8b0b1845$var$calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
var $cef5d73e8b0b1845$var$rootIterations = 12;
function $cef5d73e8b0b1845$var$approximateRoot(envelope, derivative, initialGuess) {
    var result = initialGuess;
    for(var i = 1; i < $cef5d73e8b0b1845$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ var $cef5d73e8b0b1845$var$safeMin = 0.001;
function $cef5d73e8b0b1845$var$findSpring(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? $cef5d73e8b0b1845$var$springDefaults.duration : _param_duration, _param_bounce = param.bounce, bounce = _param_bounce === void 0 ? $cef5d73e8b0b1845$var$springDefaults.bounce : _param_bounce, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? $cef5d73e8b0b1845$var$springDefaults.velocity : _param_velocity, _param_mass = param.mass, mass = _param_mass === void 0 ? $cef5d73e8b0b1845$var$springDefaults.mass : _param_mass;
    var envelope;
    var derivative;
    (0, $boJRf.warning)(duration <= (0, $cxm77.secondsToMilliseconds)($cef5d73e8b0b1845$var$springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    var dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $21URL.clamp)($cef5d73e8b0b1845$var$springDefaults.minDamping, $cef5d73e8b0b1845$var$springDefaults.maxDamping, dampingRatio);
    duration = (0, $21URL.clamp)($cef5d73e8b0b1845$var$springDefaults.minDuration, $cef5d73e8b0b1845$var$springDefaults.maxDuration, (0, $cxm77.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var a = exponentialDecay - velocity;
            var b = $cef5d73e8b0b1845$var$calcAngularFreq(undampedFreq, dampingRatio);
            var c = Math.exp(-delta);
            return $cef5d73e8b0b1845$var$safeMin - a / b * c;
        };
        derivative = function(undampedFreq) {
            var exponentialDecay = undampedFreq * dampingRatio;
            var delta = exponentialDecay * duration;
            var d = delta * velocity + velocity;
            var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            var f = Math.exp(-delta);
            var g = $cef5d73e8b0b1845$var$calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            var factor = -envelope(undampedFreq) + $cef5d73e8b0b1845$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (undampedFreq - velocity) * duration + 1;
            return -$cef5d73e8b0b1845$var$safeMin + a * b;
        };
        derivative = function(undampedFreq) {
            var a = Math.exp(-undampedFreq * duration);
            var b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    var initialGuess = 5 / duration;
    var undampedFreq = $cef5d73e8b0b1845$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $cxm77.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: $cef5d73e8b0b1845$var$springDefaults.stiffness,
        damping: $cef5d73e8b0b1845$var$springDefaults.damping,
        duration: duration
    };
    else {
        var stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
var $cef5d73e8b0b1845$var$durationKeys = [
    "duration",
    "bounce"
];
var $cef5d73e8b0b1845$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $cef5d73e8b0b1845$var$isSpringType(options, keys) {
    return keys.some(function(key) {
        return options[key] !== undefined;
    });
}
function $cef5d73e8b0b1845$var$getSpringOptions(options) {
    var springOptions = (0, $81JKW._)({
        velocity: $cef5d73e8b0b1845$var$springDefaults.velocity,
        stiffness: $cef5d73e8b0b1845$var$springDefaults.stiffness,
        damping: $cef5d73e8b0b1845$var$springDefaults.damping,
        mass: $cef5d73e8b0b1845$var$springDefaults.mass,
        isResolvedFromDuration: false
    }, options);
    // stiffness/damping/mass overrides duration/bounce
    if (!$cef5d73e8b0b1845$var$isSpringType(options, $cef5d73e8b0b1845$var$physicsKeys) && $cef5d73e8b0b1845$var$isSpringType(options, $cef5d73e8b0b1845$var$durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            var visualDuration = options.visualDuration;
            var root = 2 * Math.PI / (visualDuration * 1.2);
            var stiffness = root * root;
            var damping = 2 * (0, $21URL.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = (0, $bPuui._)((0, $81JKW._)({}, springOptions), {
                mass: $cef5d73e8b0b1845$var$springDefaults.mass,
                stiffness: stiffness,
                damping: damping
            });
        } else {
            var derived = $cef5d73e8b0b1845$var$findSpring((0, $bPuui._)((0, $81JKW._)({}, options), {
                velocity: 0
            }));
            springOptions = (0, $bPuui._)((0, $81JKW._)({}, springOptions, derived), {
                mass: $cef5d73e8b0b1845$var$springDefaults.mass
            });
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $cef5d73e8b0b1845$export$b36281d89752ae66() {
    var optionsOrVisualDuration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $cef5d73e8b0b1845$var$springDefaults.visualDuration, bounce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $cef5d73e8b0b1845$var$springDefaults.bounce;
    var options = (typeof optionsOrVisualDuration === "undefined" ? "undefined" : (0, $cQSqJ._)(optionsOrVisualDuration)) !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    var restSpeed = options.restSpeed, restDelta = options.restDelta;
    var origin = options.keyframes[0];
    var target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: origin
    };
    var _getSpringOptions = $cef5d73e8b0b1845$var$getSpringOptions((0, $bPuui._)((0, $81JKW._)({}, options), {
        velocity: -(0, $cxm77.millisecondsToSeconds)(options.velocity || 0)
    })), stiffness = _getSpringOptions.stiffness, damping = _getSpringOptions.damping, mass = _getSpringOptions.mass, duration = _getSpringOptions.duration, velocity = _getSpringOptions.velocity, isResolvedFromDuration = _getSpringOptions.isResolvedFromDuration;
    var initialVelocity = velocity || 0.0;
    var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    var initialDelta = target - origin;
    var undampedAngularFreq = (0, $cxm77.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ var isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? $cef5d73e8b0b1845$var$springDefaults.restSpeed.granular : $cef5d73e8b0b1845$var$springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? $cef5d73e8b0b1845$var$springDefaults.restDelta.granular : $cef5d73e8b0b1845$var$springDefaults.restDelta.default);
    var resolveSpring;
    var resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    var angularFreq;
    var A;
    var sinCoeff;
    var cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = $cef5d73e8b0b1845$var$calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = function(t) {
            return target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        };
        // Analytical derivative of critically damped spring (px/ms)
        var C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = function(t) {
            return Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
        };
    } else {
        // Overdamped spring
        var dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            var freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        var P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        var sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        var coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = function(t) {
            var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            var freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    var generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: function(t) {
            return (0, $cxm77.secondsToMilliseconds)(resolveVelocity(t));
        },
        next: function(t) {
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                var sin = Math.sin(angularFreq * t);
                var cos = Math.cos(angularFreq * t);
                var current = target - envelope * (A * sin + initialDelta * cos);
                var currentVelocity = (0, $cxm77.secondsToMilliseconds)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            var current1 = resolveSpring(t);
            if (!isResolvedFromDuration) {
                var currentVelocity1 = (0, $cxm77.secondsToMilliseconds)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity1) <= restSpeed && Math.abs(target - current1) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current1;
            return state;
        },
        toString: function() {
            var calculatedDuration = Math.min((0, $4UKlY.calcGeneratorDuration)(generator), (0, $4UKlY.maxGeneratorDuration));
            var easing = (0, $6RDNP.generateLinearEasing)(function(progress) {
                return generator.next(calculatedDuration * progress).value;
            }, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: function() {}
    };
    return generator;
}
$cef5d73e8b0b1845$export$b36281d89752ae66.applyToOptions = function(options) {
    var generatorOptions = (0, $irpDt.createGeneratorEasing)(options, 100, $cef5d73e8b0b1845$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $cxm77.secondsToMilliseconds)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};

});
parcelRegister("bPuui", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $89cc1b556fc3d2a8$export$71511d61b312f219; });
function $89cc1b556fc3d2a8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $89cc1b556fc3d2a8$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $89cc1b556fc3d2a8$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("21URL", function(module, exports) {

$parcel$export(module.exports, "clamp", function () { return $6bbf7acafb6ab168$export$7d15b64cf5a3a4c4; });
var $6bbf7acafb6ab168$export$7d15b64cf5a3a4c4 = function(min, max, v) {
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

});

parcelRegister("cxm77", function(module, exports) {

$parcel$export(module.exports, "secondsToMilliseconds", function () { return $8de84a6edf299cf3$export$fc3e7e8557f8c8c7; });
$parcel$export(module.exports, "millisecondsToSeconds", function () { return $8de84a6edf299cf3$export$f64c3bfbc58eec0f; });
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ var $8de84a6edf299cf3$export$fc3e7e8557f8c8c7 = function(seconds) {
    return seconds * 1000;
};
/*#__NO_SIDE_EFFECTS__*/ var $8de84a6edf299cf3$export$f64c3bfbc58eec0f = function(milliseconds) {
    return milliseconds / 1000;
};

});

parcelRegister("boJRf", function(module, exports) {

$parcel$export(module.exports, "warning", function () { return $845bafc35b930cbb$export$491112666e282270; });
$parcel$export(module.exports, "invariant", function () { return $845bafc35b930cbb$export$f5708dca728d7177; });

var $845bafc35b930cbb$export$491112666e282270 = function() {};
var $845bafc35b930cbb$export$f5708dca728d7177 = function() {};
var $845bafc35b930cbb$var$check, $845bafc35b930cbb$var$message, $845bafc35b930cbb$var$errorCode, $845bafc35b930cbb$var$check1, $845bafc35b930cbb$var$message1, $845bafc35b930cbb$var$errorCode1;

});

parcelRegister("6RDNP", function(module, exports) {

$parcel$export(module.exports, "generateLinearEasing", function () { return $d08a82310390948b$export$66d3851e2b1ec912; });
var $d08a82310390948b$export$66d3851e2b1ec912 = function(easing, duration) {
    var resolution = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10 // as milliseconds
    ;
    var points = "";
    var numPoints = Math.max(Math.round(duration / resolution), 2);
    for(var i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return "linear(".concat(points.substring(0, points.length - 2), ")");
};

});

parcelRegister("4UKlY", function(module, exports) {

$parcel$export(module.exports, "maxGeneratorDuration", function () { return $da6fb2823eb0c4a3$export$f4ff70a5b4808fd8; });
$parcel$export(module.exports, "calcGeneratorDuration", function () { return $da6fb2823eb0c4a3$export$cbdd6b3d40ea54e2; });
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ var $da6fb2823eb0c4a3$export$f4ff70a5b4808fd8 = 20000;
function $da6fb2823eb0c4a3$export$cbdd6b3d40ea54e2(generator) {
    var duration = 0;
    var timeStep = 50;
    var state = generator.next(duration);
    while(!state.done && duration < $da6fb2823eb0c4a3$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $da6fb2823eb0c4a3$export$f4ff70a5b4808fd8 ? Infinity : duration;
}

});

parcelRegister("irpDt", function(module, exports) {

$parcel$export(module.exports, "createGeneratorEasing", function () { return $463bf10bc9d5168a$export$7f1511d09ee75a99; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $cxm77 = parcelRequire("cxm77");

var $4UKlY = parcelRequire("4UKlY");
/**
 * Create a progress => progress easing function from a generator.
 */ function $463bf10bc9d5168a$export$7f1511d09ee75a99(options) {
    var scale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, createGenerator = arguments.length > 2 ? arguments[2] : void 0;
    var generator = createGenerator((0, $bPuui._)((0, $81JKW._)({}, options), {
        keyframes: [
            0,
            scale
        ]
    }));
    var duration = Math.min((0, $4UKlY.calcGeneratorDuration)(generator), (0, $4UKlY.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: function(progress) {
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $cxm77.millisecondsToSeconds)(duration)
    };
}

});


parcelRegister("fve4q", function(module, exports) {

$parcel$export(module.exports, "createAnimationsFromSequence", function () { return $24fcfc98546a9dbb$export$1f0f44b51a4b2f73; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $f7oRS = parcelRequire("f7oRS");

var $3GNpW = parcelRequire("3GNpW");

var $e6mbt = parcelRequire("e6mbt");

var $irpDt = parcelRequire("irpDt");
var $7X1wi = parcelRequire("7X1wi");
var $4fAA2 = parcelRequire("4fAA2");
var $8JGS8 = parcelRequire("8JGS8");
var $ejle5 = parcelRequire("ejle5");

var $c9XlN = parcelRequire("c9XlN");
var $jbUqp = parcelRequire("jbUqp");
var $fUcOl = parcelRequire("fUcOl");
var $cxm77 = parcelRequire("cxm77");
var $boJRf = parcelRequire("boJRf");

var $3htWe = parcelRequire("3htWe");

var $dGdtN = parcelRequire("dGdtN");

var $4wT2u = parcelRequire("4wT2u");

var $3SltM = parcelRequire("3SltM");

var $i2T9s = parcelRequire("i2T9s");

var $hWniQ = parcelRequire("hWniQ");
var $24fcfc98546a9dbb$var$defaultSegmentEasing = "easeInOut";
var $24fcfc98546a9dbb$var$MAX_REPEAT = 20;
function $24fcfc98546a9dbb$export$1f0f44b51a4b2f73(sequence) {
    var _loop = function(i) {
        var segment = sequence[i];
        /**
         * If this is a timeline label, mark it and skip the rest of this iteration.
         */ if (typeof segment === "string") {
            timeLabels.set(segment, currentTime);
            return "continue";
        } else if (!Array.isArray(segment)) {
            timeLabels.set(segment.name, (0, $4wT2u.calcNextTime)(currentTime, segment.at, prevTime, timeLabels));
            return "continue";
        }
        var _segment = (0, $3GNpW._)(segment, 3), subject = _segment[0], keyframes = _segment[1], tmp = _segment[2], transition = tmp === void 0 ? {} : tmp;
        /**
         * If a relative or absolute time value has been specified we need to resolve
         * it in relation to the currentTime.
         */ if (transition.at !== undefined) currentTime = (0, $4wT2u.calcNextTime)(currentTime, transition.at, prevTime, timeLabels);
        /**
         * Keep track of the maximum duration in this definition. This will be
         * applied to currentTime once the definition has been parsed.
         */ var maxDuration = 0;
        var resolveValueSequence = function(valueKeyframes, valueTransition, valueSequence) {
            var elementIndex = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, numSubjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
            var valueKeyframesAsList = $24fcfc98546a9dbb$var$keyframesAsList(valueKeyframes);
            var _valueTransition_delay = valueTransition.delay, delay = _valueTransition_delay === void 0 ? 0 : _valueTransition_delay, _valueTransition_times = valueTransition.times, times = _valueTransition_times === void 0 ? (0, $7X1wi.defaultOffset)(valueKeyframesAsList) : _valueTransition_times, _valueTransition_type = valueTransition.type, type = _valueTransition_type === void 0 ? defaultTransition.type || "keyframes" : _valueTransition_type, repeat = valueTransition.repeat, repeatType = valueTransition.repeatType, _valueTransition_repeatDelay = valueTransition.repeatDelay, repeatDelay = _valueTransition_repeatDelay === void 0 ? 0 : _valueTransition_repeatDelay, remainingTransition = (0, $f7oRS._)(valueTransition, [
                "delay",
                "times",
                "type",
                "repeat",
                "repeatType",
                "repeatDelay"
            ]);
            var _valueTransition_ease = valueTransition.ease, ease = _valueTransition_ease === void 0 ? defaultTransition.ease || "easeOut" : _valueTransition_ease, duration = valueTransition.duration;
            /**
             * Resolve stagger() if defined.
             */ var calculatedDelay = typeof delay === "function" ? delay(elementIndex, numSubjects) : delay;
            /**
             * If this animation should and can use a spring, generate a spring easing function.
             */ var numKeyframes = valueKeyframesAsList.length;
            var createGenerator = (0, $8JGS8.isGenerator)(type) ? type : generators === null || generators === void 0 ? void 0 : generators[type || "keyframes"];
            if (numKeyframes <= 2 && createGenerator) {
                /**
                 * As we're creating an easing function from a spring,
                 * ideally we want to generate it using the real distance
                 * between the two keyframes. However this isn't always
                 * possible - in these situations we use 0-100.
                 */ var absoluteDelta = 100;
                if (numKeyframes === 2 && $24fcfc98546a9dbb$var$isNumberKeyframesArray(valueKeyframesAsList)) {
                    var delta = valueKeyframesAsList[1] - valueKeyframesAsList[0];
                    absoluteDelta = Math.abs(delta);
                }
                var springTransition = (0, $81JKW._)({}, defaultTransition, remainingTransition);
                if (duration !== undefined) springTransition.duration = (0, $cxm77.secondsToMilliseconds)(duration);
                var springEasing = (0, $irpDt.createGeneratorEasing)(springTransition, absoluteDelta, createGenerator);
                ease = springEasing.ease;
                duration = springEasing.duration;
            }
            duration !== null && duration !== void 0 ? duration : duration = defaultDuration;
            var startTime = currentTime + calculatedDelay;
            /**
             * If there's only one time offset of 0, fill in a second with length 1
             */ if (times.length === 1 && times[0] === 0) times[1] = 1;
            /**
             * Fill out if offset if fewer offsets than keyframes
             */ var remainder = times.length - valueKeyframesAsList.length;
            remainder > 0 && (0, $4fAA2.fillOffset)(times, remainder);
            /**
             * If only one value has been set, ie [1], push a null to the start of
             * the keyframe array. This will let us mark a keyframe at this point
             * that will later be hydrated with the previous value.
             */ valueKeyframesAsList.length === 1 && valueKeyframesAsList.unshift(null);
            /**
             * Segments can't express `repeat: Infinity` or very large
             * counts — they'd leave dead time after the segment or
             * explode the keyframe array. Ignore with a warning.
             */ if (repeat) (0, $boJRf.warning)(repeat < $24fcfc98546a9dbb$var$MAX_REPEAT, "Sequence segments can't repeat ".concat(repeat, " times \u2014 ignoring repeat option. Use a value below ").concat($24fcfc98546a9dbb$var$MAX_REPEAT, " or apply repeat at the sequence level instead."));
            if (repeat && repeat < $24fcfc98546a9dbb$var$MAX_REPEAT) {
                /**
                 * Express repeatDelay in units of a single iteration's duration
                 * so it can be added to the per-iteration time offsets below
                 * before they're normalized to 0-1.
                 */ var repeatDelayUnits = duration > 0 ? repeatDelay / duration : 0;
                duration = (0, $dGdtN.calculateRepeatDuration)(duration, repeat, repeatDelay);
                var originalKeyframes = (0, $e6mbt._)(valueKeyframesAsList);
                var originalTimes = (0, $e6mbt._)(times);
                ease = Array.isArray(ease) ? (0, $e6mbt._)(ease) : [
                    ease
                ];
                var originalEase = (0, $e6mbt._)(ease);
                /**
                 * For reverse/mirror, alternate iterations play the segment
                 * backwards. mirror matches JSAnimation's mirroredGenerator:
                 * reversed keyframes, easings unchanged. reverse matches
                 * JSAnimation's iterationProgress = 1 - p: reversed
                 * keyframes, easing array reversed AND each function easing
                 * mapped through reverseEasing (string easings unchanged —
                 * they're resolved later by the keyframes engine).
                 */ var isFlipping = repeatType === "reverse" || repeatType === "mirror";
                var flippedKeyframes = originalKeyframes;
                var flippedEases = originalEase;
                if (isFlipping) {
                    flippedKeyframes = (0, $e6mbt._)(originalKeyframes).reverse();
                    if (repeatType === "reverse") flippedEases = (0, $e6mbt._)(originalEase).reverse().map(function(e) {
                        return typeof e === "function" ? (0, $fUcOl.reverseEasing)(e) : e;
                    });
                }
                for(var repeatIndex = 0; repeatIndex < repeat; repeatIndex++){
                    var _valueKeyframesAsList;
                    var isFlipped = isFlipping && repeatIndex % 2 === 0;
                    var iterKeyframes = isFlipped ? flippedKeyframes : originalKeyframes;
                    var iterEase = isFlipped ? flippedEases : originalEase;
                    var iterStartOffset = (repeatIndex + 1) * (1 + repeatDelayUnits);
                    /**
                     * If repeatDelay is set, hold the previous iteration's
                     * final value through the delay by inserting a keyframe
                     * at the moment the next iteration begins.
                     */ if (repeatDelayUnits > 0) {
                        valueKeyframesAsList.push(valueKeyframesAsList[valueKeyframesAsList.length - 1]);
                        times.push(iterStartOffset);
                        ease.push("linear");
                    }
                    (_valueKeyframesAsList = valueKeyframesAsList).push.apply(_valueKeyframesAsList, (0, $e6mbt._)(iterKeyframes));
                    for(var keyframeIndex = 0; keyframeIndex < iterKeyframes.length; keyframeIndex++){
                        times.push(originalTimes[keyframeIndex] + iterStartOffset);
                        ease.push(keyframeIndex === 0 ? "linear" : (0, $c9XlN.getEasingForSegment)(iterEase, keyframeIndex - 1));
                    }
                }
                (0, $i2T9s.normalizeTimes)(times, repeat, repeatDelayUnits);
            }
            var targetTime = startTime + duration;
            /**
             * Add keyframes, mapping offsets to absolute time.
             */ (0, $3SltM.addKeyframes)(valueSequence, valueKeyframesAsList, ease, times, startTime, targetTime);
            maxDuration = Math.max(calculatedDelay + duration, maxDuration);
            totalDuration = Math.max(targetTime, totalDuration);
        };
        if ((0, $ejle5.isMotionValue)(subject)) {
            var subjectSequence = $24fcfc98546a9dbb$var$getSubjectSequence(subject, sequences);
            resolveValueSequence(keyframes, transition, $24fcfc98546a9dbb$var$getValueSequence("default", subjectSequence));
        } else {
            var subjects = (0, $3htWe.resolveSubjects)(subject, keyframes, scope, elementCache);
            var numSubjects = subjects.length;
            /**
             * For every element in this segment, process the defined values.
             */ for(var subjectIndex = 0; subjectIndex < numSubjects; subjectIndex++){
                /**
                 * Cast necessary, but we know these are of this type
                 */ keyframes;
                transition;
                var thisSubject = subjects[subjectIndex];
                var subjectSequence1 = $24fcfc98546a9dbb$var$getSubjectSequence(thisSubject, sequences);
                for(var key in keyframes)resolveValueSequence(keyframes[key], $24fcfc98546a9dbb$export$7c1391340308742e(transition, key), $24fcfc98546a9dbb$var$getValueSequence(key, subjectSequence1), subjectIndex, numSubjects);
            }
        }
        prevTime = currentTime;
        currentTime += maxDuration;
    };
    var _param = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, scope = arguments.length > 2 ? arguments[2] : void 0, generators = arguments.length > 3 ? arguments[3] : void 0;
    var _param_defaultTransition = _param.defaultTransition, defaultTransition = _param_defaultTransition === void 0 ? {} : _param_defaultTransition, sequenceTransition = (0, $f7oRS._)(_param, [
        "defaultTransition"
    ]);
    var defaultDuration = defaultTransition.duration || 0.3;
    var animationDefinitions = new Map();
    var sequences = new Map();
    var elementCache = {};
    var timeLabels = new Map();
    var prevTime = 0;
    var currentTime = 0;
    var totalDuration = 0;
    /**
     * Build the timeline by mapping over the sequence array and converting
     * the definitions into keyframes and offsets with absolute time values.
     * These will later get converted into relative offsets in a second pass.
     */ for(var i = 0; i < sequence.length; i++)_loop(i);
    /**
     * For every element and value combination create a new animation.
     */ sequences.forEach(function(valueSequences, element) {
        for(var _ref in valueSequences){
            var key = _ref;
            var valueSequence = valueSequences[key];
            /**
             * Arrange all the keyframes in ascending time order.
             */ valueSequence.sort((0, $hWniQ.compareByTime));
            var keyframes = [];
            var valueOffset = [];
            var valueEasing = [];
            /**
             * For each keyframe, translate absolute times into
             * relative offsets based on the total duration of the timeline.
             */ for(var i = 0; i < valueSequence.length; i++){
                var _valueSequence_i = valueSequence[i], at = _valueSequence_i.at, value = _valueSequence_i.value, easing = _valueSequence_i.easing;
                keyframes.push(value);
                valueOffset.push((0, $jbUqp.progress)(0, totalDuration, at));
                valueEasing.push(easing || "easeOut");
            }
            /**
             * If the first keyframe doesn't land on offset: 0
             * provide one by duplicating the initial keyframe. This ensures
             * it snaps to the first keyframe when the animation starts.
             */ if (valueOffset[0] !== 0) {
                valueOffset.unshift(0);
                keyframes.unshift(keyframes[0]);
                valueEasing.unshift($24fcfc98546a9dbb$var$defaultSegmentEasing);
            }
            /**
             * If the last keyframe doesn't land on offset: 1
             * provide one with a null wildcard value. This will ensure it
             * stays static until the end of the animation.
             */ if (valueOffset[valueOffset.length - 1] !== 1) {
                valueOffset.push(1);
                keyframes.push(null);
            }
            if (!animationDefinitions.has(element)) animationDefinitions.set(element, {
                keyframes: {},
                transition: {}
            });
            var definition = animationDefinitions.get(element);
            definition.keyframes[key] = keyframes;
            /**
             * Exclude `type` from defaultTransition since springs have been
             * converted to duration-based easing functions in resolveValueSequence.
             * Including `type: "spring"` would cause JSAnimation to error when
             * the merged keyframes array has more than 2 keyframes.
             */ var _type = defaultTransition.type, remainingDefaultTransition = (0, $f7oRS._)(defaultTransition, [
                "type"
            ]);
            definition.transition[key] = (0, $81JKW._)((0, $bPuui._)((0, $81JKW._)({}, remainingDefaultTransition), {
                duration: totalDuration,
                ease: valueEasing,
                times: valueOffset
            }), sequenceTransition);
        }
    });
    return animationDefinitions;
}
function $24fcfc98546a9dbb$var$getSubjectSequence(subject, sequences) {
    !sequences.has(subject) && sequences.set(subject, {});
    return sequences.get(subject);
}
function $24fcfc98546a9dbb$var$getValueSequence(name, sequences) {
    if (!sequences[name]) sequences[name] = [];
    return sequences[name];
}
function $24fcfc98546a9dbb$var$keyframesAsList(keyframes) {
    return Array.isArray(keyframes) ? keyframes : [
        keyframes
    ];
}
function $24fcfc98546a9dbb$export$7c1391340308742e(transition, key) {
    return transition && transition[key] ? (0, $81JKW._)({}, transition, transition[key]) : (0, $81JKW._)({}, transition);
}
var $24fcfc98546a9dbb$var$isNumber = function(keyframe) {
    return typeof keyframe === "number";
};
var $24fcfc98546a9dbb$var$isNumberKeyframesArray = function(keyframes) {
    return keyframes.every($24fcfc98546a9dbb$var$isNumber);
};

});
parcelRegister("7X1wi", function(module, exports) {

$parcel$export(module.exports, "defaultOffset", function () { return $08feff132bf8b648$export$24dbcec0b26e6d9d; });

var $4fAA2 = parcelRequire("4fAA2");
function $08feff132bf8b648$export$24dbcec0b26e6d9d(arr) {
    var offset = [
        0
    ];
    (0, $4fAA2.fillOffset)(offset, arr.length - 1);
    return offset;
}

});
parcelRegister("4fAA2", function(module, exports) {

$parcel$export(module.exports, "fillOffset", function () { return $438a1c78af72f9b3$export$dafee61230cf05c6; });

var $jbUqp = parcelRequire("jbUqp");

var $h4uEU = parcelRequire("h4uEU");
function $438a1c78af72f9b3$export$dafee61230cf05c6(offset, remaining) {
    var min = offset[offset.length - 1];
    for(var i = 1; i <= remaining; i++){
        var offsetProgress = (0, $jbUqp.progress)(0, remaining, i);
        offset.push((0, $h4uEU.mixNumber)(min, 1, offsetProgress));
    }
}

});
parcelRegister("jbUqp", function(module, exports) {

$parcel$export(module.exports, "progress", function () { return $97e847dd211550bf$export$504d7abb21fa8c9; });
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.
*/ /*#__NO_SIDE_EFFECTS__*/ var $97e847dd211550bf$export$504d7abb21fa8c9 = function(from, to, value) {
    var range = to - from;
    return range ? (value - from) / range : 1;
};

});

parcelRegister("h4uEU", function(module, exports) {

$parcel$export(module.exports, "mixNumber", function () { return $184c268828324e7d$export$3bb0b4ff1037b8dd; });
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ var $184c268828324e7d$export$3bb0b4ff1037b8dd = function(from, to, progress) {
    return from + (to - from) * progress;
};

});



parcelRegister("8JGS8", function(module, exports) {

$parcel$export(module.exports, "isGenerator", function () { return $5844346dcae71868$export$6ab7812f1bac68be; });
function $5844346dcae71868$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

});

parcelRegister("ejle5", function(module, exports) {

$parcel$export(module.exports, "isMotionValue", function () { return $fdfd5c0582cc06fb$export$605d60a2578142d3; });
var $fdfd5c0582cc06fb$export$605d60a2578142d3 = function(value) {
    return Boolean(value && value.getVelocity);
};

});

parcelRegister("c9XlN", function(module, exports) {

$parcel$export(module.exports, "getEasingForSegment", function () { return $2f52373d73c0a1df$export$41c5e731255a462; });

var $6Y7FK = parcelRequire("6Y7FK");

var $f5mzy = parcelRequire("f5mzy");
/*#__NO_SIDE_EFFECTS__*/ function $2f52373d73c0a1df$export$41c5e731255a462(easing, i) {
    return (0, $f5mzy.isEasingArray)(easing) ? easing[(0, $6Y7FK.wrap)(0, easing.length, i)] : easing;
}

});
parcelRegister("6Y7FK", function(module, exports) {

$parcel$export(module.exports, "wrap", function () { return $594400d9f479f637$export$4997ffc0176396a6; });
var $594400d9f479f637$export$4997ffc0176396a6 = function(min, max, v) {
    var rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};

});

parcelRegister("f5mzy", function(module, exports) {

$parcel$export(module.exports, "isEasingArray", function () { return $3471119800808e33$export$216948827bbdc797; });
/*#__NO_SIDE_EFFECTS__*/ var $3471119800808e33$export$216948827bbdc797 = function(ease) {
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

});


parcelRegister("fUcOl", function(module, exports) {

$parcel$export(module.exports, "reverseEasing", function () { return $74e8e3117abe87a4$export$2c07eeff45156d4d; });
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
/*#__NO_SIDE_EFFECTS__*/ var $74e8e3117abe87a4$export$2c07eeff45156d4d = function(easing) {
    return function(p) {
        return 1 - easing(1 - p);
    };
};

});

parcelRegister("3htWe", function(module, exports) {

$parcel$export(module.exports, "resolveSubjects", function () { return $7dcf042f823d8222$export$92b2aefc56600400; });

var $lTYJk = parcelRequire("lTYJk");

var $1PMfB = parcelRequire("1PMfB");
function $7dcf042f823d8222$export$92b2aefc56600400(subject, keyframes, scope, selectorCache) {
    if (subject == null) return [];
    if (typeof subject === "string" && (0, $1PMfB.isDOMKeyframes)(keyframes)) return (0, $lTYJk.resolveElements)(subject, scope, selectorCache);
    else if (subject instanceof NodeList) return Array.from(subject);
    else if (Array.isArray(subject)) return subject.filter(function(s) {
        return s != null;
    });
    else return [
        subject
    ];
}

});
parcelRegister("lTYJk", function(module, exports) {

$parcel$export(module.exports, "resolveElements", function () { return $95c5f8e12fbe7f2f$export$90ceba2564a894f8; });
function $95c5f8e12fbe7f2f$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        var root = document;
        if (scope) root = scope.current;
        var _selectorCache_elementOrSelector;
        var elements = (_selectorCache_elementOrSelector = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _selectorCache_elementOrSelector !== void 0 ? _selectorCache_elementOrSelector : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter(function(element) {
        return element != null;
    });
}

});

parcelRegister("1PMfB", function(module, exports) {

$parcel$export(module.exports, "isDOMKeyframes", function () { return $131e2a2bfc80dbb3$export$d276bfce3b1077ca; });

var $cQSqJ = parcelRequire("cQSqJ");
function $131e2a2bfc80dbb3$export$d276bfce3b1077ca(keyframes) {
    return (typeof keyframes === "undefined" ? "undefined" : (0, $cQSqJ._)(keyframes)) === "object" && !Array.isArray(keyframes);
}

});


parcelRegister("dGdtN", function(module, exports) {

$parcel$export(module.exports, "calculateRepeatDuration", function () { return $bef18c6a7560216b$export$fcfa02e469c39006; });
function $bef18c6a7560216b$export$fcfa02e469c39006(duration, repeat, repeatDelay) {
    return duration * (repeat + 1) + repeatDelay * repeat;
}

});

parcelRegister("4wT2u", function(module, exports) {

$parcel$export(module.exports, "calcNextTime", function () { return $d97dac328f1d80e7$export$83ccd85155ba9791; });
/**
 * Given a absolute or relative time definition and current/prev time state of the sequence,
 * calculate an absolute time for the next keyframes.
 */ function $d97dac328f1d80e7$export$83ccd85155ba9791(current, next, prev, labels) {
    var _labels_get;
    if (typeof next === "number") return next;
    else if (next.startsWith("-") || next.startsWith("+")) return Math.max(0, current + parseFloat(next));
    else if (next === "<") return prev;
    else if (next.startsWith("<")) return Math.max(0, prev + parseFloat(next.slice(1)));
    else return (_labels_get = labels.get(next)) !== null && _labels_get !== void 0 ? _labels_get : current;
}

});

parcelRegister("3SltM", function(module, exports) {

$parcel$export(module.exports, "addKeyframes", function () { return $121fdb7aa3ce142b$export$89dfa6760a9f76e7; });

var $h4uEU = parcelRequire("h4uEU");

var $c9XlN = parcelRequire("c9XlN");
var $5HMvq = parcelRequire("5HMvq");
function $121fdb7aa3ce142b$export$6f93cdbb78924b88(sequence, startTime, endTime) {
    for(var i = 0; i < sequence.length; i++){
        var keyframe = sequence[i];
        if (keyframe.at > startTime && keyframe.at < endTime) {
            (0, $5HMvq.removeItem)(sequence, keyframe);
            // If we remove this item we have to push the pointer back one
            i--;
        }
    }
}
function $121fdb7aa3ce142b$export$89dfa6760a9f76e7(sequence, keyframes, easing, offset, startTime, endTime) {
    /**
     * Erase every existing value between currentTime and targetTime,
     * this will essentially splice this timeline into any currently
     * defined ones.
     */ $121fdb7aa3ce142b$export$6f93cdbb78924b88(sequence, startTime, endTime);
    for(var i = 0; i < keyframes.length; i++)sequence.push({
        value: keyframes[i],
        at: (0, $h4uEU.mixNumber)(startTime, endTime, offset[i]),
        easing: (0, $c9XlN.getEasingForSegment)(easing, i)
    });
}

});

parcelRegister("i2T9s", function(module, exports) {

$parcel$export(module.exports, "normalizeTimes", function () { return $7f60c250ff15a3d7$export$989461f373b2c60a; });
/**
 * Take an array of times that represent repeated keyframes. For instance
 * if we have original times of [0, 0.5, 1] then our repeated times will
 * be [0, 0.5, 1, 1, 1.5, 2]. Loop over the times and scale them back
 * down to a 0-1 scale.
 *
 * `repeatDelayUnits` is the repeatDelay expressed in units of a single
 * iteration's duration, so the total span equals `(repeat + 1) + repeat * repeatDelayUnits`.
 */ function $7f60c250ff15a3d7$export$989461f373b2c60a(times, repeat) {
    var repeatDelayUnits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var totalUnits = repeat + 1 + repeat * repeatDelayUnits;
    for(var i = 0; i < times.length; i++)times[i] = times[i] / totalUnits;
}

});

parcelRegister("hWniQ", function(module, exports) {

$parcel$export(module.exports, "compareByTime", function () { return $ac93173aae8846ff$export$66dd3fbf44e05bd9; });
function $ac93173aae8846ff$export$66dd3fbf44e05bd9(a, b) {
    if (a.at === b.at) {
        if (a.value === null) return 1;
        if (b.value === null) return -1;
        return 0;
    } else return a.at - b.at;
}

});


parcelRegister("kfMw2", function(module, exports) {

$parcel$export(module.exports, "animateSubject", function () { return $3d62878f3844fed0$export$7f91f5969506fd92; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $e6mbt = parcelRequire("e6mbt");

var $jaAQK = parcelRequire("jaAQK");
var $cBtac = parcelRequire("cBtac");
var $ejle5 = parcelRequire("ejle5");
var $aJc4O = parcelRequire("aJc4O");

var $boJRf = parcelRequire("boJRf");

var $hg8T5 = parcelRequire("hg8T5");

var $1PMfB = parcelRequire("1PMfB");

var $3htWe = parcelRequire("3htWe");
function $3d62878f3844fed0$var$isSingleValue(subject, keyframes) {
    return (0, $ejle5.isMotionValue)(subject) || typeof subject === "number" || typeof subject === "string" && !(0, $1PMfB.isDOMKeyframes)(keyframes);
}
/**
 * Implementation
 */ function $3d62878f3844fed0$export$7f91f5969506fd92(subject, keyframes, options, scope) {
    var animations = [];
    if ($3d62878f3844fed0$var$isSingleValue(subject, keyframes)) animations.push((0, $jaAQK.animateSingleValue)(subject, (0, $1PMfB.isDOMKeyframes)(keyframes) ? keyframes.default || keyframes : keyframes, options ? options.default || options : options));
    else {
        // Gracefully handle null/undefined subjects (e.g., from querySelector returning null)
        if (subject == null) return animations;
        var subjects = (0, $3htWe.resolveSubjects)(subject, keyframes, scope);
        var numSubjects = subjects.length;
        (0, $boJRf.invariant)(Boolean(numSubjects), "No valid elements provided.", "no-valid-elements");
        for(var i = 0; i < numSubjects; i++){
            var _animations;
            var thisSubject = subjects[i];
            var createVisualElement = thisSubject instanceof Element ? (0, $hg8T5.createDOMVisualElement) : (0, $hg8T5.createObjectVisualElement);
            if (!(0, $aJc4O.visualElementStore).has(thisSubject)) createVisualElement(thisSubject);
            var visualElement = (0, $aJc4O.visualElementStore).get(thisSubject);
            var transition = (0, $81JKW._)({}, options);
            /**
             * Resolve stagger function if provided.
             */ if ("delay" in transition && typeof transition.delay === "function") transition.delay = transition.delay(i, numSubjects);
            (_animations = animations).push.apply(_animations, (0, $e6mbt._)((0, $cBtac.animateTarget)(visualElement, (0, $bPuui._)((0, $81JKW._)({}, keyframes), {
                transition: transition
            }), {})));
        }
    }
    return animations;
}

});
parcelRegister("jaAQK", function(module, exports) {

$parcel$export(module.exports, "animateSingleValue", function () { return $b69ff7480964ca41$export$335a17c977067b99; });

var $b6c9i = parcelRequire("b6c9i");

var $4WU07 = parcelRequire("4WU07");

var $ejle5 = parcelRequire("ejle5");
function $b69ff7480964ca41$export$335a17c977067b99(value, keyframes, options) {
    var motionValue$1 = (0, $ejle5.isMotionValue)(value) ? value : (0, $4WU07.motionValue)(value);
    motionValue$1.start((0, $b6c9i.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

});
parcelRegister("b6c9i", function(module, exports) {

$parcel$export(module.exports, "animateMotionValue", function () { return $9bf2a6f8711c941f$export$90b3dfc33ff3548; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $jdEmz = parcelRequire("jdEmz");
var $cxm77 = parcelRequire("cxm77");

var $9F2HF = parcelRequire("9F2HF");

var $1bahE = parcelRequire("1bahE");

var $6sveo = parcelRequire("6sveo");

var $hgTOm = parcelRequire("hgTOm");

var $fB4yp = parcelRequire("fB4yp");

var $f9TVs = parcelRequire("f9TVs");

var $kz8da = parcelRequire("kz8da");

var $jQwB6 = parcelRequire("jQwB6");
var $9bf2a6f8711c941f$export$90b3dfc33ff3548 = function(name, value, target) {
    var transition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, element = arguments.length > 4 ? arguments[4] : void 0, isHandoff = arguments.length > 5 ? arguments[5] : void 0;
    return function(onComplete) {
        var valueTransition = (0, $6sveo.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ var delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ var _transition_elapsed = transition.elapsed, elapsed = _transition_elapsed === void 0 ? 0 : _transition_elapsed;
        elapsed = elapsed - (0, $cxm77.secondsToMilliseconds)(delay);
        var options = (0, $bPuui._)((0, $81JKW._)({
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity()
        }, valueTransition), {
            delay: -elapsed,
            onUpdate: function(v) {
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: function() {
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        });
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $kz8da.isTransitionDefined)(valueTransition)) Object.assign(options, (0, $fB4yp.getDefaultTransition)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $cxm77.secondsToMilliseconds)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $cxm77.secondsToMilliseconds)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        var shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $hgTOm.makeAnimationInstant)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $jdEmz.MotionGlobalConfig).instantAnimations || (0, $jdEmz.MotionGlobalConfig).skipAnimations || (element === null || element === void 0 ? void 0 : element.shouldSkipAnimations) || valueTransition.skipAnimations) {
            shouldSkip = true;
            (0, $hgTOm.makeAnimationInstant)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            var finalKeyframe = (0, $f9TVs.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $jQwB6.frame).update(function() {
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $1bahE.JSAnimation)(options) : new (0, $9F2HF.AsyncMotionValueAnimation)(options);
    };
};

});
parcelRegister("9F2HF", function(module, exports) {

$parcel$export(module.exports, "AsyncMotionValueAnimation", function () { return $c256f11db099f9f3$export$b9855e2a7dee3dd2; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $goUpr = parcelRequire("goUpr");

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $f7oRS = parcelRequire("f7oRS");

var $jdEmz = parcelRequire("jdEmz");
var $jXHGJ = parcelRequire("jXHGJ");

var $jEChV = parcelRequire("jEChV");

var $1bahE = parcelRequire("1bahE");

var $f9TVs = parcelRequire("f9TVs");

var $98YDC = parcelRequire("98YDC");

var $gav0r = parcelRequire("gav0r");

var $ibKsX = parcelRequire("ibKsX");

var $hgTOm = parcelRequire("hgTOm");

var $gKmrr = parcelRequire("gKmrr");

var $2rwoM = parcelRequire("2rwoM");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ var $c256f11db099f9f3$var$MAX_RESOLVE_DELAY = 40;
var $c256f11db099f9f3$export$b9855e2a7dee3dd2 = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, $goUpr._)(AsyncMotionValueAnimation, WithPromise);
    function AsyncMotionValueAnimation(_param) {
        (0, $6vyh9._)(this, AsyncMotionValueAnimation);
        var _this;
        var _param_autoplay = _param.autoplay, autoplay = _param_autoplay === void 0 ? true : _param_autoplay, _param_delay = _param.delay, delay = _param_delay === void 0 ? 0 : _param_delay, _param_type = _param.type, type = _param_type === void 0 ? "keyframes" : _param_type, _param_repeat = _param.repeat, repeat = _param_repeat === void 0 ? 0 : _param_repeat, _param_repeatDelay = _param.repeatDelay, repeatDelay = _param_repeatDelay === void 0 ? 0 : _param_repeatDelay, _param_repeatType = _param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType, keyframes = _param.keyframes, name = _param.name, motionValue = _param.motionValue, element = _param.element, options = (0, $f7oRS._)(_param, [
            "autoplay",
            "delay",
            "type",
            "repeat",
            "repeatDelay",
            "repeatType",
            "keyframes",
            "name",
            "motionValue",
            "element"
        ]);
        var _this_keyframeResolver;
        _this = (0, $enHBd._)(this, AsyncMotionValueAnimation);
        /**
         * Bound to support return animation.stop pattern
         */ _this.stop = function() {
            var _this_keyframeResolver;
            if (_this._animation) {
                var _this_stopTimeline, _this1;
                _this._animation.stop();
                (_this_stopTimeline = (_this1 = _this).stopTimeline) === null || _this_stopTimeline === void 0 ? void 0 : _this_stopTimeline.call(_this1);
            }
            (_this_keyframeResolver = _this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
        };
        _this.createdAt = (0, $jEChV.time).now();
        var optionsWithDefaults = (0, $81JKW._)({
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element
        }, options);
        var KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $98YDC.KeyframeResolver);
        _this.keyframeResolver = new KeyframeResolver$1(keyframes, function(resolvedKeyframes, finalKeyframe, forced) {
            return _this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced);
        }, name, motionValue, element);
        (_this_keyframeResolver = _this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.scheduleResolve();
        return _this;
    }
    (0, $l6JfT._)(AsyncMotionValueAnimation, [
        {
            key: "onKeyframesResolved",
            value: function onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
                var _this = this;
                var _resolvedOptions_motionValue_owner, _resolvedOptions_motionValue;
                this.keyframeResolver = undefined;
                var name = options.name, type = options.type, velocity = options.velocity, delay = options.delay, isHandoff = options.isHandoff, onUpdate = options.onUpdate;
                this.resolvedAt = (0, $jEChV.time).now();
                /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ var canAnimateValue = true;
                if (!(0, $ibKsX.canAnimate)(keyframes, name, type, velocity)) {
                    canAnimateValue = false;
                    if ((0, $jdEmz.MotionGlobalConfig).instantAnimations || !delay) onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate((0, $f9TVs.getFinalKeyframe)(keyframes, options, finalKeyframe));
                    keyframes[0] = keyframes[keyframes.length - 1];
                    (0, $hgTOm.makeAnimationInstant)(options);
                    options.repeat = 0;
                }
                /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ var startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $c256f11db099f9f3$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
                var resolvedOptions = (0, $bPuui._)((0, $81JKW._)({
                    startTime: startTime,
                    finalKeyframe: finalKeyframe
                }, options), {
                    keyframes: keyframes
                });
                /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ var useWaapi = canAnimateValue && !isHandoff && (0, $2rwoM.supportsBrowserAnimation)(resolvedOptions);
                var element = (_resolvedOptions_motionValue = resolvedOptions.motionValue) === null || _resolvedOptions_motionValue === void 0 ? void 0 : (_resolvedOptions_motionValue_owner = _resolvedOptions_motionValue.owner) === null || _resolvedOptions_motionValue_owner === void 0 ? void 0 : _resolvedOptions_motionValue_owner.current;
                var animation;
                if (useWaapi) try {
                    animation = new (0, $gav0r.NativeAnimationExtended)((0, $bPuui._)((0, $81JKW._)({}, resolvedOptions), {
                        element: element
                    }));
                } catch (e) {
                    animation = new (0, $1bahE.JSAnimation)(resolvedOptions);
                }
                else animation = new (0, $1bahE.JSAnimation)(resolvedOptions);
                animation.finished.then(function() {
                    _this.notifyFinished();
                }).catch((0, $jXHGJ.noop));
                if (this.pendingTimeline) {
                    this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
                    this.pendingTimeline = undefined;
                }
                this._animation = animation;
            }
        },
        {
            key: "finished",
            get: function get() {
                if (!this._animation) return this._finished;
                else return this.animation.finished;
            }
        },
        {
            key: "then",
            value: function then(onResolve, _onReject) {
                return this.finished.finally(onResolve).then(function() {});
            }
        },
        {
            key: "animation",
            get: function get() {
                if (!this._animation) {
                    var _this_keyframeResolver;
                    (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.resume();
                    (0, $98YDC.flushKeyframeResolvers)();
                }
                return this._animation;
            }
        },
        {
            key: "duration",
            get: function get() {
                return this.animation.duration;
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                return this.animation.iterationDuration;
            }
        },
        {
            key: "time",
            get: function get() {
                return this.animation.time;
            },
            set: function set(newTime) {
                this.animation.time = newTime;
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.animation.speed;
            },
            set: function set(newSpeed) {
                this.animation.speed = newSpeed;
            }
        },
        {
            key: "state",
            get: function get() {
                return this.animation.state;
            }
        },
        {
            key: "startTime",
            get: function get() {
                return this.animation.startTime;
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this = this;
                if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
                else this.pendingTimeline = timeline;
                return function() {
                    return _this.stop();
                };
            }
        },
        {
            key: "play",
            value: function play() {
                this.animation.play();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.animation.pause();
            }
        },
        {
            key: "complete",
            value: function complete() {
                this.animation.complete();
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this_keyframeResolver;
                if (this._animation) this.animation.cancel();
                (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
            }
        }
    ]);
    return AsyncMotionValueAnimation;
}((0, $gKmrr.WithPromise));

});
parcelRegister("1bahE", function(module, exports) {

$parcel$export(module.exports, "JSAnimation", function () { return $f52e9c3dd5cc2044$export$3394f837405475c7; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $goUpr = parcelRequire("goUpr");

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $e6mbt = parcelRequire("e6mbt");

var $21URL = parcelRequire("21URL");
var $cxm77 = parcelRequire("cxm77");
var $kdX6y = parcelRequire("kdX6y");

var $jEChV = parcelRequire("jEChV");

var $24ZQd = parcelRequire("24ZQd");

var $l2y1e = parcelRequire("l2y1e");

var $fJCyW = parcelRequire("fJCyW");

var $1qJmB = parcelRequire("1qJmB");

var $87iNH = parcelRequire("87iNH");

var $4UKlY = parcelRequire("4UKlY");

var $7DYJ1 = parcelRequire("7DYJ1");

var $f9TVs = parcelRequire("f9TVs");

var $1pwqd = parcelRequire("1pwqd");

var $gKmrr = parcelRequire("gKmrr");
var $f52e9c3dd5cc2044$var$percentToProgress = function(percent) {
    return percent / 100;
};
var $f52e9c3dd5cc2044$export$3394f837405475c7 = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, $goUpr._)(JSAnimation, WithPromise);
    function JSAnimation(options) {
        (0, $6vyh9._)(this, JSAnimation);
        var _this;
        _this = (0, $enHBd._)(this, JSAnimation);
        _this.state = "idle";
        _this.startTime = null;
        _this.isStopped = false;
        /**
         * The current time of the animation.
         */ _this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ _this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ _this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ _this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ _this.stop = function() {
            var _this_options_onStop, _this_options;
            var motionValue = _this.options.motionValue;
            if (motionValue && motionValue.updatedAt !== (0, $jEChV.time).now()) _this.tick((0, $jEChV.time).now());
            _this.isStopped = true;
            if (_this.state === "idle") return;
            _this.teardown();
            (_this_options_onStop = (_this_options = _this.options).onStop) === null || _this_options_onStop === void 0 ? void 0 : _this_options_onStop.call(_this_options);
        };
        (0, $24ZQd.activeAnimations).mainThread++;
        _this.options = options;
        _this.initAnimation();
        _this.play();
        if (options.autoplay === false) _this.pause();
        return _this;
    }
    (0, $l6JfT._)(JSAnimation, [
        {
            key: "initAnimation",
            value: function initAnimation() {
                var options = this.options;
                (0, $1pwqd.replaceTransitionType)(options);
                var _options_type = options.type, type = _options_type === void 0 ? (0, $87iNH.keyframes) : _options_type, _options_repeat = options.repeat, repeat = _options_repeat === void 0 ? 0 : _options_repeat, _options_repeatDelay = options.repeatDelay, repeatDelay = _options_repeatDelay === void 0 ? 0 : _options_repeatDelay, repeatType = options.repeatType, _options_velocity = options.velocity, velocity = _options_velocity === void 0 ? 0 : _options_velocity;
                var keyframes$1 = options.keyframes;
                var generatorFactory = type || (0, $87iNH.keyframes);
                if (generatorFactory !== (0, $87iNH.keyframes) && typeof keyframes$1[0] !== "number") {
                    this.mixKeyframes = (0, $kdX6y.pipe)($f52e9c3dd5cc2044$var$percentToProgress, (0, $l2y1e.mix)(keyframes$1[0], keyframes$1[1]));
                    keyframes$1 = [
                        0,
                        100
                    ];
                }
                var generator = generatorFactory((0, $bPuui._)((0, $81JKW._)({}, options), {
                    keyframes: keyframes$1
                }));
                /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory((0, $bPuui._)((0, $81JKW._)({}, options), {
                    keyframes: (0, $e6mbt._)(keyframes$1).reverse(),
                    velocity: -velocity
                }));
                /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $4UKlY.calcGeneratorDuration)(generator);
                var calculatedDuration = generator.calculatedDuration;
                this.calculatedDuration = calculatedDuration;
                this.resolvedDuration = calculatedDuration + repeatDelay;
                this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
                this.generator = generator;
            }
        },
        {
            key: "updateTime",
            value: function updateTime(timestamp) {
                var animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
                // Update currentTime
                if (this.holdTime !== null) this.currentTime = this.holdTime;
                else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
                // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
                // example.
                this.currentTime = animationTime;
            }
        },
        {
            key: "tick",
            value: function tick(timestamp) {
                var sample = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this, generator = _this.generator, totalDuration = _this.totalDuration, mixKeyframes = _this.mixKeyframes, mirroredGenerator = _this.mirroredGenerator, resolvedDuration = _this.resolvedDuration, calculatedDuration = _this.calculatedDuration;
                if (this.startTime === null) return generator.next(0);
                var _this_options = this.options, _this_options_delay = _this_options.delay, delay = _this_options_delay === void 0 ? 0 : _this_options_delay, keyframes = _this_options.keyframes, repeat = _this_options.repeat, repeatType = _this_options.repeatType, repeatDelay = _this_options.repeatDelay, type = _this_options.type, onUpdate = _this_options.onUpdate, finalKeyframe = _this_options.finalKeyframe;
                /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
                else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
                if (sample) this.currentTime = timestamp;
                else this.updateTime(timestamp);
                // Rebase on delay
                var timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
                var isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
                this.currentTime = Math.max(timeWithoutDelay, 0);
                // If this animation has finished, set the current time  to the total duration.
                if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
                var elapsed = this.currentTime;
                var frameGenerator = generator;
                if (repeat) {
                    /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ var progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
                    /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ var currentIteration = Math.floor(progress);
                    /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ var iterationProgress = progress % 1.0;
                    /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
                    iterationProgress === 1 && currentIteration--;
                    currentIteration = Math.min(currentIteration, repeat + 1);
                    /**
             * Reverse progress if we're not running in "normal" direction
             */ var isOddIteration = Boolean(currentIteration % 2);
                    if (isOddIteration) {
                        if (repeatType === "reverse") {
                            iterationProgress = 1 - iterationProgress;
                            if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                        } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
                    }
                    elapsed = (0, $21URL.clamp)(0, 1, iterationProgress) * resolvedDuration;
                }
                /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ var state;
                if (isInDelayPhase) {
                    this.delayState.value = keyframes[0];
                    state = this.delayState;
                } else state = frameGenerator.next(elapsed);
                if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
                var done = state.done;
                if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
                var isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
                // TODO: The exception for inertia could be cleaner here
                if (isAnimationFinished && type !== (0, $1qJmB.inertia)) state.value = (0, $f9TVs.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
                if (onUpdate) onUpdate(state.value);
                if (isAnimationFinished) this.finish();
                return state;
            }
        },
        {
            /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ key: "then",
            value: function then(resolve, reject) {
                return this.finished.then(resolve, reject);
            }
        },
        {
            key: "duration",
            get: function get() {
                return (0, $cxm77.millisecondsToSeconds)(this.calculatedDuration);
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                var _ref = this.options || {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay;
                return this.duration + (0, $cxm77.millisecondsToSeconds)(delay);
            }
        },
        {
            key: "time",
            get: function get() {
                return (0, $cxm77.millisecondsToSeconds)(this.currentTime);
            },
            set: function set(newTime) {
                newTime = (0, $cxm77.secondsToMilliseconds)(newTime);
                this.currentTime = newTime;
                if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
                else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
                if (this.driver) this.driver.start(false);
                else {
                    this.startTime = 0;
                    this.state = "paused";
                    this.holdTime = newTime;
                    this.tick(newTime);
                }
            }
        },
        {
            /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ key: "getGeneratorVelocity",
            value: function getGeneratorVelocity1() {
                var _this = this;
                var t = this.currentTime;
                if (t <= 0) return this.options.velocity || 0;
                if (this.generator.velocity) return this.generator.velocity(t);
                // Fallback: finite difference
                var current = this.generator.next(t).value;
                return (0, $7DYJ1.getGeneratorVelocity)(function(s) {
                    return _this.generator.next(s).value;
                }, t, current);
            }
        },
        {
            key: "speed",
            get: function get() {
                return this.playbackSpeed;
            },
            set: function set(newSpeed) {
                var hasChanged = this.playbackSpeed !== newSpeed;
                if (hasChanged && this.driver) this.updateTime((0, $jEChV.time).now());
                this.playbackSpeed = newSpeed;
                if (hasChanged && this.driver) this.time = (0, $cxm77.millisecondsToSeconds)(this.currentTime);
            }
        },
        {
            key: "play",
            value: function play() {
                var _this = this;
                var _this_options_onPlay, _this_options;
                if (this.isStopped) return;
                var _this_options1 = this.options, _this_options_driver = _this_options1.driver, driver = _this_options_driver === void 0 ? (0, $fJCyW.frameloopDriver) : _this_options_driver, startTime = _this_options1.startTime;
                if (!this.driver) this.driver = driver(function(timestamp) {
                    return _this.tick(timestamp);
                });
                (_this_options_onPlay = (_this_options = this.options).onPlay) === null || _this_options_onPlay === void 0 ? void 0 : _this_options_onPlay.call(_this_options);
                var now = this.driver.now();
                if (this.state === "finished") {
                    this.updateFinished();
                    this.startTime = now;
                } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
                else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : now;
                if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
                this.holdTime = null;
                /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
                this.driver.start();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.state = "paused";
                this.updateTime((0, $jEChV.time).now());
                this.holdTime = this.currentTime;
            }
        },
        {
            key: "complete",
            value: function complete() {
                if (this.state !== "running") this.play();
                this.state = "finished";
                this.holdTime = null;
            }
        },
        {
            key: "finish",
            value: function finish() {
                var _this_options_onComplete, _this_options;
                this.notifyFinished();
                this.teardown();
                this.state = "finished";
                (_this_options_onComplete = (_this_options = this.options).onComplete) === null || _this_options_onComplete === void 0 ? void 0 : _this_options_onComplete.call(_this_options);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this_options_onCancel, _this_options;
                this.holdTime = null;
                this.startTime = 0;
                this.tick(0);
                this.teardown();
                (_this_options_onCancel = (_this_options = this.options).onCancel) === null || _this_options_onCancel === void 0 ? void 0 : _this_options_onCancel.call(_this_options);
            }
        },
        {
            key: "teardown",
            value: function teardown() {
                this.state = "idle";
                this.stopDriver();
                this.startTime = this.holdTime = null;
                (0, $24ZQd.activeAnimations).mainThread--;
            }
        },
        {
            key: "stopDriver",
            value: function stopDriver() {
                if (!this.driver) return;
                this.driver.stop();
                this.driver = undefined;
            }
        },
        {
            key: "sample",
            value: function sample(sampleTime) {
                this.startTime = 0;
                return this.tick(sampleTime, true);
            }
        },
        {
            key: "attachTimeline",
            value: function attachTimeline(timeline) {
                var _this_driver;
                if (this.options.allowFlatten) {
                    this.options.type = "keyframes";
                    this.options.ease = "linear";
                    this.initAnimation();
                }
                (_this_driver = this.driver) === null || _this_driver === void 0 ? void 0 : _this_driver.stop();
                return timeline.observe(this);
            }
        }
    ]);
    return JSAnimation;
}((0, $gKmrr.WithPromise));
// Legacy function support
function $f52e9c3dd5cc2044$export$ee9b76de7353d815(options) {
    return new $f52e9c3dd5cc2044$export$3394f837405475c7(options);
}

});
parcelRegister("kdX6y", function(module, exports) {

$parcel$export(module.exports, "pipe", function () { return $6b779c5fca5b850a$export$a4627e546088548d; });
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ var $6b779c5fca5b850a$export$a4627e546088548d = function() {
    for(var _len = arguments.length, transformers = new Array(_len), _key = 0; _key < _len; _key++){
        transformers[_key] = arguments[_key];
    }
    return transformers.reduce(function(a, b) {
        return function(v) {
            return b(a(v));
        };
    });
};

});

parcelRegister("24ZQd", function(module, exports) {

$parcel$export(module.exports, "activeAnimations", function () { return $2690d6a8b14fac35$export$d921fb2475e2900c; });
var $2690d6a8b14fac35$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};

});

parcelRegister("l2y1e", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $d722f0dabbbe4717$export$2c9e8a9632a706b2; });

var $adKPC = parcelRequire("adKPC");

var $h4uEU = parcelRequire("h4uEU");
function $d722f0dabbbe4717$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $h4uEU.mixNumber)(from, to, p);
    var mixer = (0, $adKPC.getMixer)(from);
    return mixer(from, to);
}

});
parcelRegister("adKPC", function(module, exports) {

$parcel$export(module.exports, "getMixer", function () { return $e7a0937a4db0b740$export$36ec24672cd098e0; });

var $81JKW = parcelRequire("81JKW");

var $e6mbt = parcelRequire("e6mbt");

var $cQSqJ = parcelRequire("cQSqJ");

var $kdX6y = parcelRequire("kdX6y");
var $boJRf = parcelRequire("boJRf");

var $9ws7c = parcelRequire("9ws7c");

var $4bNpx = parcelRequire("4bNpx");

var $kBIio = parcelRequire("kBIio");

var $fzu2M = parcelRequire("fzu2M");

var $gOPYb = parcelRequire("gOPYb");

var $h4uEU = parcelRequire("h4uEU");

var $cqd3P = parcelRequire("cqd3P");
function $e7a0937a4db0b740$var$mixNumber(a, b) {
    return function(p) {
        return (0, $h4uEU.mixNumber)(a, b, p);
    };
}
function $e7a0937a4db0b740$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $e7a0937a4db0b740$var$mixNumber;
    else if (typeof a === "string") return (0, $9ws7c.isCSSVariableToken)(a) ? (0, $gOPYb.mixImmediate) : (0, $4bNpx.color).test(a) ? (0, $fzu2M.mixColor) : $e7a0937a4db0b740$export$65516310a87d8205;
    else if (Array.isArray(a)) return $e7a0937a4db0b740$export$3bbefa2f402845c4;
    else if ((typeof a === "undefined" ? "undefined" : (0, $cQSqJ._)(a)) === "object") return (0, $4bNpx.color).test(a) ? (0, $fzu2M.mixColor) : $e7a0937a4db0b740$export$ebc23b6840c51ba1;
    return 0, $gOPYb.mixImmediate;
}
function $e7a0937a4db0b740$export$3bbefa2f402845c4(a, b) {
    var output = (0, $e6mbt._)(a);
    var numValues = output.length;
    var blendValue = a.map(function(v, i) {
        return $e7a0937a4db0b740$export$36ec24672cd098e0(v)(v, b[i]);
    });
    return function(p) {
        for(var i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $e7a0937a4db0b740$export$ebc23b6840c51ba1(a, b) {
    var output = (0, $81JKW._)({}, a, b);
    var blendValue = {};
    for(var key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $e7a0937a4db0b740$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return function(v) {
        for(var key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $e7a0937a4db0b740$var$matchOrder(origin, target) {
    var orderedOrigin = [];
    var pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(var i = 0; i < target.values.length; i++){
        var type = target.types[i];
        var originIndex = origin.indexes[type][pointers[type]];
        var _origin_values_originIndex;
        var originValue = (_origin_values_originIndex = origin.values[originIndex]) !== null && _origin_values_originIndex !== void 0 ? _origin_values_originIndex : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
var $e7a0937a4db0b740$export$65516310a87d8205 = function(origin, target) {
    var template = (0, $kBIio.complex).createTransformer(target);
    var originStats = (0, $kBIio.analyseComplexValue)(origin);
    var targetStats = (0, $kBIio.analyseComplexValue)(target);
    var canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $cqd3P.invisibleValues).has(origin) && !targetStats.values.length || (0, $cqd3P.invisibleValues).has(target) && !originStats.values.length) return (0, $cqd3P.mixVisibility)(origin, target);
        return (0, $kdX6y.pipe)($e7a0937a4db0b740$export$3bbefa2f402845c4($e7a0937a4db0b740$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $boJRf.warning)(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."), "complex-values-different");
        return (0, $gOPYb.mixImmediate)(origin, target);
    }
};

});
parcelRegister("9ws7c", function(module, exports) {

$parcel$export(module.exports, "isCSSVariableName", function () { return $db704ac1d31b3d35$export$9de1236619d9e756; });
$parcel$export(module.exports, "isCSSVariableToken", function () { return $db704ac1d31b3d35$export$31f9caa2600b5723; });
$parcel$export(module.exports, "containsCSSVariable", function () { return $db704ac1d31b3d35$export$df8f90ab5d0b05fa; });
var $db704ac1d31b3d35$var$checkStringStartsWith = function(token) {
    return function(key) {
        return typeof key === "string" && key.startsWith(token);
    };
};
var $db704ac1d31b3d35$export$9de1236619d9e756 = /*@__PURE__*/ $db704ac1d31b3d35$var$checkStringStartsWith("--");
var $db704ac1d31b3d35$var$startsAsVariableToken = /*@__PURE__*/ $db704ac1d31b3d35$var$checkStringStartsWith("var(--");
var $db704ac1d31b3d35$export$31f9caa2600b5723 = function(value) {
    var startsWithToken = $db704ac1d31b3d35$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $db704ac1d31b3d35$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
var $db704ac1d31b3d35$var$singleCssVariableRegex = RegExp("var\\(--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)$", "iu");
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function $db704ac1d31b3d35$export$df8f90ab5d0b05fa(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}

});

parcelRegister("4bNpx", function(module, exports) {

$parcel$export(module.exports, "color", function () { return $164d2f2f4d2fd3d7$export$35e9368ef982300f; });

var $hgB25 = parcelRequire("hgB25");

var $cE6QS = parcelRequire("cE6QS");

var $2llB1 = parcelRequire("2llB1");
var $164d2f2f4d2fd3d7$export$35e9368ef982300f = {
    test: function(v) {
        return (0, $2llB1.rgba).test(v) || (0, $hgB25.hex).test(v) || (0, $cE6QS.hsla).test(v);
    },
    parse: function(v) {
        if ((0, $2llB1.rgba).test(v)) return (0, $2llB1.rgba).parse(v);
        else if ((0, $cE6QS.hsla).test(v)) return (0, $cE6QS.hsla).parse(v);
        else return (0, $hgB25.hex).parse(v);
    },
    transform: function(v) {
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $2llB1.rgba).transform(v) : (0, $cE6QS.hsla).transform(v);
    },
    getAnimatableNone: function(v) {
        var parsed = $164d2f2f4d2fd3d7$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $164d2f2f4d2fd3d7$export$35e9368ef982300f.transform(parsed);
    }
};

});
parcelRegister("hgB25", function(module, exports) {

$parcel$export(module.exports, "hex", function () { return $ea6bc222d5443c79$export$834dfc94dde4b3d8; });

var $2llB1 = parcelRequire("2llB1");

var $eJZzx = parcelRequire("eJZzx");
function $ea6bc222d5443c79$var$parseHex(v) {
    var r = "";
    var g = "";
    var b = "";
    var a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
var $ea6bc222d5443c79$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $eJZzx.isColorString)("#"),
    parse: $ea6bc222d5443c79$var$parseHex,
    transform: (0, $2llB1.rgba).transform
};

});
parcelRegister("2llB1", function(module, exports) {

$parcel$export(module.exports, "rgba", function () { return $a44f1a785eca229d$export$4e46ac54fc82cf3b; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $21URL = parcelRequire("21URL");

var $lNDSs = parcelRequire("lNDSs");

var $eiTtB = parcelRequire("eiTtB");

var $eJZzx = parcelRequire("eJZzx");
var $a44f1a785eca229d$var$clampRgbUnit = function(v) {
    return (0, $21URL.clamp)(0, 255, v);
};
var $a44f1a785eca229d$export$7a99c86b5b1f4c9e = (0, $bPuui._)((0, $81JKW._)({}, (0, $lNDSs.number)), {
    transform: function(v) {
        return Math.round($a44f1a785eca229d$var$clampRgbUnit(v));
    }
});
var $a44f1a785eca229d$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $eJZzx.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $eJZzx.splitColor)("red", "green", "blue"),
    transform: function(param) {
        var red = param.red, green = param.green, blue = param.blue, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "rgba(" + $a44f1a785eca229d$export$7a99c86b5b1f4c9e.transform(red) + ", " + $a44f1a785eca229d$export$7a99c86b5b1f4c9e.transform(green) + ", " + $a44f1a785eca229d$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $eiTtB.sanitize)((0, $lNDSs.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("lNDSs", function(module, exports) {

$parcel$export(module.exports, "number", function () { return $116ef7f5864bd043$export$98e628dec113755e; });
$parcel$export(module.exports, "alpha", function () { return $116ef7f5864bd043$export$58f0f39f63f3cf42; });
$parcel$export(module.exports, "scale", function () { return $116ef7f5864bd043$export$dcdf75081b88279d; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $21URL = parcelRequire("21URL");
var $116ef7f5864bd043$export$98e628dec113755e = {
    test: function(v) {
        return typeof v === "number";
    },
    parse: parseFloat,
    transform: function(v) {
        return v;
    }
};
var $116ef7f5864bd043$export$58f0f39f63f3cf42 = (0, $bPuui._)((0, $81JKW._)({}, $116ef7f5864bd043$export$98e628dec113755e), {
    transform: function(v) {
        return (0, $21URL.clamp)(0, 1, v);
    }
});
var $116ef7f5864bd043$export$dcdf75081b88279d = (0, $bPuui._)((0, $81JKW._)({}, $116ef7f5864bd043$export$98e628dec113755e), {
    default: 1
});

});

parcelRegister("eiTtB", function(module, exports) {

$parcel$export(module.exports, "sanitize", function () { return $2dd7e600dd475ca4$export$83d2e9e3e4ee39ed; });
// If this number is a decimal, make it just five decimal places
// to avoid exponents
var $2dd7e600dd475ca4$export$83d2e9e3e4ee39ed = function(v) {
    return Math.round(v * 100000) / 100000;
};

});

parcelRegister("eJZzx", function(module, exports) {

$parcel$export(module.exports, "isColorString", function () { return $298522a7e7cad324$export$2c8400d58aca05e; });
$parcel$export(module.exports, "splitColor", function () { return $298522a7e7cad324$export$73d6f35be992df24; });

var $inKFz = parcelRequire("inKFz");

var $3GNpW = parcelRequire("3GNpW");

var $5mNJo = parcelRequire("5mNJo");

var $exwd6 = parcelRequire("exwd6");

var $5qbVu = parcelRequire("5qbVu");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ var $298522a7e7cad324$export$2c8400d58aca05e = function(type, testProp) {
    return function(v) {
        return Boolean(typeof v === "string" && (0, $5qbVu.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, $exwd6.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
};
var $298522a7e7cad324$export$73d6f35be992df24 = function(aName, bName, cName) {
    return function(v) {
        if (typeof v !== "string") return v;
        var _v_match = (0, $3GNpW._)(v.match((0, $5mNJo.floatRegex)), 4), a = _v_match[0], b = _v_match[1], c = _v_match[2], alpha = _v_match[3];
        var _obj;
        return _obj = {}, (0, $inKFz._)(_obj, aName, parseFloat(a)), (0, $inKFz._)(_obj, bName, parseFloat(b)), (0, $inKFz._)(_obj, cName, parseFloat(c)), (0, $inKFz._)(_obj, "alpha", alpha !== undefined ? parseFloat(alpha) : 1), _obj;
    };
};

});
parcelRegister("5mNJo", function(module, exports) {

$parcel$export(module.exports, "floatRegex", function () { return $2914d8c46cc1d12e$export$2444ca58c08448e4; });
var $2914d8c46cc1d12e$export$2444ca58c08448e4 = RegExp("-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "gu");

});

parcelRegister("exwd6", function(module, exports) {

$parcel$export(module.exports, "isNullish", function () { return $869f135f8fa3b02a$export$b931b78cbb3caf86; });
function $869f135f8fa3b02a$export$b931b78cbb3caf86(v) {
    return v == null;
}

});

parcelRegister("5qbVu", function(module, exports) {

$parcel$export(module.exports, "singleColorRegex", function () { return $b1622c4b484cfd77$export$ed808ff6ecd39e8d; });
var $b1622c4b484cfd77$export$ed808ff6ecd39e8d = RegExp("^(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))$", "iu");

});




parcelRegister("cE6QS", function(module, exports) {

$parcel$export(module.exports, "hsla", function () { return $d81b5aead7905742$export$810b04175080204c; });

var $lNDSs = parcelRequire("lNDSs");

var $lAqg3 = parcelRequire("lAqg3");

var $eiTtB = parcelRequire("eiTtB");

var $eJZzx = parcelRequire("eJZzx");
var $d81b5aead7905742$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $eJZzx.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $eJZzx.splitColor)("hue", "saturation", "lightness"),
    transform: function(param) {
        var hue = param.hue, saturation = param.saturation, lightness = param.lightness, tmp = param.alpha, alpha$1 = tmp === void 0 ? 1 : tmp;
        return "hsla(" + Math.round(hue) + ", " + (0, $lAqg3.percent).transform((0, $eiTtB.sanitize)(saturation)) + ", " + (0, $lAqg3.percent).transform((0, $eiTtB.sanitize)(lightness)) + ", " + (0, $eiTtB.sanitize)((0, $lNDSs.alpha).transform(alpha$1)) + ")";
    }
};

});
parcelRegister("lAqg3", function(module, exports) {

$parcel$export(module.exports, "degrees", function () { return $e0493343c1749b54$export$41fc368e1a942b97; });
$parcel$export(module.exports, "percent", function () { return $e0493343c1749b54$export$626336c2cd4b14de; });
$parcel$export(module.exports, "px", function () { return $e0493343c1749b54$export$91c0eda1d06bf008; });
$parcel$export(module.exports, "vh", function () { return $e0493343c1749b54$export$f91e8c45a95a32f2; });
$parcel$export(module.exports, "vw", function () { return $e0493343c1749b54$export$aed3d7b7d206c196; });
$parcel$export(module.exports, "progressPercentage", function () { return $e0493343c1749b54$export$44e2e1705876d7ed; });
/*#__NO_SIDE_EFFECTS__*/ 
var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");
var $e0493343c1749b54$var$createUnitType = function(unit) {
    return {
        test: function(v) {
            return typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1;
        },
        parse: parseFloat,
        transform: function(v) {
            return "".concat(v).concat(unit);
        }
    };
};
var $e0493343c1749b54$export$41fc368e1a942b97 = /*@__PURE__*/ $e0493343c1749b54$var$createUnitType("deg");
var $e0493343c1749b54$export$626336c2cd4b14de = /*@__PURE__*/ $e0493343c1749b54$var$createUnitType("%");
var $e0493343c1749b54$export$91c0eda1d06bf008 = /*@__PURE__*/ $e0493343c1749b54$var$createUnitType("px");
var $e0493343c1749b54$export$f91e8c45a95a32f2 = /*@__PURE__*/ $e0493343c1749b54$var$createUnitType("vh");
var $e0493343c1749b54$export$aed3d7b7d206c196 = /*@__PURE__*/ $e0493343c1749b54$var$createUnitType("vw");
var $e0493343c1749b54$export$44e2e1705876d7ed = /*@__PURE__*/ function() {
    return (0, $bPuui._)((0, $81JKW._)({}, $e0493343c1749b54$export$626336c2cd4b14de), {
        parse: function(v) {
            return $e0493343c1749b54$export$626336c2cd4b14de.parse(v) / 100;
        },
        transform: function(v) {
            return $e0493343c1749b54$export$626336c2cd4b14de.transform(v * 100);
        }
    });
}();

});



parcelRegister("kBIio", function(module, exports) {

$parcel$export(module.exports, "analyseComplexValue", function () { return $92f560cc183e6798$export$b61fc7c44bf646d5; });
$parcel$export(module.exports, "complex", function () { return $92f560cc183e6798$export$83a0e34f1302825b; });

var $4bNpx = parcelRequire("4bNpx");

var $kRhh4 = parcelRequire("kRhh4");

var $5mNJo = parcelRequire("5mNJo");

var $eiTtB = parcelRequire("eiTtB");
function $92f560cc183e6798$var$test(v) {
    var _v_match, _v_match1;
    return isNaN(v) && typeof v === "string" && (((_v_match = v.match((0, $5mNJo.floatRegex))) === null || _v_match === void 0 ? void 0 : _v_match.length) || 0) + (((_v_match1 = v.match((0, $kRhh4.colorRegex))) === null || _v_match1 === void 0 ? void 0 : _v_match1.length) || 0) > 0;
}
var $92f560cc183e6798$var$NUMBER_TOKEN = "number";
var $92f560cc183e6798$var$COLOR_TOKEN = "color";
var $92f560cc183e6798$var$VAR_TOKEN = "var";
var $92f560cc183e6798$var$VAR_FUNCTION_TOKEN = "var(";
var $92f560cc183e6798$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
var $92f560cc183e6798$var$complexRegex = RegExp("var\\s*\\(\\s*--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)|#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\)|-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "giu");
function $92f560cc183e6798$export$b61fc7c44bf646d5(value) {
    var originalValue = value.toString();
    var values = [];
    var indexes = {
        color: [],
        number: [],
        var: []
    };
    var types = [];
    var i = 0;
    var tokenised = originalValue.replace($92f560cc183e6798$var$complexRegex, function(parsedValue) {
        if ((0, $4bNpx.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push($92f560cc183e6798$var$COLOR_TOKEN);
            values.push((0, $4bNpx.color).parse(parsedValue));
        } else if (parsedValue.startsWith($92f560cc183e6798$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($92f560cc183e6798$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($92f560cc183e6798$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $92f560cc183e6798$var$SPLIT_TOKEN;
    });
    var split = tokenised.split($92f560cc183e6798$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $92f560cc183e6798$var$parseComplexValue(v) {
    return $92f560cc183e6798$export$b61fc7c44bf646d5(v).values;
}
function $92f560cc183e6798$var$buildTransformer(param) {
    var split = param.split, types = param.types;
    var numSections = split.length;
    return function(v) {
        var output = "";
        for(var i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                var type = types[i];
                if (type === $92f560cc183e6798$var$NUMBER_TOKEN) output += (0, $eiTtB.sanitize)(v[i]);
                else if (type === $92f560cc183e6798$var$COLOR_TOKEN) output += (0, $4bNpx.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function $92f560cc183e6798$var$createTransformer(source) {
    return $92f560cc183e6798$var$buildTransformer($92f560cc183e6798$export$b61fc7c44bf646d5(source));
}
var $92f560cc183e6798$var$convertNumbersToZero = function(v) {
    return typeof v === "number" ? 0 : (0, $4bNpx.color).test(v) ? (0, $4bNpx.color).getAnimatableNone(v) : v;
};
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ var $92f560cc183e6798$var$convertToZero = function(value, splitBefore) {
    if (typeof value === "number") return (splitBefore === null || splitBefore === void 0 ? void 0 : splitBefore.trim().endsWith("/")) ? value : 0;
    return $92f560cc183e6798$var$convertNumbersToZero(value);
};
function $92f560cc183e6798$var$getAnimatableNone(v) {
    var info = $92f560cc183e6798$export$b61fc7c44bf646d5(v);
    var transformer = $92f560cc183e6798$var$buildTransformer(info);
    return transformer(info.values.map(function(value, i) {
        return $92f560cc183e6798$var$convertToZero(value, info.split[i]);
    }));
}
var $92f560cc183e6798$export$83a0e34f1302825b = {
    test: $92f560cc183e6798$var$test,
    parse: $92f560cc183e6798$var$parseComplexValue,
    createTransformer: $92f560cc183e6798$var$createTransformer,
    getAnimatableNone: $92f560cc183e6798$var$getAnimatableNone
};

});
parcelRegister("kRhh4", function(module, exports) {

$parcel$export(module.exports, "colorRegex", function () { return $78d717d58770831d$export$740b69c5fad25dba; });
var $78d717d58770831d$export$740b69c5fad25dba = RegExp("(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))", "giu");

});


parcelRegister("fzu2M", function(module, exports) {

$parcel$export(module.exports, "mixColor", function () { return $3388b97ce7f6e3ea$export$51e568cf5c039bac; });

var $81JKW = parcelRequire("81JKW");

var $boJRf = parcelRequire("boJRf");

var $hgB25 = parcelRequire("hgB25");

var $cE6QS = parcelRequire("cE6QS");

var $4uu9q = parcelRequire("4uu9q");

var $2llB1 = parcelRequire("2llB1");

var $gOPYb = parcelRequire("gOPYb");

var $h4uEU = parcelRequire("h4uEU");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
var $3388b97ce7f6e3ea$export$d4ecea248cce73c = function(from, to, v) {
    var fromExpo = from * from;
    var expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
var $3388b97ce7f6e3ea$var$colorTypes = [
    (0, $hgB25.hex),
    (0, $2llB1.rgba),
    (0, $cE6QS.hsla)
];
var $3388b97ce7f6e3ea$var$getColorType = function(v) {
    return $3388b97ce7f6e3ea$var$colorTypes.find(function(type) {
        return type.test(v);
    });
};
function $3388b97ce7f6e3ea$var$asRGBA(color) {
    var type = $3388b97ce7f6e3ea$var$getColorType(color);
    (0, $boJRf.warning)(Boolean(type), "'".concat(color, "' is not an animatable color. Use the equivalent color code instead."), "color-not-animatable");
    if (!Boolean(type)) return false;
    var model = type.parse(color);
    if (type === (0, $cE6QS.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $4uu9q.hslaToRgba)(model);
    return model;
}
var $3388b97ce7f6e3ea$export$51e568cf5c039bac = function(from, to) {
    var fromRGBA = $3388b97ce7f6e3ea$var$asRGBA(from);
    var toRGBA = $3388b97ce7f6e3ea$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $gOPYb.mixImmediate)(from, to);
    var blended = (0, $81JKW._)({}, fromRGBA);
    return function(v) {
        blended.red = $3388b97ce7f6e3ea$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $3388b97ce7f6e3ea$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $3388b97ce7f6e3ea$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $h4uEU.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $2llB1.rgba).transform(blended);
    };
};

});
parcelRegister("4uu9q", function(module, exports) {

$parcel$export(module.exports, "hslaToRgba", function () { return $1c65aa39d9d7ab9f$export$6ae64dbcd6bfc33e; });
// Adapted from https://gist.github.com/mjackson/5311256
function $1c65aa39d9d7ab9f$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $1c65aa39d9d7ab9f$export$6ae64dbcd6bfc33e(param) {
    var hue = param.hue, saturation = param.saturation, lightness = param.lightness, alpha = param.alpha;
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    var red = 0;
    var green = 0;
    var blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        var q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        var p = 2 * lightness - q;
        red = $1c65aa39d9d7ab9f$var$hueToRgb(p, q, hue + 1 / 3);
        green = $1c65aa39d9d7ab9f$var$hueToRgb(p, q, hue);
        blue = $1c65aa39d9d7ab9f$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}

});

parcelRegister("gOPYb", function(module, exports) {

$parcel$export(module.exports, "mixImmediate", function () { return $26b2e96248d98ed0$export$a6f92d4bae65c0f1; });
function $26b2e96248d98ed0$export$a6f92d4bae65c0f1(a, b) {
    return function(p) {
        return p > 0 ? b : a;
    };
}

});


parcelRegister("cqd3P", function(module, exports) {

$parcel$export(module.exports, "invisibleValues", function () { return $7a13c36b8f29fadd$export$e5a55ae567dd4ac7; });
$parcel$export(module.exports, "mixVisibility", function () { return $7a13c36b8f29fadd$export$fed62ccc3fb1a568; });
var $7a13c36b8f29fadd$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $7a13c36b8f29fadd$export$fed62ccc3fb1a568(origin, target) {
    if ($7a13c36b8f29fadd$export$e5a55ae567dd4ac7.has(origin)) return function(p) {
        return p <= 0 ? origin : target;
    };
    else return function(p) {
        return p >= 1 ? target : origin;
    };
}

});



parcelRegister("fJCyW", function(module, exports) {

$parcel$export(module.exports, "frameloopDriver", function () { return $1479646af64376d3$export$c1033964b5ad7fef; });

var $jEChV = parcelRequire("jEChV");

var $jQwB6 = parcelRequire("jQwB6");
var $1479646af64376d3$export$c1033964b5ad7fef = function(update) {
    var passTimestamp = function(param) {
        var timestamp = param.timestamp;
        return update(timestamp);
    };
    return {
        start: function() {
            var keepAlive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            return (0, $jQwB6.frame).update(passTimestamp, keepAlive);
        },
        stop: function() {
            return (0, $jQwB6.cancelFrame)(passTimestamp);
        },
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: function() {
            return (0, $jQwB6.frameData).isProcessing ? (0, $jQwB6.frameData).timestamp : (0, $jEChV.time).now();
        }
    };
};

});

parcelRegister("1qJmB", function(module, exports) {

$parcel$export(module.exports, "inertia", function () { return $9349e461d35adbed$export$ee3ff3a17106998; });

var $8T39o = parcelRequire("8T39o");

var $7DYJ1 = parcelRequire("7DYJ1");
function $9349e461d35adbed$export$ee3ff3a17106998(param) {
    var keyframes = param.keyframes, _param_velocity = param.velocity, velocity = _param_velocity === void 0 ? 0.0 : _param_velocity, _param_power = param.power, power = _param_power === void 0 ? 0.8 : _param_power, _param_timeConstant = param.timeConstant, timeConstant = _param_timeConstant === void 0 ? 325 : _param_timeConstant, _param_bounceDamping = param.bounceDamping, bounceDamping = _param_bounceDamping === void 0 ? 10 : _param_bounceDamping, _param_bounceStiffness = param.bounceStiffness, bounceStiffness = _param_bounceStiffness === void 0 ? 500 : _param_bounceStiffness, modifyTarget = param.modifyTarget, min = param.min, max = param.max, _param_restDelta = param.restDelta, restDelta = _param_restDelta === void 0 ? 0.5 : _param_restDelta, restSpeed = param.restSpeed;
    var origin = keyframes[0];
    var state = {
        done: false,
        value: origin
    };
    var isOutOfBounds = function(v) {
        return min !== undefined && v < min || max !== undefined && v > max;
    };
    var nearestBoundary = function(v) {
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    var amplitude = power * velocity;
    var ideal = origin + amplitude;
    var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    var calcDelta = function(t) {
        return -amplitude * Math.exp(-t / timeConstant);
    };
    var calcLatest = function(t) {
        return target + calcDelta(t);
    };
    var applyFriction = function(t) {
        var delta = calcDelta(t);
        var latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ var timeReachedBoundary;
    var spring$1;
    var checkCatchBoundary = function(t) {
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $8T39o.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $7DYJ1.getGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: function(t) {
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ var hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

});
parcelRegister("7DYJ1", function(module, exports) {

$parcel$export(module.exports, "getGeneratorVelocity", function () { return $aa41c7954c7ced80$export$279c5e002bb29070; });

var $iky9o = parcelRequire("iky9o");
var $aa41c7954c7ced80$var$velocitySampleDuration = 5; // ms
function $aa41c7954c7ced80$export$279c5e002bb29070(resolveValue, t, current) {
    var prevT = Math.max(t - $aa41c7954c7ced80$var$velocitySampleDuration, 0);
    return (0, $iky9o.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

});


parcelRegister("87iNH", function(module, exports) {

$parcel$export(module.exports, "keyframes", function () { return $00bdefbddfe933e9$export$d25ddfdf17c3ad3e; });

var $3IrVH = parcelRequire("3IrVH");
var $NCinx = parcelRequire("NCinx");
var $f5mzy = parcelRequire("f5mzy");

var $5xzo6 = parcelRequire("5xzo6");

var $7X1wi = parcelRequire("7X1wi");

var $b5Lwc = parcelRequire("b5Lwc");
function $00bdefbddfe933e9$export$6b60b58e4ea7d715(values, easing) {
    return values.map(function() {
        return easing || (0, $3IrVH.easeInOut);
    }).splice(0, values.length - 1);
}
function $00bdefbddfe933e9$export$d25ddfdf17c3ad3e(param) {
    var _param_duration = param.duration, duration = _param_duration === void 0 ? 300 : _param_duration, keyframeValues = param.keyframes, times = param.times, _param_ease = param.ease, ease = _param_ease === void 0 ? "easeInOut" : _param_ease;
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ var easingFunctions = (0, $f5mzy.isEasingArray)(ease) ? ease.map((0, $NCinx.easingDefinitionToFunction)) : (0, $NCinx.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ var state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ var absoluteTimes = (0, $b5Lwc.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $7X1wi.defaultOffset)(keyframeValues), duration);
    var mapTimeToKeyframe = (0, $5xzo6.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $00bdefbddfe933e9$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: function(t) {
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

});
parcelRegister("3IrVH", function(module, exports) {

$parcel$export(module.exports, "easeIn", function () { return $0372bd2e61c57f2c$export$929e5a82286172a6; });
$parcel$export(module.exports, "easeOut", function () { return $0372bd2e61c57f2c$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeInOut", function () { return $0372bd2e61c57f2c$export$c07234257a03d5e9; });

var $4Fem2 = parcelRequire("4Fem2");
var $0372bd2e61c57f2c$export$929e5a82286172a6 = /*@__PURE__*/ (0, $4Fem2.cubicBezier)(0.42, 0, 1, 1);
var $0372bd2e61c57f2c$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $4Fem2.cubicBezier)(0, 0, 0.58, 1);
var $0372bd2e61c57f2c$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $4Fem2.cubicBezier)(0.42, 0, 0.58, 1);

});
parcelRegister("4Fem2", function(module, exports) {

$parcel$export(module.exports, "cubicBezier", function () { return $ae292eae32a7443f$export$2c575fa1d20488bd; });

var $jXHGJ = parcelRequire("jXHGJ");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
var $ae292eae32a7443f$var$calcBezier = function(t, a1, a2) {
    return (((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
};
var $ae292eae32a7443f$var$subdivisionPrecision = 0.0000001;
var $ae292eae32a7443f$var$subdivisionMaxIterations = 12;
function $ae292eae32a7443f$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $ae292eae32a7443f$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $ae292eae32a7443f$var$subdivisionPrecision && ++i < $ae292eae32a7443f$var$subdivisionMaxIterations);
    return currentT;
}
/*#__NO_SIDE_EFFECTS__*/ function $ae292eae32a7443f$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $jXHGJ.noop;
    var getTForX = function(aX) {
        return $ae292eae32a7443f$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    };
    // If animation is at start/end, return t without easing
    return function(t) {
        return t === 0 || t === 1 ? t : $ae292eae32a7443f$var$calcBezier(getTForX(t), mY1, mY2);
    };
}

});


parcelRegister("NCinx", function(module, exports) {

$parcel$export(module.exports, "easingDefinitionToFunction", function () { return $0497c612ca6a9e91$export$ef97fe084f156ca4; });

var $3GNpW = parcelRequire("3GNpW");

var $boJRf = parcelRequire("boJRf");

var $jXHGJ = parcelRequire("jXHGJ");

var $6lSAG = parcelRequire("6lSAG");

var $5Ltsj = parcelRequire("5Ltsj");

var $hWytO = parcelRequire("hWytO");

var $4Fem2 = parcelRequire("4Fem2");

var $3IrVH = parcelRequire("3IrVH");

var $aK7lc = parcelRequire("aK7lc");
var $0497c612ca6a9e91$var$easingLookup = {
    linear: (0, $jXHGJ.noop),
    easeIn: (0, $3IrVH.easeIn),
    easeInOut: (0, $3IrVH.easeInOut),
    easeOut: (0, $3IrVH.easeOut),
    circIn: (0, $hWytO.circIn),
    circInOut: (0, $hWytO.circInOut),
    circOut: (0, $hWytO.circOut),
    backIn: (0, $5Ltsj.backIn),
    backInOut: (0, $5Ltsj.backInOut),
    backOut: (0, $5Ltsj.backOut),
    anticipate: (0, $6lSAG.anticipate)
};
var $0497c612ca6a9e91$var$isValidEasing = function(easing) {
    return typeof easing === "string";
};
var $0497c612ca6a9e91$export$ef97fe084f156ca4 = function(definition) {
    if ((0, $aK7lc.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $boJRf.invariant)(definition.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
        var _definition = (0, $3GNpW._)(definition, 4), x1 = _definition[0], y1 = _definition[1], x2 = _definition[2], y2 = _definition[3];
        return (0, $4Fem2.cubicBezier)(x1, y1, x2, y2);
    } else if ($0497c612ca6a9e91$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $boJRf.invariant)($0497c612ca6a9e91$var$easingLookup[definition] !== undefined, "Invalid easing type '".concat(definition, "'"), "invalid-easing-type");
        return $0497c612ca6a9e91$var$easingLookup[definition];
    }
    return definition;
};

});
parcelRegister("6lSAG", function(module, exports) {

$parcel$export(module.exports, "anticipate", function () { return $2238c56151633019$export$6b0af63b873d419e; });

var $5Ltsj = parcelRequire("5Ltsj");
var $2238c56151633019$export$6b0af63b873d419e = function(p) {
    return p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, $5Ltsj.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
};

});
parcelRegister("5Ltsj", function(module, exports) {

$parcel$export(module.exports, "backOut", function () { return $d3611fffd053f5c5$export$77edfce482316a60; });
$parcel$export(module.exports, "backIn", function () { return $d3611fffd053f5c5$export$b01116c84cdfe1a2; });
$parcel$export(module.exports, "backInOut", function () { return $d3611fffd053f5c5$export$ddc5fd596f6c71b2; });

var $4Fem2 = parcelRequire("4Fem2");

var $8cbKa = parcelRequire("8cbKa");

var $fUcOl = parcelRequire("fUcOl");
var $d3611fffd053f5c5$export$77edfce482316a60 = /*@__PURE__*/ (0, $4Fem2.cubicBezier)(0.33, 1.53, 0.69, 0.99);
var $d3611fffd053f5c5$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $fUcOl.reverseEasing)($d3611fffd053f5c5$export$77edfce482316a60);
var $d3611fffd053f5c5$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $8cbKa.mirrorEasing)($d3611fffd053f5c5$export$b01116c84cdfe1a2);

});
parcelRegister("8cbKa", function(module, exports) {

$parcel$export(module.exports, "mirrorEasing", function () { return $408df9228a279deb$export$f946554fb8aeaf0d; });
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
/*#__NO_SIDE_EFFECTS__*/ var $408df9228a279deb$export$f946554fb8aeaf0d = function(easing) {
    return function(p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};

});



parcelRegister("hWytO", function(module, exports) {

$parcel$export(module.exports, "circIn", function () { return $e72edb5774c1fa0d$export$e444123e42d03385; });
$parcel$export(module.exports, "circOut", function () { return $e72edb5774c1fa0d$export$c8d67a19199d1a50; });
$parcel$export(module.exports, "circInOut", function () { return $e72edb5774c1fa0d$export$30d3455eee55bed5; });

var $8cbKa = parcelRequire("8cbKa");

var $fUcOl = parcelRequire("fUcOl");
var $e72edb5774c1fa0d$export$e444123e42d03385 = function(p) {
    return 1 - Math.sin(Math.acos(p));
};
var $e72edb5774c1fa0d$export$c8d67a19199d1a50 = (0, $fUcOl.reverseEasing)($e72edb5774c1fa0d$export$e444123e42d03385);
var $e72edb5774c1fa0d$export$30d3455eee55bed5 = (0, $8cbKa.mirrorEasing)($e72edb5774c1fa0d$export$e444123e42d03385);

});

parcelRegister("aK7lc", function(module, exports) {

$parcel$export(module.exports, "isBezierDefinition", function () { return $0876116f12d08b4e$export$ff43f99925d7366b; });
/*#__NO_SIDE_EFFECTS__*/ var $0876116f12d08b4e$export$ff43f99925d7366b = function(easing) {
    return Array.isArray(easing) && typeof easing[0] === "number";
};

});


parcelRegister("5xzo6", function(module, exports) {

$parcel$export(module.exports, "interpolate", function () { return $4b1a0f8130b0072f$export$89e29e4ab65e70a9; });

var $e6mbt = parcelRequire("e6mbt");

var $21URL = parcelRequire("21URL");
var $boJRf = parcelRequire("boJRf");
var $jdEmz = parcelRequire("jdEmz");
var $jXHGJ = parcelRequire("jXHGJ");
var $kdX6y = parcelRequire("kdX6y");
var $jbUqp = parcelRequire("jbUqp");

var $l2y1e = parcelRequire("l2y1e");
function $4b1a0f8130b0072f$var$createMixers(output, ease, customMixer) {
    var mixers = [];
    var mixerFactory = customMixer || (0, $jdEmz.MotionGlobalConfig).mix || (0, $l2y1e.mix);
    var numMixers = output.length - 1;
    for(var i = 0; i < numMixers; i++){
        var mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] || (0, $jXHGJ.noop) : ease;
            mixer = (0, $kdX6y.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $4b1a0f8130b0072f$export$89e29e4ab65e70a9(input, output) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.clamp, isClamp = tmp === void 0 ? true : tmp, ease = _ref.ease, mixer = _ref.mixer;
    var inputLength = input.length;
    (0, $boJRf.invariant)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return function() {
        return output[0];
    };
    if (inputLength === 2 && output[0] === output[1]) return function() {
        return output[1];
    };
    var isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = (0, $e6mbt._)(input).reverse();
        output = (0, $e6mbt._)(output).reverse();
    }
    var mixers = $4b1a0f8130b0072f$var$createMixers(output, ease, mixer);
    var numMixers = mixers.length;
    var interpolator = function(v) {
        if (isZeroDeltaRange && v < input[0]) return output[0];
        var i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        var progressInRange = (0, $jbUqp.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? function(v) {
        return interpolator((0, $21URL.clamp)(input[0], input[inputLength - 1], v));
    } : interpolator;
}

});

parcelRegister("b5Lwc", function(module, exports) {

$parcel$export(module.exports, "convertOffsetToTimes", function () { return $dbd5133c7af4a935$export$2a91b4e3a4539316; });
function $dbd5133c7af4a935$export$2a91b4e3a4539316(offset, duration) {
    return offset.map(function(o) {
        return o * duration;
    });
}

});


parcelRegister("f9TVs", function(module, exports) {

$parcel$export(module.exports, "getFinalKeyframe", function () { return $018525d5cf12783f$export$14de59408fad90b; });
var $018525d5cf12783f$var$isNotNull = function(value) {
    return value !== null;
};
function $018525d5cf12783f$export$14de59408fad90b(keyframes, param, finalKeyframe) {
    var repeat = param.repeat, _param_repeatType = param.repeatType, repeatType = _param_repeatType === void 0 ? "loop" : _param_repeatType, speed = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
    var resolvedKeyframes = keyframes.filter($018525d5cf12783f$var$isNotNull);
    var useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    var index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

});

parcelRegister("1pwqd", function(module, exports) {

$parcel$export(module.exports, "replaceTransitionType", function () { return $cc4fad352200e8b1$export$98db6ef1242dfa2; });

var $1qJmB = parcelRequire("1qJmB");

var $87iNH = parcelRequire("87iNH");

var $8T39o = parcelRequire("8T39o");
var $cc4fad352200e8b1$var$transitionTypeMap = {
    decay: (0, $1qJmB.inertia),
    inertia: (0, $1qJmB.inertia),
    tween: (0, $87iNH.keyframes),
    keyframes: (0, $87iNH.keyframes),
    spring: (0, $8T39o.spring)
};
function $cc4fad352200e8b1$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $cc4fad352200e8b1$var$transitionTypeMap[transition.type];
}

});

parcelRegister("gKmrr", function(module, exports) {

$parcel$export(module.exports, "WithPromise", function () { return $50b885c36dbb0bd8$export$655db786091c33e0; });

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");
var $50b885c36dbb0bd8$export$655db786091c33e0 = /*#__PURE__*/ function() {
    "use strict";
    function WithPromise() {
        (0, $6vyh9._)(this, WithPromise);
        this.updateFinished();
    }
    (0, $l6JfT._)(WithPromise, [
        {
            key: "finished",
            get: function get() {
                return this._finished;
            }
        },
        {
            key: "updateFinished",
            value: function updateFinished() {
                var _this = this;
                this._finished = new Promise(function(resolve) {
                    _this.resolve = resolve;
                });
            }
        },
        {
            key: "notifyFinished",
            value: function notifyFinished() {
                this.resolve();
            }
        },
        {
            /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ key: "then",
            value: function then(onResolve, onReject) {
                return this.finished.then(onResolve, onReject);
            }
        }
    ]);
    return WithPromise;
}();

});


parcelRegister("98YDC", function(module, exports) {

$parcel$export(module.exports, "flushKeyframeResolvers", function () { return $8a489d53b149c733$export$78b96d2a12593b05; });
$parcel$export(module.exports, "KeyframeResolver", function () { return $8a489d53b149c733$export$74d34ca3182f1750; });

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $3GNpW = parcelRequire("3GNpW");

var $e6mbt = parcelRequire("e6mbt");

var $h659J = parcelRequire("h659J");

var $hwzru = parcelRequire("hwzru");

var $jQwB6 = parcelRequire("jQwB6");
var $8a489d53b149c733$var$toResolve = new Set();
var $8a489d53b149c733$var$isScheduled = false;
var $8a489d53b149c733$var$anyNeedsMeasurement = false;
var $8a489d53b149c733$var$isForced = false;
function $8a489d53b149c733$var$measureAllKeyframes() {
    if ($8a489d53b149c733$var$anyNeedsMeasurement) {
        var resolversToMeasure = Array.from($8a489d53b149c733$var$toResolve).filter(function(resolver) {
            return resolver.needsMeasurement;
        });
        var elementsToMeasure = new Set(resolversToMeasure.map(function(resolver) {
            return resolver.element;
        }));
        var transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach(function(element) {
            var removedTransforms = (0, $hwzru.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureInitialState();
        });
        // Write
        elementsToMeasure.forEach(function(element) {
            element.render();
            var restore = transformsToRestore.get(element);
            if (restore) restore.forEach(function(param) {
                var _param = (0, $3GNpW._)(param, 2), key = _param[0], value = _param[1];
                var _element_getValue;
                (_element_getValue = element.getValue(key)) === null || _element_getValue === void 0 ? void 0 : _element_getValue.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach(function(resolver) {
            return resolver.measureEndState();
        });
        // Write
        resolversToMeasure.forEach(function(resolver) {
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $8a489d53b149c733$var$anyNeedsMeasurement = false;
    $8a489d53b149c733$var$isScheduled = false;
    $8a489d53b149c733$var$toResolve.forEach(function(resolver) {
        return resolver.complete($8a489d53b149c733$var$isForced);
    });
    $8a489d53b149c733$var$toResolve.clear();
}
function $8a489d53b149c733$var$readAllKeyframes() {
    $8a489d53b149c733$var$toResolve.forEach(function(resolver) {
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $8a489d53b149c733$var$anyNeedsMeasurement = true;
    });
}
function $8a489d53b149c733$export$78b96d2a12593b05() {
    $8a489d53b149c733$var$isForced = true;
    $8a489d53b149c733$var$readAllKeyframes();
    $8a489d53b149c733$var$measureAllKeyframes();
    $8a489d53b149c733$var$isForced = false;
}
var $8a489d53b149c733$export$74d34ca3182f1750 = /*#__PURE__*/ function() {
    "use strict";
    function KeyframeResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
        var isAsync = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        (0, $6vyh9._)(this, KeyframeResolver);
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = (0, $e6mbt._)(unresolvedKeyframes);
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    (0, $l6JfT._)(KeyframeResolver, [
        {
            key: "scheduleResolve",
            value: function scheduleResolve() {
                this.state = "scheduled";
                if (this.isAsync) {
                    $8a489d53b149c733$var$toResolve.add(this);
                    if (!$8a489d53b149c733$var$isScheduled) {
                        $8a489d53b149c733$var$isScheduled = true;
                        (0, $jQwB6.frame).read($8a489d53b149c733$var$readAllKeyframes);
                        (0, $jQwB6.frame).resolveKeyframes($8a489d53b149c733$var$measureAllKeyframes);
                    }
                } else {
                    this.readKeyframes();
                    this.complete();
                }
            }
        },
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name, element = _this.element, motionValue = _this.motionValue;
                // If initial keyframe is null we need to read it from the DOM
                if (unresolvedKeyframes[0] === null) {
                    var currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
                    // TODO: This doesn't work if the final keyframe is a wildcard
                    var finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                    if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
                    else if (element && name) {
                        var valueAsRead = element.readValue(name, finalKeyframe);
                        if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
                    }
                    if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
                    if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
                }
                (0, $h659J.fillWildcards)(unresolvedKeyframes);
            }
        },
        {
            key: "setFinalKeyframe",
            value: function setFinalKeyframe() {}
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {}
        },
        {
            key: "renderEndStyles",
            value: function renderEndStyles() {}
        },
        {
            key: "measureEndState",
            value: function measureEndState() {}
        },
        {
            key: "complete",
            value: function complete() {
                var isForcedComplete = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                this.state = "complete";
                this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
                $8a489d53b149c733$var$toResolve.delete(this);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state === "scheduled") {
                    $8a489d53b149c733$var$toResolve.delete(this);
                    this.state = "pending";
                }
            }
        },
        {
            key: "resume",
            value: function resume() {
                if (this.state === "pending") this.scheduleResolve();
            }
        }
    ]);
    return KeyframeResolver;
}();

});
parcelRegister("h659J", function(module, exports) {

$parcel$export(module.exports, "fillWildcards", function () { return $38216d1c21c57991$export$5a98a90409277f5a; });
function $38216d1c21c57991$export$5a98a90409277f5a(keyframes) {
    var _keyframes_i;
    for(var i = 1; i < keyframes.length; i++)(_keyframes_i = keyframes[i]) !== null && _keyframes_i !== void 0 ? _keyframes_i : keyframes[i] = keyframes[i - 1];
}

});

parcelRegister("hwzru", function(module, exports) {

$parcel$export(module.exports, "isNumOrPxType", function () { return $91829f239cfa48ae$export$8e5250d1aa9bf370; });
$parcel$export(module.exports, "removeNonTranslationalTransform", function () { return $91829f239cfa48ae$export$39d4bc9655f3f632; });
$parcel$export(module.exports, "positionalValues", function () { return $91829f239cfa48ae$export$781d46a8aa670d52; });

var $6ondx = parcelRequire("6ondx");

var $lDJGD = parcelRequire("lDJGD");

var $lNDSs = parcelRequire("lNDSs");

var $lAqg3 = parcelRequire("lAqg3");
var $91829f239cfa48ae$export$8e5250d1aa9bf370 = function(v) {
    return v === (0, $lNDSs.number) || v === (0, $lAqg3.px);
};
var $91829f239cfa48ae$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
var $91829f239cfa48ae$var$nonTranslationalTransformKeys = (0, $lDJGD.transformPropOrder).filter(function(key) {
    return !$91829f239cfa48ae$var$transformKeys.has(key);
});
function $91829f239cfa48ae$export$39d4bc9655f3f632(visualElement) {
    var removedTransforms = [];
    $91829f239cfa48ae$var$nonTranslationalTransformKeys.forEach(function(key) {
        var value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
var $91829f239cfa48ae$export$781d46a8aa670d52 = {
    // Dimensions
    width: function(param, param1) {
        var x = param.x, _param_paddingLeft = param1.paddingLeft, paddingLeft = _param_paddingLeft === void 0 ? "0" : _param_paddingLeft, _param_paddingRight = param1.paddingRight, paddingRight = _param_paddingRight === void 0 ? "0" : _param_paddingRight, boxSizing = param1.boxSizing;
        var width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: function(param, param1) {
        var y = param.y, _param_paddingTop = param1.paddingTop, paddingTop = _param_paddingTop === void 0 ? "0" : _param_paddingTop, _param_paddingBottom = param1.paddingBottom, paddingBottom = _param_paddingBottom === void 0 ? "0" : _param_paddingBottom, boxSizing = param1.boxSizing;
        var height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: function(_bbox, param) {
        var top = param.top;
        return parseFloat(top);
    },
    left: function(_bbox, param) {
        var left = param.left;
        return parseFloat(left);
    },
    bottom: function(param, param1) {
        var y = param.y, top = param1.top;
        return parseFloat(top) + (y.max - y.min);
    },
    right: function(param, param1) {
        var x = param.x, left = param1.left;
        return parseFloat(left) + (x.max - x.min);
    },
    // Transform
    x: function(_bbox, param) {
        var transform = param.transform;
        return (0, $6ondx.parseValueFromTransform)(transform, "x");
    },
    y: function(_bbox, param) {
        var transform = param.transform;
        return (0, $6ondx.parseValueFromTransform)(transform, "y");
    }
};
// Alias translate longform names
$91829f239cfa48ae$export$781d46a8aa670d52.translateX = $91829f239cfa48ae$export$781d46a8aa670d52.x;
$91829f239cfa48ae$export$781d46a8aa670d52.translateY = $91829f239cfa48ae$export$781d46a8aa670d52.y;

});
parcelRegister("6ondx", function(module, exports) {

$parcel$export(module.exports, "defaultTransformValue", function () { return $5344033f41b1d3aa$export$1f10c01143b9f089; });
$parcel$export(module.exports, "parseValueFromTransform", function () { return $5344033f41b1d3aa$export$f9111f9e16b73a26; });
$parcel$export(module.exports, "readTransformValue", function () { return $5344033f41b1d3aa$export$bcd97e0e03ba17f6; });
var $5344033f41b1d3aa$var$radToDeg = function(rad) {
    return rad * 180 / Math.PI;
};
var $5344033f41b1d3aa$var$rotate = function(v) {
    var angle = $5344033f41b1d3aa$var$radToDeg(Math.atan2(v[1], v[0]));
    return $5344033f41b1d3aa$var$rebaseAngle(angle);
};
var $5344033f41b1d3aa$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: function(v) {
        return (Math.abs(v[0]) + Math.abs(v[3])) / 2;
    },
    rotate: $5344033f41b1d3aa$var$rotate,
    rotateZ: $5344033f41b1d3aa$var$rotate,
    skewX: function(v) {
        return $5344033f41b1d3aa$var$radToDeg(Math.atan(v[1]));
    },
    skewY: function(v) {
        return $5344033f41b1d3aa$var$radToDeg(Math.atan(v[2]));
    },
    skew: function(v) {
        return (Math.abs(v[1]) + Math.abs(v[2])) / 2;
    }
};
var $5344033f41b1d3aa$var$rebaseAngle = function(angle) {
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
var $5344033f41b1d3aa$var$rotateZ = $5344033f41b1d3aa$var$rotate;
var $5344033f41b1d3aa$var$scaleX = function(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};
var $5344033f41b1d3aa$var$scaleY = function(v) {
    return Math.sqrt(v[4] * v[4] + v[5] * v[5]);
};
var $5344033f41b1d3aa$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $5344033f41b1d3aa$var$scaleX,
    scaleY: $5344033f41b1d3aa$var$scaleY,
    scale: function(v) {
        return ($5344033f41b1d3aa$var$scaleX(v) + $5344033f41b1d3aa$var$scaleY(v)) / 2;
    },
    rotateX: function(v) {
        return $5344033f41b1d3aa$var$rebaseAngle($5344033f41b1d3aa$var$radToDeg(Math.atan2(v[6], v[5])));
    },
    rotateY: function(v) {
        return $5344033f41b1d3aa$var$rebaseAngle($5344033f41b1d3aa$var$radToDeg(Math.atan2(-v[2], v[0])));
    },
    rotateZ: $5344033f41b1d3aa$var$rotateZ,
    rotate: $5344033f41b1d3aa$var$rotateZ,
    skewX: function(v) {
        return $5344033f41b1d3aa$var$radToDeg(Math.atan(v[4]));
    },
    skewY: function(v) {
        return $5344033f41b1d3aa$var$radToDeg(Math.atan(v[1]));
    },
    skew: function(v) {
        return (Math.abs(v[1]) + Math.abs(v[4])) / 2;
    }
};
function $5344033f41b1d3aa$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $5344033f41b1d3aa$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $5344033f41b1d3aa$export$1f10c01143b9f089(name);
    var matrix3dMatch = transform.match(RegExp("^matrix3d\\(([-\\d.e\\s,]+)\\)$", "u"));
    var parsers;
    var match;
    if (matrix3dMatch) {
        parsers = $5344033f41b1d3aa$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        var matrix2dMatch = transform.match(RegExp("^matrix\\(([-\\d.e\\s,]+)\\)$", "u"));
        parsers = $5344033f41b1d3aa$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $5344033f41b1d3aa$export$1f10c01143b9f089(name);
    var valueParser = parsers[name];
    var values = match[1].split(",").map($5344033f41b1d3aa$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
var $5344033f41b1d3aa$export$bcd97e0e03ba17f6 = function(instance, name) {
    var _getComputedStyle = getComputedStyle(instance), _getComputedStyle_transform = _getComputedStyle.transform, transform = _getComputedStyle_transform === void 0 ? "none" : _getComputedStyle_transform;
    return $5344033f41b1d3aa$export$f9111f9e16b73a26(transform, name);
};
function $5344033f41b1d3aa$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

});

parcelRegister("lDJGD", function(module, exports) {

$parcel$export(module.exports, "transformPropOrder", function () { return $072732f87242a581$export$280dc01950909d86; });
$parcel$export(module.exports, "transformProps", function () { return $072732f87242a581$export$7b42a0094fb00b6e; });
/**
 * Generate a list of every possible transform key.
 */ 
var $e6mbt = parcelRequire("e6mbt");
var $072732f87242a581$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 *
 * `pathRotation` is a transform for routing purposes (skipped from raw
 * style application, wired to the transform composite, flags transform
 * dirty) but is intentionally NOT in `transformPropOrder` — it is
 * composed onto `rotate` at the build sites, not serialized in its own
 * slot, and must stay out of the order-array consumers (parse-transform,
 * unit-conversion, keys-position).
 */ var $072732f87242a581$export$7b42a0094fb00b6e = /*@__PURE__*/ function() {
    return new Set((0, $e6mbt._)($072732f87242a581$export$280dc01950909d86).concat([
        "pathRotation"
    ]));
}();

});



parcelRegister("gav0r", function(module, exports) {

$parcel$export(module.exports, "NativeAnimationExtended", function () { return $c8d399b0787721bd$export$bd2cd6a048093d96; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $goUpr = parcelRequire("goUpr");

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $f7oRS = parcelRequire("f7oRS");

var $21URL = parcelRequire("21URL");

var $jEChV = parcelRequire("jEChV");

var $eZTzE = parcelRequire("eZTzE");

var $1bahE = parcelRequire("1bahE");

var $kWkWf = parcelRequire("kWkWf");

var $1pwqd = parcelRequire("1pwqd");

var $duaPg = parcelRequire("duaPg");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ var $c8d399b0787721bd$var$sampleDelta = 10; //ms
var $c8d399b0787721bd$export$bd2cd6a048093d96 = /*#__PURE__*/ function(NativeAnimation) {
    "use strict";
    (0, $goUpr._)(NativeAnimationExtended, NativeAnimation);
    function NativeAnimationExtended(options) {
        (0, $6vyh9._)(this, NativeAnimationExtended);
        var _this;
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $duaPg.replaceStringEasing)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $1pwqd.replaceTransitionType)(options);
        _this = (0, $enHBd._)(this, NativeAnimationExtended, [
            options
        ]);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) _this.startTime = options.startTime;
        _this.options = options;
        return _this;
    }
    (0, $l6JfT._)(NativeAnimationExtended, [
        {
            /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ key: "updateMotionValue",
            value: function updateMotionValue(value) {
                var _this_options = this.options, motionValue = _this_options.motionValue, onUpdate = _this_options.onUpdate, onComplete = _this_options.onComplete, element = _this_options.element, options = (0, $f7oRS._)(_this_options, [
                    "motionValue",
                    "onUpdate",
                    "onComplete",
                    "element"
                ]);
                if (!motionValue) return;
                if (value !== undefined) {
                    motionValue.set(value);
                    return;
                }
                var sampleAnimation = new (0, $1bahE.JSAnimation)((0, $bPuui._)((0, $81JKW._)({}, options), {
                    autoplay: false
                }));
                /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ var sampleTime = Math.max($c8d399b0787721bd$var$sampleDelta, (0, $jEChV.time).now() - this.startTime);
                var delta = (0, $21URL.clamp)(0, $c8d399b0787721bd$var$sampleDelta, sampleTime - $c8d399b0787721bd$var$sampleDelta);
                var current = sampleAnimation.sample(sampleTime).value;
                /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ var name = this.options.name;
                if (element && name) (0, $eZTzE.setStyle)(element, name, current);
                motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
                sampleAnimation.stop();
            }
        }
    ]);
    return NativeAnimationExtended;
}((0, $kWkWf.NativeAnimation));

});
parcelRegister("eZTzE", function(module, exports) {

$parcel$export(module.exports, "setStyle", function () { return $7c1924258ab72895$export$37a5fde709c1db82; });

var $4V39g = parcelRequire("4V39g");
function $7c1924258ab72895$export$37a5fde709c1db82(element, name, value) {
    (0, $4V39g.isCSSVar)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}

});
parcelRegister("4V39g", function(module, exports) {

$parcel$export(module.exports, "isCSSVar", function () { return $ef735692c06345b3$export$c9f584638d388483; });
var $ef735692c06345b3$export$c9f584638d388483 = function(name) {
    return name.startsWith("--");
};

});


parcelRegister("kWkWf", function(module, exports) {

$parcel$export(module.exports, "NativeAnimation", function () { return $f1afdd8dc7671206$export$6c0f9803d8aa7219; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $goUpr = parcelRequire("goUpr");

var $h38BI = parcelRequire("h38BI");

var $boJRf = parcelRequire("boJRf");
var $cxm77 = parcelRequire("cxm77");
var $jXHGJ = parcelRequire("jXHGJ");

var $eZTzE = parcelRequire("eZTzE");

var $1h8jZ = parcelRequire("1h8jZ");

var $f9TVs = parcelRequire("f9TVs");

var $gKmrr = parcelRequire("gKmrr");

var $93KU4 = parcelRequire("93KU4");

var $gGAyS = parcelRequire("gGAyS");
/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ var $f1afdd8dc7671206$export$6c0f9803d8aa7219 = /*#__PURE__*/ function(WithPromise) {
    "use strict";
    (0, $goUpr._)(NativeAnimation, WithPromise);
    function NativeAnimation(options) {
        (0, $6vyh9._)(this, NativeAnimation);
        var _this;
        _this = (0, $enHBd._)(this, NativeAnimation);
        _this.finishedTime = null;
        _this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ _this.manualStartTime = null;
        if (!options) return (0, $h38BI._)(_this);
        var element = options.element, name = options.name, keyframes = options.keyframes, pseudoElement = options.pseudoElement, _options_allowFlatten = options.allowFlatten, allowFlatten = _options_allowFlatten === void 0 ? false : _options_allowFlatten, finalKeyframe = options.finalKeyframe, onComplete = options.onComplete;
        _this.isPseudoElement = Boolean(pseudoElement);
        _this.allowFlatten = allowFlatten;
        _this.options = options;
        (0, $boJRf.invariant)(typeof options.type !== "string", 'Mini animate() doesn\'t support "type" as a string.', "mini-spring");
        var transition = (0, $gGAyS.applyGeneratorOptions)(options);
        _this.animation = (0, $93KU4.startWaapiAnimation)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) _this.animation.pause();
        _this.animation.onfinish = function() {
            _this.finishedTime = _this.time;
            if (!pseudoElement) {
                var keyframe = (0, $f9TVs.getFinalKeyframe)(keyframes, _this.options, finalKeyframe, _this.speed);
                if (_this.updateMotionValue) _this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, $eZTzE.setStyle)(element, name, keyframe);
                _this.animation.cancel();
            }
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            _this.notifyFinished();
        };
        return _this;
    }
    (0, $l6JfT._)(NativeAnimation, [
        {
            key: "play",
            value: function play() {
                if (this.isStopped) return;
                this.manualStartTime = null;
                this.animation.play();
                if (this.state === "finished") this.updateFinished();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.animation.pause();
            }
        },
        {
            key: "complete",
            value: function complete() {
                var _this_animation_finish, _this_animation;
                (_this_animation_finish = (_this_animation = this.animation).finish) === null || _this_animation_finish === void 0 ? void 0 : _this_animation_finish.call(_this_animation);
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                try {
                    this.animation.cancel();
                } catch (e) {}
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.isStopped) return;
                this.isStopped = true;
                var state = this.state;
                if (state === "idle" || state === "finished") return;
                if (this.updateMotionValue) this.updateMotionValue();
                else this.commitStyles();
                if (!this.isPseudoElement) this.cancel();
            }
        },
        {
            /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ key: "commitStyles",
            value: function commitStyles() {
                var _this_options, _this_animation_commitStyles, _this_animation;
                var element = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.element;
                if (!this.isPseudoElement && (element === null || element === void 0 ? void 0 : element.isConnected)) (_this_animation_commitStyles = (_this_animation = this.animation).commitStyles) === null || _this_animation_commitStyles === void 0 ? void 0 : _this_animation_commitStyles.call(_this_animation);
            }
        },
        {
            key: "duration",
            get: function get() {
                var _this_animation_effect_getComputedTiming, _this_animation_effect;
                var duration = ((_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : (_this_animation_effect_getComputedTiming = _this_animation_effect.getComputedTiming) === null || _this_animation_effect_getComputedTiming === void 0 ? void 0 : _this_animation_effect_getComputedTiming.call(_this_animation_effect).duration) || 0;
                return (0, $cxm77.millisecondsToSeconds)(Number(duration));
            }
        },
        {
            key: "iterationDuration",
            get: function get() {
                var _ref = this.options || {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay;
                return this.duration + (0, $cxm77.millisecondsToSeconds)(delay);
            }
        },
        {
            key: "time",
            get: function get() {
                return (0, $cxm77.millisecondsToSeconds)(Number(this.animation.currentTime) || 0);
            },
            set: function set(newTime) {
                var wasFinished = this.finishedTime !== null;
                this.manualStartTime = null;
                this.finishedTime = null;
                this.animation.currentTime = (0, $cxm77.secondsToMilliseconds)(newTime);
                if (wasFinished) this.animation.pause();
            }
        },
        {
            key: "speed",
            get: /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ function get() {
                return this.animation.playbackRate;
            },
            set: function set(newSpeed) {
                // Allow backwards playback after finishing
                if (newSpeed < 0) this.finishedTime = null;
                this.animation.playbackRate = newSpeed;
            }
        },
        {
            key: "state",
            get: function get() {
                return this.finishedTime !== null ? "finished" : this.animation.playState;
            }
        },
        {
            key: "startTime",
            get: function get() {
                var _this_manualStartTime;
                return (_this_manualStartTime = this.manualStartTime) !== null && _this_manualStartTime !== void 0 ? _this_manualStartTime : Number(this.animation.startTime);
            },
            set: function set(newStartTime) {
                this.manualStartTime = this.animation.startTime = newStartTime;
            }
        },
        {
            /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ key: "attachTimeline",
            value: function attachTimeline(param) {
                var timeline = param.timeline, rangeStart = param.rangeStart, rangeEnd = param.rangeEnd, observe = param.observe;
                var _this_animation_effect;
                if (this.allowFlatten) (_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : _this_animation_effect.updateTiming({
                    easing: "linear"
                });
                this.animation.onfinish = null;
                if (timeline && (0, $1h8jZ.supportsScrollTimeline)()) {
                    this.animation.timeline = timeline;
                    if (rangeStart) this.animation.rangeStart = rangeStart;
                    if (rangeEnd) this.animation.rangeEnd = rangeEnd;
                    return 0, $jXHGJ.noop;
                } else return observe(this);
            }
        }
    ]);
    return NativeAnimation;
}((0, $gKmrr.WithPromise));

});
parcelRegister("1h8jZ", function(module, exports) {

$parcel$export(module.exports, "supportsScrollTimeline", function () { return $98a1b378c68ac331$export$20d68f04f30763a5; });

var $fJUlM = parcelRequire("fJUlM");
var $98a1b378c68ac331$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $fJUlM.memoSupports)(function() {
    return window.ScrollTimeline !== undefined;
}, "scrollTimeline");
var $98a1b378c68ac331$export$206321d8c5f8fd38 = /* @__PURE__ */ (0, $fJUlM.memoSupports)(function() {
    return window.ViewTimeline !== undefined;
}, "viewTimeline");

});
parcelRegister("fJUlM", function(module, exports) {

$parcel$export(module.exports, "memoSupports", function () { return $861a9ef5723d1d36$export$1964673d5ec13c3a; });

var $2ZVS2 = parcelRequire("2ZVS2");

var $lMAI6 = parcelRequire("lMAI6");
function $861a9ef5723d1d36$export$1964673d5ec13c3a(callback, supportsFlag) {
    var memoized = (0, $2ZVS2.memo)(callback);
    return function() {
        var _supportsFlags_supportsFlag;
        return (_supportsFlags_supportsFlag = (0, $lMAI6.supportsFlags)[supportsFlag]) !== null && _supportsFlags_supportsFlag !== void 0 ? _supportsFlags_supportsFlag : memoized();
    };
}

});
parcelRegister("2ZVS2", function(module, exports) {

$parcel$export(module.exports, "memo", function () { return $9d0ca9d9d2093e6f$export$7c73462e0d25e514; });
/*#__NO_SIDE_EFFECTS__*/ function $9d0ca9d9d2093e6f$export$7c73462e0d25e514(callback) {
    var result;
    return function() {
        if (result === undefined) result = callback();
        return result;
    };
}

});

parcelRegister("lMAI6", function(module, exports) {

$parcel$export(module.exports, "supportsFlags", function () { return $49b0ea75c2c4f239$export$e3ad02c335474dee; });
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ var $49b0ea75c2c4f239$export$e3ad02c335474dee = {};

});



parcelRegister("93KU4", function(module, exports) {

$parcel$export(module.exports, "startWaapiAnimation", function () { return $13be44a9ad33b740$export$d896de52f97cb615; });

var $inKFz = parcelRequire("inKFz");

var $24ZQd = parcelRequire("24ZQd");

var $2crQf = parcelRequire("2crQf");

var $8X7GA = parcelRequire("8X7GA");
function $13be44a9ad33b740$export$d896de52f97cb615(element, valueName, keyframes) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 300 : _ref_duration, _ref_repeat = _ref.repeat, repeat = _ref_repeat === void 0 ? 0 : _ref_repeat, _ref_repeatType = _ref.repeatType, repeatType = _ref_repeatType === void 0 ? "loop" : _ref_repeatType, _ref_ease = _ref.ease, ease = _ref_ease === void 0 ? "easeOut" : _ref_ease, times = _ref.times, pseudoElement = arguments.length > 4 ? arguments[4] : void 0;
    var keyframeOptions = (0, $inKFz._)({}, valueName, keyframes);
    if (times) keyframeOptions.offset = times;
    var easing = (0, $8X7GA.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $2crQf.statsBuffer).value) (0, $24ZQd.activeAnimations).waapi++;
    var options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    var animation = element.animate(keyframeOptions, options);
    if ((0, $2crQf.statsBuffer).value) animation.finished.finally(function() {
        (0, $24ZQd.activeAnimations).waapi--;
    });
    return animation;
}

});
parcelRegister("8X7GA", function(module, exports) {

$parcel$export(module.exports, "mapEasingToNativeEasing", function () { return $a86f902b0c864203$export$916ea73bcd3a6030; });

var $aK7lc = parcelRequire("aK7lc");

var $9BgrV = parcelRequire("9BgrV");

var $6RDNP = parcelRequire("6RDNP");

var $jBbQf = parcelRequire("jBbQf");

var $fFtZx = parcelRequire("fFtZx");
function $a86f902b0c864203$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $9BgrV.supportsLinearEasing)() ? (0, $6RDNP.generateLinearEasing)(easing, duration) : "ease-out";
    else if ((0, $aK7lc.isBezierDefinition)(easing)) return (0, $jBbQf.cubicBezierAsString)(easing);
    else if (Array.isArray(easing)) return easing.map(function(segmentEasing) {
        return $a86f902b0c864203$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $fFtZx.supportedWaapiEasing).easeOut;
    });
    else return (0, $fFtZx.supportedWaapiEasing)[easing];
}

});
parcelRegister("9BgrV", function(module, exports) {

$parcel$export(module.exports, "supportsLinearEasing", function () { return $a4f867527d6a964a$export$866c1d07a1ac2ab; });

var $fJUlM = parcelRequire("fJUlM");
var $a4f867527d6a964a$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $fJUlM.memoSupports)(function() {
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

});

parcelRegister("jBbQf", function(module, exports) {

$parcel$export(module.exports, "cubicBezierAsString", function () { return $6078fff6d7f4b3e0$export$2523b8f0bd8f44cb; });

var $3GNpW = parcelRequire("3GNpW");
var $6078fff6d7f4b3e0$export$2523b8f0bd8f44cb = function(param) {
    var _param = (0, $3GNpW._)(param, 4), a = _param[0], b = _param[1], c = _param[2], d = _param[3];
    return "cubic-bezier(".concat(a, ", ").concat(b, ", ").concat(c, ", ").concat(d, ")");
};

});

parcelRegister("fFtZx", function(module, exports) {

$parcel$export(module.exports, "supportedWaapiEasing", function () { return $fca3a3439e01161e$export$2cf569f5e2221176; });

var $jBbQf = parcelRequire("jBbQf");
var $fca3a3439e01161e$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $jBbQf.cubicBezierAsString)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $jBbQf.cubicBezierAsString)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $jBbQf.cubicBezierAsString)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $jBbQf.cubicBezierAsString)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};

});



parcelRegister("gGAyS", function(module, exports) {

$parcel$export(module.exports, "applyGeneratorOptions", function () { return $32d82eeb42fb59bb$export$a31269144d66b4a; });

var $f7oRS = parcelRequire("f7oRS");

var $9BgrV = parcelRequire("9BgrV");

var $8JGS8 = parcelRequire("8JGS8");
function $32d82eeb42fb59bb$export$a31269144d66b4a(_param) {
    var type = _param.type, options = (0, $f7oRS._)(_param, [
        "type"
    ]);
    if ((0, $8JGS8.isGenerator)(type) && (0, $9BgrV.supportsLinearEasing)()) return type.applyToOptions(options);
    else {
        var _options_duration;
        (_options_duration = options.duration) !== null && _options_duration !== void 0 ? _options_duration : options.duration = 300;
        var _options_ease;
        (_options_ease = options.ease) !== null && _options_ease !== void 0 ? _options_ease : options.ease = "easeOut";
    }
    return options;
}

});


parcelRegister("duaPg", function(module, exports) {

$parcel$export(module.exports, "replaceStringEasing", function () { return $ee1b9346b7e6b5e3$export$5195f232c29d1f82; });

var $6lSAG = parcelRequire("6lSAG");
var $5Ltsj = parcelRequire("5Ltsj");
var $hWytO = parcelRequire("hWytO");
var $ee1b9346b7e6b5e3$var$unsupportedEasingFunctions = {
    anticipate: (0, $6lSAG.anticipate),
    backInOut: (0, $5Ltsj.backInOut),
    circInOut: (0, $hWytO.circInOut)
};
function $ee1b9346b7e6b5e3$var$isUnsupportedEase(key) {
    return key in $ee1b9346b7e6b5e3$var$unsupportedEasingFunctions;
}
function $ee1b9346b7e6b5e3$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $ee1b9346b7e6b5e3$var$isUnsupportedEase(transition.ease)) transition.ease = $ee1b9346b7e6b5e3$var$unsupportedEasingFunctions[transition.ease];
}

});


parcelRegister("ibKsX", function(module, exports) {

$parcel$export(module.exports, "canAnimate", function () { return $42a2208e2267fe83$export$1b109e6c9968df4f; });

var $boJRf = parcelRequire("boJRf");

var $8JGS8 = parcelRequire("8JGS8");

var $HeKAe = parcelRequire("HeKAe");
function $42a2208e2267fe83$var$hasKeyframesChanged(keyframes) {
    var current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(var i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $42a2208e2267fe83$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ var originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    var targetKeyframe = keyframes[keyframes.length - 1];
    var isOriginAnimatable = (0, $HeKAe.isAnimatable)(originKeyframe, name);
    var isTargetAnimatable = (0, $HeKAe.isAnimatable)(targetKeyframe, name);
    (0, $boJRf.warning)(isOriginAnimatable === isTargetAnimatable, "You are trying to animate ".concat(name, ' from "').concat(originKeyframe, '" to "').concat(targetKeyframe, '". "').concat(isOriginAnimatable ? targetKeyframe : originKeyframe, '" is not an animatable value.'), "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $42a2208e2267fe83$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $8JGS8.isGenerator)(type)) && velocity;
}

});
parcelRegister("HeKAe", function(module, exports) {

$parcel$export(module.exports, "isAnimatable", function () { return $5aeab0e6a0f430f0$export$65676b58b122bc38; });

var $kBIio = parcelRequire("kBIio");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ var $5aeab0e6a0f430f0$export$65676b58b122bc38 = function(value, name) {
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $kBIio.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

});


parcelRegister("hgTOm", function(module, exports) {

$parcel$export(module.exports, "makeAnimationInstant", function () { return $43a238110aa62979$export$b2585dd3c345da47; });
function $43a238110aa62979$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}

});

parcelRegister("2rwoM", function(module, exports) {

$parcel$export(module.exports, "supportsBrowserAnimation", function () { return $8b0207c2f46491d6$export$ea92bde116fda821; });

var $2ZVS2 = parcelRequire("2ZVS2");

var $dwQ69 = parcelRequire("dwQ69");

var $gDNZE = parcelRequire("gDNZE");
var $8b0207c2f46491d6$var$colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
var $8b0207c2f46491d6$var$supportsWaapi = /*@__PURE__*/ (0, $2ZVS2.memo)(function() {
    return Object.hasOwnProperty.call(Element.prototype, "animate");
});
function $8b0207c2f46491d6$export$ea92bde116fda821(options) {
    var _motionValue_owner;
    var motionValue = options.motionValue, name = options.name, repeatDelay = options.repeatDelay, repeatType = options.repeatType, damping = options.damping, type = options.type, keyframes = options.keyframes;
    var subject = motionValue === null || motionValue === void 0 ? void 0 : (_motionValue_owner = motionValue.owner) === null || _motionValue_owner === void 0 ? void 0 : _motionValue_owner.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    var _motionValue_owner_getProps = motionValue.owner.getProps(), onUpdate = _motionValue_owner_getProps.onUpdate, transformTemplate = _motionValue_owner_getProps.transformTemplate;
    return $8b0207c2f46491d6$var$supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, $dwQ69.acceleratedValues).has(name) || $8b0207c2f46491d6$var$colorProperties.has(name) && (0, $gDNZE.hasBrowserOnlyColors)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}

});
parcelRegister("dwQ69", function(module, exports) {

$parcel$export(module.exports, "acceleratedValues", function () { return $01a23fb0285a5638$export$a27eefbd8fb5e404; });
/**
 * A list of values that can be hardware-accelerated.
 */ var $01a23fb0285a5638$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);

});

parcelRegister("gDNZE", function(module, exports) {

$parcel$export(module.exports, "hasBrowserOnlyColors", function () { return $78380cc585ef844e$export$1af9e65d1501d15; });
var $78380cc585ef844e$var$browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function $78380cc585ef844e$export$1af9e65d1501d15(keyframes) {
    for(var i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && $78380cc585ef844e$var$browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}

});



parcelRegister("6sveo", function(module, exports) {

$parcel$export(module.exports, "getValueTransition", function () { return $bb5a8f4275e89c5b$export$7c1391340308742e; });

var $6gDRU = parcelRequire("6gDRU");
function $bb5a8f4275e89c5b$export$7c1391340308742e(transition, key) {
    var _transition_key, _ref;
    var valueTransition = (_ref = (_transition_key = transition === null || transition === void 0 ? void 0 : transition[key]) !== null && _transition_key !== void 0 ? _transition_key : transition === null || transition === void 0 ? void 0 : transition["default"]) !== null && _ref !== void 0 ? _ref : transition;
    if (valueTransition !== transition) return (0, $6gDRU.resolveTransition)(valueTransition, transition);
    return valueTransition;
}

});
parcelRegister("6gDRU", function(module, exports) {

$parcel$export(module.exports, "resolveTransition", function () { return $4201724a7bfb69c2$export$b180037f8f468d61; });
/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ 
var $81JKW = parcelRequire("81JKW");

var $f7oRS = parcelRequire("f7oRS");
function $4201724a7bfb69c2$export$b180037f8f468d61(transition, parentTransition) {
    if ((transition === null || transition === void 0 ? void 0 : transition.inherit) && parentTransition) {
        var _ = transition.inherit, rest = (0, $f7oRS._)(transition, [
            "inherit"
        ]);
        return (0, $81JKW._)({}, parentTransition, rest);
    }
    return transition;
}

});


parcelRegister("fB4yp", function(module, exports) {

$parcel$export(module.exports, "getDefaultTransition", function () { return $497de48e5b4e1eca$export$262124b154b9f1c0; });

var $lDJGD = parcelRequire("lDJGD");
var $497de48e5b4e1eca$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
var $497de48e5b4e1eca$var$criticallyDampedSpring = function(target) {
    return {
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    };
};
var $497de48e5b4e1eca$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ var $497de48e5b4e1eca$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
var $497de48e5b4e1eca$export$262124b154b9f1c0 = function(valueKey, param) {
    var keyframes = param.keyframes;
    if (keyframes.length > 2) return $497de48e5b4e1eca$var$keyframesTransition;
    else if ((0, $lDJGD.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? $497de48e5b4e1eca$var$criticallyDampedSpring(keyframes[1]) : $497de48e5b4e1eca$var$underDampedSpring;
    return $497de48e5b4e1eca$var$ease;
};

});

parcelRegister("kz8da", function(module, exports) {

$parcel$export(module.exports, "isTransitionDefined", function () { return $6f08960178072935$export$ca8e47dc8ed5a9d7; });
var $6f08960178072935$var$orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $6f08960178072935$export$ca8e47dc8ed5a9d7(transition) {
    for(var key in transition){
        if (!$6f08960178072935$var$orchestrationKeys.has(key)) return true;
    }
    return false;
}

});



parcelRegister("cBtac", function(module, exports) {

$parcel$export(module.exports, "animateTarget", function () { return $d5cfbb9ad821caf6$export$68cacfeee78d98d2; });

var $81JKW = parcelRequire("81JKW");

var $f7oRS = parcelRequire("f7oRS");

var $6sveo = parcelRequire("6sveo");

var $6gDRU = parcelRequire("6gDRU");

var $eXksG = parcelRequire("eXksG");

var $8zMuN = parcelRequire("8zMuN");

var $h6MeH = parcelRequire("h6MeH");

var $6g2gB = parcelRequire("6g2gB");

var $b6c9i = parcelRequire("b6c9i");

var $jQwB6 = parcelRequire("jQwB6");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $d5cfbb9ad821caf6$var$shouldBlockAnimation(param, key) {
    var protectedKeys = param.protectedKeys, needsAnimating = param.needsAnimating;
    var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $d5cfbb9ad821caf6$export$68cacfeee78d98d2(visualElement, targetAndTransition) {
    var _loop = function(key) {
        var _visualElement_latestValues_key;
        var value = visualElement.getValue(key, (_visualElement_latestValues_key = visualElement.latestValues[key]) !== null && _visualElement_latestValues_key !== void 0 ? _visualElement_latestValues_key : null);
        var valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $d5cfbb9ad821caf6$var$shouldBlockAnimation(animationTypeState, key)) return "continue";
        var valueTransition = (0, $81JKW._)({
            delay: delay
        }, (0, $6sveo.getValueTransition)(transition || {}, key));
        if (skipAnimations) valueTransition.skipAnimations = true;
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ var currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, $jQwB6.frame).update(function() {
                return value.set(valueTarget);
            });
            return "continue";
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ var isHandoff = false;
        if (window.MotionHandoffAnimation) {
            var appearId = (0, $6g2gB.getOptimisedAppearId)(visualElement);
            if (appearId) {
                var startTime = window.MotionHandoffAnimation(appearId, key, (0, $jQwB6.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $h6MeH.addValueToWillChange)(visualElement, key);
        var shouldReduceMotion = reduceMotion !== null && reduceMotion !== void 0 ? reduceMotion : visualElement.shouldReduceMotion;
        value.start((0, $b6c9i.animateMotionValue)(key, value, valueTarget, shouldReduceMotion && (0, $eXksG.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        var animation = value.animation;
        if (animation) animations.push(animation);
    };
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_delay = _ref.delay, delay = _ref_delay === void 0 ? 0 : _ref_delay, transitionOverride = _ref.transitionOverride, type = _ref.type;
    var transition = targetAndTransition.transition, transitionEnd = targetAndTransition.transitionEnd, target = (0, $f7oRS._)(targetAndTransition, [
        "transition",
        "transitionEnd"
    ]);
    var defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, $6gDRU.resolveTransition)(transition, defaultTransition) : defaultTransition;
    var reduceMotion = transition === null || transition === void 0 ? void 0 : transition.reduceMotion;
    var skipAnimations = transition === null || transition === void 0 ? void 0 : transition.skipAnimations;
    if (transitionOverride) transition = transitionOverride;
    var animations = [];
    var animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    var path = transition === null || transition === void 0 ? void 0 : transition.path;
    if (path) // path mutates `target` to claim x/y; loop below skips them.
    path.animateVisualElement(visualElement, target, transition, delay, animations);
    for(var key in target)_loop(key);
    if (transitionEnd) {
        var applyTransitionEnd = function() {
            return (0, $jQwB6.frame).update(function() {
                transitionEnd && (0, $8zMuN.setTarget)(visualElement, transitionEnd);
            });
        };
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}

});
parcelRegister("eXksG", function(module, exports) {

$parcel$export(module.exports, "positionalKeys", function () { return $08bc19c84be3412b$export$c66c0d5db2a205d; });

var $e6mbt = parcelRequire("e6mbt");

var $lDJGD = parcelRequire("lDJGD");
var $08bc19c84be3412b$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom"
].concat((0, $e6mbt._)((0, $lDJGD.transformPropOrder))));

});

parcelRegister("8zMuN", function(module, exports) {

$parcel$export(module.exports, "setTarget", function () { return $74acaba1c3ce3a43$export$1f61c53461aff4a5; });

var $81JKW = parcelRequire("81JKW");

var $f7oRS = parcelRequire("f7oRS");

var $4WU07 = parcelRequire("4WU07");

var $9c5SQ = parcelRequire("9c5SQ");

var $9x8Og = parcelRequire("9x8Og");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $74acaba1c3ce3a43$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $4WU07.motionValue)(value));
}
function $74acaba1c3ce3a43$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $9x8Og.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
}
function $74acaba1c3ce3a43$export$1f61c53461aff4a5(visualElement, definition) {
    var resolved = (0, $9c5SQ.resolveVariant)(visualElement, definition);
    var _ref = resolved || {}, _ref_transitionEnd = _ref.transitionEnd, transitionEnd = _ref_transitionEnd === void 0 ? {} : _ref_transitionEnd, _ref_transition = _ref.transition, transition = _ref_transition === void 0 ? {} : _ref_transition, target = (0, $f7oRS._)(_ref, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $81JKW._)({}, target, transitionEnd);
    for(var key in target){
        var value = $74acaba1c3ce3a43$var$resolveFinalValueInKeyframes(target[key]);
        $74acaba1c3ce3a43$var$setMotionValue(visualElement, key, value);
    }
}

});
parcelRegister("9c5SQ", function(module, exports) {

$parcel$export(module.exports, "resolveVariant", function () { return $a58a00cae3a08463$export$7b1b1c981f4f0558; });

var $6UGQ7 = parcelRequire("6UGQ7");
function $a58a00cae3a08463$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    var props = visualElement.getProps();
    return (0, $6UGQ7.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

});
parcelRegister("6UGQ7", function(module, exports) {

$parcel$export(module.exports, "resolveVariantFromProps", function () { return $53fee4f4a85c16d3$export$d68f140c4d9b48bc; });

var $3GNpW = parcelRequire("3GNpW");
function $53fee4f4a85c16d3$var$getValueState(visualElement) {
    var state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach(function(value, key) {
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $53fee4f4a85c16d3$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        var _getValueState = (0, $3GNpW._)($53fee4f4a85c16d3$var$getValueState(visualElement), 2), current = _getValueState[0], velocity = _getValueState[1];
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        var _getValueState1 = (0, $3GNpW._)($53fee4f4a85c16d3$var$getValueState(visualElement), 2), current1 = _getValueState1[0], velocity1 = _getValueState1[1];
        definition = definition(custom !== undefined ? custom : props.custom, current1, velocity1);
    }
    return definition;
}

});


parcelRegister("9x8Og", function(module, exports) {

$parcel$export(module.exports, "isKeyframesTarget", function () { return $933b5c838c087c68$export$9153ad4c4999f4a0; });
var $933b5c838c087c68$export$9153ad4c4999f4a0 = function(v) {
    return Array.isArray(v);
};

});


parcelRegister("h6MeH", function(module, exports) {

$parcel$export(module.exports, "addValueToWillChange", function () { return $527efe5995a855ab$export$3ac5aed310be0bee; });

var $jdEmz = parcelRequire("jdEmz");

var $kSIOq = parcelRequire("kSIOq");
function $527efe5995a855ab$export$3ac5aed310be0bee(visualElement, key) {
    var willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $kSIOq.isWillChangeMotionValue)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $jdEmz.MotionGlobalConfig).WillChange) {
        var newWillChange = new (0, $jdEmz.MotionGlobalConfig).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}

});
parcelRegister("kSIOq", function(module, exports) {

$parcel$export(module.exports, "isWillChangeMotionValue", function () { return $007db79c99fea6c0$export$98397f3adbf6259f; });

var $ejle5 = parcelRequire("ejle5");
function $007db79c99fea6c0$export$98397f3adbf6259f(value) {
    return Boolean((0, $ejle5.isMotionValue)(value) && value.add);
}

});


parcelRegister("6g2gB", function(module, exports) {

$parcel$export(module.exports, "getOptimisedAppearId", function () { return $c965eb8eb413ec25$export$5f8d21e84d1d84fc; });

var $bxW6d = parcelRequire("bxW6d");
function $c965eb8eb413ec25$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $bxW6d.optimizedAppearDataAttribute];
}

});
parcelRegister("bxW6d", function(module, exports) {

$parcel$export(module.exports, "optimizedAppearDataAttribute", function () { return $b6c8c3941aadd7d5$export$8592e1c077c890a6; });

var $3TqEi = parcelRequire("3TqEi");
var $b6c8c3941aadd7d5$export$ed7b8fa9dbf0105d = "framerAppearId";
var $b6c8c3941aadd7d5$export$8592e1c077c890a6 = "data-" + (0, $3TqEi.camelToDash)($b6c8c3941aadd7d5$export$ed7b8fa9dbf0105d);

});
parcelRegister("3TqEi", function(module, exports) {

$parcel$export(module.exports, "camelToDash", function () { return $89973eadeeb82009$export$9fd24a634729c672; });
function $89973eadeeb82009$export$9fd24a634729c672(str) {
    return str.replace(/([A-Z])/g, function(match) {
        return "-".concat(match.toLowerCase());
    });
}

});




parcelRegister("aJc4O", function(module, exports) {

$parcel$export(module.exports, "visualElementStore", function () { return $ecc9435674f8eefd$export$bc2a978a17abfdde; });
var $ecc9435674f8eefd$export$bc2a978a17abfdde = new WeakMap();

});

parcelRegister("hg8T5", function(module, exports) {

$parcel$export(module.exports, "createDOMVisualElement", function () { return $5b06ac583237967b$export$602bd1946a6d1d47; });
$parcel$export(module.exports, "createObjectVisualElement", function () { return $5b06ac583237967b$export$69c3b8be1812d4ee; });

var $iOylb = parcelRequire("iOylb");
var $6sW40 = parcelRequire("6sW40");
var $4WdoH = parcelRequire("4WdoH");
var $iPlTo = parcelRequire("iPlTo");
var $eTeMd = parcelRequire("eTeMd");
var $aJc4O = parcelRequire("aJc4O");
function $5b06ac583237967b$export$602bd1946a6d1d47(element) {
    var options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                transform: {},
                transformOrigin: {},
                style: {},
                vars: {},
                attrs: {}
            },
            latestValues: {}
        }
    };
    var node = (0, $6sW40.isSVGElement)(element) && !(0, $4WdoH.isSVGSVGElement)(element) ? new (0, $eTeMd.SVGVisualElement)(options) : new (0, $iOylb.HTMLVisualElement)(options);
    node.mount(element);
    (0, $aJc4O.visualElementStore).set(element, node);
}
function $5b06ac583237967b$export$69c3b8be1812d4ee(subject) {
    var options = {
        presenceContext: null,
        props: {},
        visualState: {
            renderState: {
                output: {}
            },
            latestValues: {}
        }
    };
    var node = new (0, $iPlTo.ObjectVisualElement)(options);
    node.mount(subject);
    (0, $aJc4O.visualElementStore).set(subject, node);
}

});
parcelRegister("iOylb", function(module, exports) {

$parcel$export(module.exports, "HTMLVisualElement", function () { return $724272c77eae6976$export$23fea75b03ac16b3; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $goUpr = parcelRequire("goUpr");

var $9ws7c = parcelRequire("9ws7c");

var $lDJGD = parcelRequire("lDJGD");

var $6ondx = parcelRequire("6ondx");

var $2Nvge = parcelRequire("2Nvge");

var $eA0JA = parcelRequire("eA0JA");

var $9O0P4 = parcelRequire("9O0P4");

var $6j8zo = parcelRequire("6j8zo");

var $d7Mlo = parcelRequire("d7Mlo");
function $724272c77eae6976$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
var $724272c77eae6976$export$23fea75b03ac16b3 = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, $goUpr._)(HTMLVisualElement, DOMVisualElement);
    function HTMLVisualElement() {
        (0, $6vyh9._)(this, HTMLVisualElement);
        var _this;
        _this = (0, $enHBd._)(this, HTMLVisualElement, arguments);
        _this.type = "html";
        _this.renderInstance = (0, $6j8zo.renderHTML);
        return _this;
    }
    (0, $l6JfT._)(HTMLVisualElement, [
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                var _this_projection;
                if ((0, $lDJGD.transformProps).has(key)) return ((_this_projection = this.projection) === null || _this_projection === void 0 ? void 0 : _this_projection.isProjecting) ? (0, $6ondx.defaultTransformValue)(key) : (0, $6ondx.readTransformValue)(instance, key);
                else {
                    var computedStyle = $724272c77eae6976$export$3735103072e4a80(instance);
                    var value = ((0, $9ws7c.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
                    return typeof value === "string" ? value.trim() : value;
                }
            }
        },
        {
            key: "measureInstanceViewportBox",
            value: function measureInstanceViewportBox(instance, param) {
                var transformPagePoint = param.transformPagePoint;
                return (0, $2Nvge.measureViewportBox)(instance, transformPagePoint);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, $9O0P4.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps1(props, prevProps, visualElement) {
                return (0, $d7Mlo.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
            }
        }
    ]);
    return HTMLVisualElement;
}((0, $eA0JA.DOMVisualElement));

});
parcelRegister("2Nvge", function(module, exports) {

$parcel$export(module.exports, "measureViewportBox", function () { return $24b56310a14011c2$export$d8718b6a7e5c624e; });

var $aq4Gp = parcelRequire("aq4Gp");

var $enKDu = parcelRequire("enKDu");
function $24b56310a14011c2$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $aq4Gp.convertBoundingBoxToBox)((0, $aq4Gp.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function $24b56310a14011c2$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    var viewportBox = $24b56310a14011c2$export$d8718b6a7e5c624e(element, transformPagePoint);
    var scroll = rootProjectionNode.scroll;
    if (scroll) {
        (0, $enKDu.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, $enKDu.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

});
parcelRegister("aq4Gp", function(module, exports) {

$parcel$export(module.exports, "convertBoundingBoxToBox", function () { return $519247f1eeefb342$export$d3955c6a8f65a36b; });
$parcel$export(module.exports, "transformBoxPoints", function () { return $519247f1eeefb342$export$21543fb75483a50; });
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $519247f1eeefb342$export$d3955c6a8f65a36b(param) {
    var top = param.top, left = param.left, right = param.right, bottom = param.bottom;
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $519247f1eeefb342$export$b6b9cd4198191a47(param) {
    var x = param.x, y = param.y;
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $519247f1eeefb342$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    var topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    var bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

});

parcelRegister("enKDu", function(module, exports) {

$parcel$export(module.exports, "translateAxis", function () { return $789dce55ace35e8c$export$a807a5ce5ebb3895; });

var $h4uEU = parcelRequire("h4uEU");

var $rGpkn = parcelRequire("rGpkn");
/**
 * Scales a point based on a factor and an originPoint
 */ function $789dce55ace35e8c$export$2290ec7febe36dd6(point, scale, originPoint) {
    var distanceFromOrigin = point - originPoint;
    var scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $789dce55ace35e8c$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $789dce55ace35e8c$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $789dce55ace35e8c$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $789dce55ace35e8c$export$e8e3a712e9ebf422(axis) {
    var translate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, scale = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, originPoint = arguments.length > 3 ? arguments[3] : void 0, boxScale = arguments.length > 4 ? arguments[4] : void 0;
    axis.min = $789dce55ace35e8c$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $789dce55ace35e8c$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $789dce55ace35e8c$export$d80074982803af5c(box, param) {
    var x = param.x, y = param.y;
    $789dce55ace35e8c$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $789dce55ace35e8c$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
var $789dce55ace35e8c$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
var $789dce55ace35e8c$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $789dce55ace35e8c$export$e2a980535c55eabb(box, treeScale, treePath) {
    var isSharedTransition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    var node;
    var delta;
    for(var i = 0; i < treeLength; i++){
        var _node_layout;
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ var visualElement = node.options.visualElement;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            $789dce55ace35e8c$export$a807a5ce5ebb3895(box.x, -node.scroll.offset.x);
            $789dce55ace35e8c$export$a807a5ce5ebb3895(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $789dce55ace35e8c$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $rGpkn.hasTransform)(node.latestValues)) $789dce55ace35e8c$export$58b16271041fbfb(box, node.latestValues, (_node_layout = node.layout) === null || _node_layout === void 0 ? void 0 : _node_layout.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $789dce55ace35e8c$var$TREE_SCALE_SNAP_MAX && treeScale.x > $789dce55ace35e8c$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $789dce55ace35e8c$var$TREE_SCALE_SNAP_MAX && treeScale.y > $789dce55ace35e8c$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $789dce55ace35e8c$export$a807a5ce5ebb3895(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $789dce55ace35e8c$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale) {
    var axisOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0.5;
    var originPoint = (0, $h4uEU.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $789dce55ace35e8c$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function $789dce55ace35e8c$var$resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $789dce55ace35e8c$export$58b16271041fbfb(box, transform, sourceBox) {
    var resolveBox = sourceBox !== null && sourceBox !== void 0 ? sourceBox : box;
    $789dce55ace35e8c$export$625f1dd140a2f5e7(box.x, $789dce55ace35e8c$var$resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    $789dce55ace35e8c$export$625f1dd140a2f5e7(box.y, $789dce55ace35e8c$var$resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}

});
parcelRegister("rGpkn", function(module, exports) {

$parcel$export(module.exports, "hasTransform", function () { return $5de747f8d84ec42f$export$a545127cf1fbb600; });
function $5de747f8d84ec42f$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $5de747f8d84ec42f$export$bdf30dca883ea463(param) {
    var scale = param.scale, scaleX = param.scaleX, scaleY = param.scaleY;
    return !$5de747f8d84ec42f$var$isIdentityScale(scale) || !$5de747f8d84ec42f$var$isIdentityScale(scaleX) || !$5de747f8d84ec42f$var$isIdentityScale(scaleY);
}
function $5de747f8d84ec42f$export$a545127cf1fbb600(values) {
    return $5de747f8d84ec42f$export$bdf30dca883ea463(values) || $5de747f8d84ec42f$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $5de747f8d84ec42f$export$bf80f5f8f4dc327f(values) {
    return $5de747f8d84ec42f$var$is2DTranslate(values.x) || $5de747f8d84ec42f$var$is2DTranslate(values.y);
}
function $5de747f8d84ec42f$var$is2DTranslate(value) {
    return value && value !== "0%";
}

});



parcelRegister("eA0JA", function(module, exports) {

$parcel$export(module.exports, "DOMVisualElement", function () { return $b8aba6cb5f407106$export$e49735c2a366bdc7; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $goUpr = parcelRequire("goUpr");

var $ejle5 = parcelRequire("ejle5");

var $alEEM = parcelRequire("alEEM");

var $hsHfm = parcelRequire("hsHfm");
var $b8aba6cb5f407106$export$e49735c2a366bdc7 = /*#__PURE__*/ function(VisualElement) {
    "use strict";
    (0, $goUpr._)(DOMVisualElement, VisualElement);
    function DOMVisualElement() {
        (0, $6vyh9._)(this, DOMVisualElement);
        var _this;
        _this = (0, $enHBd._)(this, DOMVisualElement, arguments);
        _this.KeyframeResolver = (0, $alEEM.DOMKeyframesResolver);
        return _this;
    }
    (0, $l6JfT._)(DOMVisualElement, [
        {
            key: "sortInstanceNodePosition",
            value: function sortInstanceNodePosition(a, b) {
                /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
            }
        },
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                var style = props.style;
                return style ? style[key] : undefined;
            }
        },
        {
            key: "removeValueFromRenderState",
            value: function removeValueFromRenderState(key, param) {
                var vars = param.vars, style = param.style;
                delete vars[key];
                delete style[key];
            }
        },
        {
            key: "handleChildMotionValue",
            value: function handleChildMotionValue() {
                var _this = this;
                if (this.childSubscription) {
                    this.childSubscription();
                    delete this.childSubscription;
                }
                var children = this.props.children;
                if ((0, $ejle5.isMotionValue)(children)) this.childSubscription = children.on("change", function(latest) {
                    if (_this.current) _this.current.textContent = "".concat(latest);
                });
            }
        }
    ]);
    return DOMVisualElement;
}((0, $hsHfm.VisualElement));

});
parcelRegister("alEEM", function(module, exports) {

$parcel$export(module.exports, "DOMKeyframesResolver", function () { return $d6e571bb95b0f3d8$export$4983792d11b61017; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $9t9ku = parcelRequire("9t9ku");

var $j5BSo = parcelRequire("j5BSo");

var $goUpr = parcelRequire("goUpr");

var $3GNpW = parcelRequire("3GNpW");

var $eXksG = parcelRequire("eXksG");

var $bwHVe = parcelRequire("bwHVe");

var $h6yPR = parcelRequire("h6yPR");

var $9ws7c = parcelRequire("9ws7c");

var $98YDC = parcelRequire("98YDC");

var $7lBzJ = parcelRequire("7lBzJ");

var $bGqY0 = parcelRequire("bGqY0");

var $hwzru = parcelRequire("hwzru");
var $d6e571bb95b0f3d8$export$4983792d11b61017 = /*#__PURE__*/ function(KeyframeResolver) {
    "use strict";
    (0, $goUpr._)(DOMKeyframesResolver, KeyframeResolver);
    function DOMKeyframesResolver(unresolvedKeyframes, onComplete, name, motionValue, element) {
        (0, $6vyh9._)(this, DOMKeyframesResolver);
        return (0, $enHBd._)(this, DOMKeyframesResolver, [
            unresolvedKeyframes,
            onComplete,
            name,
            motionValue,
            element,
            true
        ]);
    }
    (0, $l6JfT._)(DOMKeyframesResolver, [
        {
            key: "readKeyframes",
            value: function readKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, element = _this.element, name = _this.name;
                if (!element || !element.current) return;
                (0, $9t9ku._)((0, $j5BSo._)(DOMKeyframesResolver.prototype), "readKeyframes", this).call(this);
                /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(var i = 0; i < unresolvedKeyframes.length; i++){
                    var keyframe = unresolvedKeyframes[i];
                    if (typeof keyframe === "string") {
                        keyframe = keyframe.trim();
                        if ((0, $9ws7c.isCSSVariableToken)(keyframe)) {
                            var resolved = (0, $h6yPR.getVariableValue)(keyframe, element.current);
                            if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                            if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                        }
                    }
                }
                /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
                /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $eXksG.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
                var _unresolvedKeyframes = (0, $3GNpW._)(unresolvedKeyframes, 2), origin = _unresolvedKeyframes[0], target = _unresolvedKeyframes[1];
                var originType = (0, $bwHVe.findDimensionValueType)(origin);
                var targetType = (0, $bwHVe.findDimensionValueType)(target);
                /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ var originHasVar = (0, $9ws7c.containsCSSVariable)(origin);
                var targetHasVar = (0, $9ws7c.containsCSSVariable)(target);
                if (originHasVar !== targetHasVar && (0, $hwzru.positionalValues)[name]) {
                    this.needsMeasurement = true;
                    return;
                }
                /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
                /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $hwzru.isNumOrPxType)(originType) && (0, $hwzru.isNumOrPxType)(targetType)) for(var i1 = 0; i1 < unresolvedKeyframes.length; i1++){
                    var value = unresolvedKeyframes[i1];
                    if (typeof value === "string") unresolvedKeyframes[i1] = parseFloat(value);
                }
                else if ((0, $hwzru.positionalValues)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
            }
        },
        {
            key: "resolveNoneKeyframes",
            value: function resolveNoneKeyframes() {
                var _this = this, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                var noneKeyframeIndexes = [];
                for(var i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $7lBzJ.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
                if (noneKeyframeIndexes.length) (0, $bGqY0.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
            }
        },
        {
            key: "measureInitialState",
            value: function measureInitialState() {
                var _this = this, element = _this.element, unresolvedKeyframes = _this.unresolvedKeyframes, name = _this.name;
                if (!element || !element.current) return;
                if (name === "height") this.suspendedScrollY = window.pageYOffset;
                this.measuredOrigin = (0, $hwzru.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                unresolvedKeyframes[0] = this.measuredOrigin;
                // Set final key frame to measure after next render
                var measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
                if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
            }
        },
        {
            key: "measureEndState",
            value: function measureEndState() {
                var _this_removedTransforms;
                var _this = this, element = _this.element, name = _this.name, unresolvedKeyframes = _this.unresolvedKeyframes;
                if (!element || !element.current) return;
                var value = element.getValue(name);
                value && value.jump(this.measuredOrigin, false);
                var finalKeyframeIndex = unresolvedKeyframes.length - 1;
                var finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
                unresolvedKeyframes[finalKeyframeIndex] = (0, $hwzru.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
                if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
                // If we removed transform values, reapply them before the next render
                if ((_this_removedTransforms = this.removedTransforms) === null || _this_removedTransforms === void 0 ? void 0 : _this_removedTransforms.length) this.removedTransforms.forEach(function(param) {
                    var _param = (0, $3GNpW._)(param, 2), unsetTransformName = _param[0], unsetTransformValue = _param[1];
                    element.getValue(unsetTransformName).set(unsetTransformValue);
                });
                this.resolveNoneKeyframes();
            }
        }
    ]);
    return DOMKeyframesResolver;
}((0, $98YDC.KeyframeResolver));

});
parcelRegister("9t9ku", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6e4e0f1df1094c5a$export$71511d61b312f219; });

var $3nDLS = parcelRequire("3nDLS");
function $6e4e0f1df1094c5a$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $6e4e0f1df1094c5a$export$71511d61b312f219 = Reflect.get;
    else $6e4e0f1df1094c5a$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $3nDLS._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $6e4e0f1df1094c5a$export$71511d61b312f219(target, property, receiver || target);
}

});
parcelRegister("3nDLS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $27625ecb3190531d$export$71511d61b312f219; });

var $j5BSo = parcelRequire("j5BSo");
function $27625ecb3190531d$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $j5BSo._)(object);
        if (object === null) break;
    }
    return object;
}

});


parcelRegister("bwHVe", function(module, exports) {

$parcel$export(module.exports, "dimensionValueTypes", function () { return $f2a8bbbedb993d92$export$d176691c1998a1f5; });
$parcel$export(module.exports, "findDimensionValueType", function () { return $f2a8bbbedb993d92$export$eefdd52e3ccae428; });

var $hIznc = parcelRequire("hIznc");

var $lNDSs = parcelRequire("lNDSs");

var $lAqg3 = parcelRequire("lAqg3");

var $15GBz = parcelRequire("15GBz");
/**
 * A list of value types commonly used for dimensions
 */ var $f2a8bbbedb993d92$export$d176691c1998a1f5 = [
    (0, $lNDSs.number),
    (0, $lAqg3.px),
    (0, $lAqg3.percent),
    (0, $lAqg3.degrees),
    (0, $lAqg3.vw),
    (0, $lAqg3.vh),
    (0, $hIznc.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ var $f2a8bbbedb993d92$export$eefdd52e3ccae428 = function(v) {
    return $f2a8bbbedb993d92$export$d176691c1998a1f5.find((0, $15GBz.testValueType)(v));
};

});
parcelRegister("hIznc", function(module, exports) {

$parcel$export(module.exports, "auto", function () { return $e393db29dce6dd05$export$dfb5619354ba860; });
/**
 * ValueType for "auto"
 */ var $e393db29dce6dd05$export$dfb5619354ba860 = {
    test: function(v) {
        return v === "auto";
    },
    parse: function(v) {
        return v;
    }
};

});

parcelRegister("15GBz", function(module, exports) {

$parcel$export(module.exports, "testValueType", function () { return $a3581008b42f4b17$export$6eae4d0a6a7ca7cd; });
/**
 * Tests a provided value against a ValueType
 */ var $a3581008b42f4b17$export$6eae4d0a6a7ca7cd = function(v) {
    return function(type) {
        return type.test(v);
    };
};

});


parcelRegister("h6yPR", function(module, exports) {

$parcel$export(module.exports, "getVariableValue", function () { return $c3a2f6a48f2ae310$export$289398774300c991; });

var $3GNpW = parcelRequire("3GNpW");

var $boJRf = parcelRequire("boJRf");
var $7xdGn = parcelRequire("7xdGn");

var $9ws7c = parcelRequire("9ws7c");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ var $c3a2f6a48f2ae310$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
RegExp("^var\\(--(?:([\\w-]+)|([\\w-]+), ?([a-zA-Z\\d ()%#.,-]+))\\)", "u");
function $c3a2f6a48f2ae310$export$b9f0c1f373aee2b0(current) {
    var match = $c3a2f6a48f2ae310$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    var _match = (0, $3GNpW._)(match, 4), token1 = _match[1], token2 = _match[2], fallback = _match[3];
    return [
        "--".concat(token1 !== null && token1 !== void 0 ? token1 : token2),
        fallback
    ];
}
var $c3a2f6a48f2ae310$var$maxDepth = 4;
function $c3a2f6a48f2ae310$export$289398774300c991(current, element) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    (0, $boJRf.invariant)(depth <= $c3a2f6a48f2ae310$var$maxDepth, 'Max CSS variable fallback depth detected in property "'.concat(current, '". This may indicate a circular fallback dependency.'), "max-css-var-depth");
    var _parseCSSVariable = (0, $3GNpW._)($c3a2f6a48f2ae310$export$b9f0c1f373aee2b0(current), 2), token = _parseCSSVariable[0], fallback = _parseCSSVariable[1];
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    var resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        var trimmed = resolved.trim();
        return (0, $7xdGn.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $9ws7c.isCSSVariableToken)(fallback) ? $c3a2f6a48f2ae310$export$289398774300c991(fallback, element, depth + 1) : fallback;
}

});
parcelRegister("7xdGn", function(module, exports) {

$parcel$export(module.exports, "isNumericalString", function () { return $e46dd2d6fc6cc0c5$export$65583ed5a868f2d9; });
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var $e46dd2d6fc6cc0c5$export$65583ed5a868f2d9 = function(v) {
    return RegExp("^-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)$", "u").test(v);
};

});


parcelRegister("7lBzJ", function(module, exports) {

$parcel$export(module.exports, "isNone", function () { return $f976c586b9a3260d$export$e56af863d5645d5f; });

var $f8LTG = parcelRequire("f8LTG");
function $f976c586b9a3260d$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $f8LTG.isZeroValueString)(value);
    else return true;
}

});
parcelRegister("f8LTG", function(module, exports) {

$parcel$export(module.exports, "isZeroValueString", function () { return $f9e8a5dca70e9c5a$export$ade84c85e44a6cb1; });
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var $f9e8a5dca70e9c5a$export$ade84c85e44a6cb1 = function(v) {
    return RegExp("^0[^.\\s]+$", "u").test(v);
};

});


parcelRegister("bGqY0", function(module, exports) {

$parcel$export(module.exports, "makeNoneKeyframesAnimatable", function () { return $ad93c791fd260965$export$8cc4958f8e540f37; });

var $kBIio = parcelRequire("kBIio");

var $AeJ3c = parcelRequire("AeJ3c");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ var $ad93c791fd260965$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $ad93c791fd260965$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    var i = 0;
    var animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        var keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$ad93c791fd260965$var$invalidTemplates.has(keyframe) && (0, $kBIio.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (animatableTemplate && name) try {
        for(var _iterator = noneKeyframeIndexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var noneIndex = _step.value;
            unresolvedKeyframes[noneIndex] = (0, $AeJ3c.getAnimatableNone)(name, animatableTemplate);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

});
parcelRegister("AeJ3c", function(module, exports) {

$parcel$export(module.exports, "getAnimatableNone", function () { return $30e766647b9e029e$export$cea0cedcb94873b5; });

var $kBIio = parcelRequire("kBIio");

var $Rgyqw = parcelRequire("Rgyqw");

var $jd1uD = parcelRequire("jd1uD");

var $dXezp = parcelRequire("dXezp");
var $30e766647b9e029e$var$customTypes = /*@__PURE__*/ new Set([
    (0, $Rgyqw.filter),
    (0, $jd1uD.mask)
]);
function $30e766647b9e029e$export$cea0cedcb94873b5(key, value) {
    var defaultValueType = (0, $dXezp.getDefaultValueType)(key);
    if (!$30e766647b9e029e$var$customTypes.has(defaultValueType)) defaultValueType = (0, $kBIio.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

});
parcelRegister("Rgyqw", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $09a13e7fa3675847$export$3dea766d36a8935f; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $3GNpW = parcelRequire("3GNpW");

var $kBIio = parcelRequire("kBIio");

var $5mNJo = parcelRequire("5mNJo");
/**
 * Properties that should default to 1 or 100%
 */ var $09a13e7fa3675847$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $09a13e7fa3675847$var$applyDefaultFilter(v) {
    var _v_slice_split = (0, $3GNpW._)(v.slice(0, -1).split("("), 2), name = _v_slice_split[0], value = _v_slice_split[1];
    if (name === "drop-shadow") return v;
    var _ref = (0, $3GNpW._)(value.match((0, $5mNJo.floatRegex)) || [], 1), number = _ref[0];
    if (!number) return v;
    var unit = value.replace(number, "");
    var defaultValue = $09a13e7fa3675847$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
var $09a13e7fa3675847$var$functionRegex = RegExp("\\b([a-z-]*)\\(.*?\\)", "gu");
var $09a13e7fa3675847$export$3dea766d36a8935f = (0, $bPuui._)((0, $81JKW._)({}, (0, $kBIio.complex)), {
    getAnimatableNone: function(v) {
        var functions = v.match($09a13e7fa3675847$var$functionRegex);
        return functions ? functions.map($09a13e7fa3675847$var$applyDefaultFilter).join(" ") : v;
    }
});

});

parcelRegister("jd1uD", function(module, exports) {

$parcel$export(module.exports, "mask", function () { return $b3f0bd5e9d71bb2c$export$d99f0801a68bbcf1; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $cQSqJ = parcelRequire("cQSqJ");

var $kBIio = parcelRequire("kBIio");
var $b3f0bd5e9d71bb2c$export$d99f0801a68bbcf1 = (0, $bPuui._)((0, $81JKW._)({}, (0, $kBIio.complex)), {
    getAnimatableNone: function(v) {
        var parsed = (0, $kBIio.complex).parse(v);
        var transformer = (0, $kBIio.complex).createTransformer(v);
        return transformer(parsed.map(function(v) {
            return typeof v === "number" ? 0 : (typeof v === "undefined" ? "undefined" : (0, $cQSqJ._)(v)) === "object" ? (0, $bPuui._)((0, $81JKW._)({}, v), {
                alpha: 1
            }) : v;
        }));
    }
});

});

parcelRegister("dXezp", function(module, exports) {

$parcel$export(module.exports, "getDefaultValueType", function () { return $ca7a94ae0e2a227e$export$67d1babe0338d23b; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $4bNpx = parcelRequire("4bNpx");

var $Rgyqw = parcelRequire("Rgyqw");

var $jd1uD = parcelRequire("jd1uD");

var $10GvF = parcelRequire("10GvF");
/**
 * A map of default value types for common values
 */ var $ca7a94ae0e2a227e$export$98cd7c72c5a731fb = (0, $bPuui._)((0, $81JKW._)({}, (0, $10GvF.numberValueTypes)), {
    // Color props
    color: (0, $4bNpx.color),
    backgroundColor: (0, $4bNpx.color),
    outlineColor: (0, $4bNpx.color),
    fill: (0, $4bNpx.color),
    stroke: (0, $4bNpx.color),
    // Border props
    borderColor: (0, $4bNpx.color),
    borderTopColor: (0, $4bNpx.color),
    borderRightColor: (0, $4bNpx.color),
    borderBottomColor: (0, $4bNpx.color),
    borderLeftColor: (0, $4bNpx.color),
    filter: (0, $Rgyqw.filter),
    WebkitFilter: (0, $Rgyqw.filter),
    mask: (0, $jd1uD.mask),
    WebkitMask: (0, $jd1uD.mask)
});
/**
 * Gets the default ValueType for the provided value key
 */ var $ca7a94ae0e2a227e$export$67d1babe0338d23b = function(key) {
    return $ca7a94ae0e2a227e$export$98cd7c72c5a731fb[key];
};

});
parcelRegister("10GvF", function(module, exports) {

$parcel$export(module.exports, "numberValueTypes", function () { return $154d80d66a0a0a44$export$eec14432cd1cb67b; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $JKVVp = parcelRequire("JKVVp");

var $lNDSs = parcelRequire("lNDSs");

var $lAqg3 = parcelRequire("lAqg3");

var $7qjHd = parcelRequire("7qjHd");
var $154d80d66a0a0a44$export$eec14432cd1cb67b = (0, $bPuui._)((0, $81JKW._)({
    // Border props
    borderWidth: (0, $lAqg3.px),
    borderTopWidth: (0, $lAqg3.px),
    borderRightWidth: (0, $lAqg3.px),
    borderBottomWidth: (0, $lAqg3.px),
    borderLeftWidth: (0, $lAqg3.px),
    borderRadius: (0, $lAqg3.px),
    borderTopLeftRadius: (0, $lAqg3.px),
    borderTopRightRadius: (0, $lAqg3.px),
    borderBottomRightRadius: (0, $lAqg3.px),
    borderBottomLeftRadius: (0, $lAqg3.px),
    // Positioning props
    width: (0, $lAqg3.px),
    maxWidth: (0, $lAqg3.px),
    height: (0, $lAqg3.px),
    maxHeight: (0, $lAqg3.px),
    top: (0, $lAqg3.px),
    right: (0, $lAqg3.px),
    bottom: (0, $lAqg3.px),
    left: (0, $lAqg3.px),
    inset: (0, $lAqg3.px),
    insetBlock: (0, $lAqg3.px),
    insetBlockStart: (0, $lAqg3.px),
    insetBlockEnd: (0, $lAqg3.px),
    insetInline: (0, $lAqg3.px),
    insetInlineStart: (0, $lAqg3.px),
    insetInlineEnd: (0, $lAqg3.px),
    // Spacing props
    padding: (0, $lAqg3.px),
    paddingTop: (0, $lAqg3.px),
    paddingRight: (0, $lAqg3.px),
    paddingBottom: (0, $lAqg3.px),
    paddingLeft: (0, $lAqg3.px),
    paddingBlock: (0, $lAqg3.px),
    paddingBlockStart: (0, $lAqg3.px),
    paddingBlockEnd: (0, $lAqg3.px),
    paddingInline: (0, $lAqg3.px),
    paddingInlineStart: (0, $lAqg3.px),
    paddingInlineEnd: (0, $lAqg3.px),
    margin: (0, $lAqg3.px),
    marginTop: (0, $lAqg3.px),
    marginRight: (0, $lAqg3.px),
    marginBottom: (0, $lAqg3.px),
    marginLeft: (0, $lAqg3.px),
    marginBlock: (0, $lAqg3.px),
    marginBlockStart: (0, $lAqg3.px),
    marginBlockEnd: (0, $lAqg3.px),
    marginInline: (0, $lAqg3.px),
    marginInlineStart: (0, $lAqg3.px),
    marginInlineEnd: (0, $lAqg3.px),
    // Typography
    fontSize: (0, $lAqg3.px),
    // Misc
    backgroundPositionX: (0, $lAqg3.px),
    backgroundPositionY: (0, $lAqg3.px)
}, (0, $7qjHd.transformValueTypes)), {
    zIndex: (0, $JKVVp.int),
    // SVG
    fillOpacity: (0, $lNDSs.alpha),
    strokeOpacity: (0, $lNDSs.alpha),
    numOctaves: (0, $JKVVp.int)
});

});
parcelRegister("JKVVp", function(module, exports) {

$parcel$export(module.exports, "int", function () { return $81f6883476d8d185$export$7d260a2a5f8bc19e; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $lNDSs = parcelRequire("lNDSs");
var $81f6883476d8d185$export$7d260a2a5f8bc19e = (0, $bPuui._)((0, $81JKW._)({}, (0, $lNDSs.number)), {
    transform: Math.round
});

});

parcelRegister("7qjHd", function(module, exports) {

$parcel$export(module.exports, "transformValueTypes", function () { return $bc4e4bfedf8a4a71$export$f2e4285fee37e26; });

var $lNDSs = parcelRequire("lNDSs");

var $lAqg3 = parcelRequire("lAqg3");
var $bc4e4bfedf8a4a71$export$f2e4285fee37e26 = {
    rotate: (0, $lAqg3.degrees),
    /**
     * Internal channel for `transition.path` orientToPath. Composed onto
     * `rotate` at the transform-build sites so the user's `rotate` is
     * never read or overwritten. Not part of `transformPropOrder`.
     */ pathRotation: (0, $lAqg3.degrees),
    rotateX: (0, $lAqg3.degrees),
    rotateY: (0, $lAqg3.degrees),
    rotateZ: (0, $lAqg3.degrees),
    scale: (0, $lNDSs.scale),
    scaleX: (0, $lNDSs.scale),
    scaleY: (0, $lNDSs.scale),
    scaleZ: (0, $lNDSs.scale),
    skew: (0, $lAqg3.degrees),
    skewX: (0, $lAqg3.degrees),
    skewY: (0, $lAqg3.degrees),
    distance: (0, $lAqg3.px),
    translateX: (0, $lAqg3.px),
    translateY: (0, $lAqg3.px),
    translateZ: (0, $lAqg3.px),
    x: (0, $lAqg3.px),
    y: (0, $lAqg3.px),
    z: (0, $lAqg3.px),
    perspective: (0, $lAqg3.px),
    transformPerspective: (0, $lAqg3.px),
    opacity: (0, $lNDSs.alpha),
    originX: (0, $lAqg3.progressPercentage),
    originY: (0, $lAqg3.progressPercentage),
    originZ: (0, $lAqg3.px)
};

});






parcelRegister("hsHfm", function(module, exports) {

$parcel$export(module.exports, "VisualElement", function () { return $7d91001b297bc7c9$export$fa8b653c0f3714e5; });

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $81JKW = parcelRequire("81JKW");

var $f7oRS = parcelRequire("f7oRS");

var $e6mbt = parcelRequire("e6mbt");

var $cQSqJ = parcelRequire("cQSqJ");

var $7xdGn = parcelRequire("7xdGn");
var $f8LTG = parcelRequire("f8LTG");
var $cxm77 = parcelRequire("cxm77");
var $hIgjE = parcelRequire("hIgjE");

var $98YDC = parcelRequire("98YDC");

var $kWkWf = parcelRequire("kWkWf");

var $dwQ69 = parcelRequire("dwQ69");

var $6kujv = parcelRequire("6kujv");

var $jEChV = parcelRequire("jEChV");

var $lyiyz = parcelRequire("lyiyz");

var $4WU07 = parcelRequire("4WU07");

var $kBIio = parcelRequire("kBIio");

var $AeJ3c = parcelRequire("AeJ3c");

var $jUgxy = parcelRequire("jUgxy");

var $ejle5 = parcelRequire("ejle5");

var $aJc4O = parcelRequire("aJc4O");

var $lecAh = parcelRequire("lecAh");

var $lDJGD = parcelRequire("lDJGD");

var $86IoI = parcelRequire("86IoI");

var $kAf0j = parcelRequire("kAf0j");

var $6UGQ7 = parcelRequire("6UGQ7");

var $d5HXs = parcelRequire("d5HXs");

var $jQwB6 = parcelRequire("jQwB6");
var $7d91001b297bc7c9$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ var $7d91001b297bc7c9$var$featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function $7d91001b297bc7c9$export$8ad214844176d967(definitions) {
    $7d91001b297bc7c9$var$featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function $7d91001b297bc7c9$export$e183cb9c018608ba() {
    return $7d91001b297bc7c9$var$featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ var $7d91001b297bc7c9$export$fa8b653c0f3714e5 = /*#__PURE__*/ function() {
    "use strict";
    function VisualElement(param) {
        var _this = this;
        var parent = param.parent, props = param.props, presenceContext = param.presenceContext, reducedMotionConfig = param.reducedMotionConfig, skipAnimations = param.skipAnimations, blockInitialAnimation = param.blockInitialAnimation, visualState = param.visualState, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $6vyh9._)(this, VisualElement);
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $98YDC.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = function() {
            return _this.notify("Update", _this.latestValues);
        };
        this.render = function() {
            if (!_this.current) return;
            _this.triggerBuild();
            _this.renderInstance(_this.current, _this.renderState, _this.props.style, _this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = function() {
            var now = (0, $jEChV.time).now();
            if (_this.renderScheduledAt < now) {
                _this.renderScheduledAt = now;
                (0, $jQwB6.frame).render(_this.render, false, true);
            }
        };
        var latestValues = visualState.latestValues, renderState = visualState.renderState;
        this.latestValues = latestValues;
        this.baseTarget = (0, $81JKW._)({}, latestValues);
        this.initialValues = props.initial ? (0, $81JKW._)({}, latestValues) : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $lecAh.isControllingVariants)(props);
        this.isVariantNode = (0, $lecAh.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ var _this_scrapeMotionValuesFromProps = this.scrapeMotionValuesFromProps(props, {}, this), willChange = _this_scrapeMotionValuesFromProps.willChange, initialMotionValues = (0, $f7oRS._)(_this_scrapeMotionValuesFromProps, [
            "willChange"
        ]);
        for(var key in initialMotionValues){
            var value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $ejle5.isMotionValue)(value)) value.set(latestValues[key]);
        }
    }
    (0, $l6JfT._)(VisualElement, [
        {
            /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
                return {};
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                var _this = this;
                var _this_parent;
                /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(var key in this.initialValues){
                    var _this_values_get;
                    (_this_values_get = this.values.get(key)) === null || _this_values_get === void 0 ? void 0 : _this_values_get.jump(this.initialValues[key]);
                    this.latestValues[key] = this.initialValues[key];
                }
                this.current = instance;
                (0, $aJc4O.visualElementStore).set(instance, this);
                if (this.projection && !this.projection.instance) this.projection.mount(instance);
                if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
                this.values.forEach(function(value, key) {
                    return _this.bindToMotionValue(key, value);
                });
                /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
                else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
                else {
                    if (!(0, $d5HXs.hasReducedMotionListener).current) (0, $kAf0j.initPrefersReducedMotion)();
                    this.shouldReduceMotion = (0, $d5HXs.prefersReducedMotion).current;
                }
                var _this_skipAnimationsConfig;
                /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = (_this_skipAnimationsConfig = this.skipAnimationsConfig) !== null && _this_skipAnimationsConfig !== void 0 ? _this_skipAnimationsConfig : false;
                (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.addChild(this);
                this.update(this.props, this.presenceContext);
                this.hasBeenMounted = true;
            }
        },
        {
            key: "unmount",
            value: function unmount() {
                var _this_parent;
                this.projection && this.projection.unmount();
                (0, $jQwB6.cancelFrame)(this.notifyUpdate);
                (0, $jQwB6.cancelFrame)(this.render);
                this.valueSubscriptions.forEach(function(remove) {
                    return remove();
                });
                this.valueSubscriptions.clear();
                this.removeFromVariantTree && this.removeFromVariantTree();
                (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.removeChild(this);
                for(var key in this.events)this.events[key].clear();
                for(var key1 in this.features){
                    var feature = this.features[key1];
                    if (feature) {
                        feature.unmount();
                        feature.isMounted = false;
                    }
                }
                this.current = null;
            }
        },
        {
            key: "addChild",
            value: function addChild(child) {
                this.children.add(child);
                var _this_enteringChildren;
                (_this_enteringChildren = this.enteringChildren) !== null && _this_enteringChildren !== void 0 ? _this_enteringChildren : this.enteringChildren = new Set();
                this.enteringChildren.add(child);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child) {
                this.children.delete(child);
                this.enteringChildren && this.enteringChildren.delete(child);
            }
        },
        {
            key: "bindToMotionValue",
            value: function bindToMotionValue(key, value) {
                var _this = this;
                if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
                if (value.accelerate && (0, $dwQ69.acceleratedValues).has(key) && this.current instanceof HTMLElement) {
                    var _value_accelerate = value.accelerate, factory = _value_accelerate.factory, keyframes = _value_accelerate.keyframes, times = _value_accelerate.times, ease = _value_accelerate.ease, duration = _value_accelerate.duration;
                    var animation = new (0, $kWkWf.NativeAnimation)({
                        element: this.current,
                        name: key,
                        keyframes: keyframes,
                        times: times,
                        ease: ease,
                        duration: (0, $cxm77.secondsToMilliseconds)(duration)
                    });
                    var cleanup = factory(animation);
                    this.valueSubscriptions.set(key, function() {
                        cleanup();
                        animation.cancel();
                    });
                    return;
                }
                var valueIsTransform = (0, $lDJGD.transformProps).has(key);
                if (valueIsTransform && this.onBindTransform) this.onBindTransform();
                var removeOnChange = value.on("change", function(latestValue) {
                    _this.latestValues[key] = latestValue;
                    _this.props.onUpdate && (0, $jQwB6.frame).preRender(_this.notifyUpdate);
                    if (valueIsTransform && _this.projection) _this.projection.isTransformDirty = true;
                    _this.scheduleRender();
                });
                var removeSyncCheck;
                if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
                this.valueSubscriptions.set(key, function() {
                    removeOnChange();
                    if (removeSyncCheck) removeSyncCheck();
                // Defer to MotionValue.on("change") auto-stop so React 19 remounts
                // can resubscribe before the animation is cancelled (#3315).
                });
            }
        },
        {
            key: "sortNodePosition",
            value: function sortNodePosition(other) {
                /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
                return this.sortInstanceNodePosition(this.current, other.current);
            }
        },
        {
            key: "updateFeatures",
            value: function updateFeatures() {
                var key = "animation";
                for(key in $7d91001b297bc7c9$var$featureDefinitions){
                    var featureDefinition = $7d91001b297bc7c9$var$featureDefinitions[key];
                    if (!featureDefinition) continue;
                    var isEnabled = featureDefinition.isEnabled, FeatureConstructor = featureDefinition.Feature;
                    /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
                    /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                        var feature = this.features[key];
                        if (feature.isMounted) feature.update();
                        else {
                            feature.mount();
                            feature.isMounted = true;
                        }
                    }
                }
            }
        },
        {
            key: "triggerBuild",
            value: function triggerBuild() {
                this.build(this.renderState, this.latestValues, this.props);
            }
        },
        {
            /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ key: "measureViewportBox",
            value: function measureViewportBox() {
                return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $lyiyz.createBox)();
            }
        },
        {
            key: "getStaticValue",
            value: function getStaticValue(key) {
                return this.latestValues[key];
            }
        },
        {
            key: "setStaticValue",
            value: function setStaticValue(key, value) {
                this.latestValues[key] = value;
            }
        },
        {
            /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ key: "update",
            value: function update(props, presenceContext) {
                if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
                this.prevProps = this.props;
                this.props = props;
                this.prevPresenceContext = this.presenceContext;
                this.presenceContext = presenceContext;
                /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(var i = 0; i < $7d91001b297bc7c9$var$propEventHandlers.length; i++){
                    var key = $7d91001b297bc7c9$var$propEventHandlers[i];
                    if (this.propEventSubscriptions[key]) {
                        this.propEventSubscriptions[key]();
                        delete this.propEventSubscriptions[key];
                    }
                    var listenerName = "on" + key;
                    var listener = props[listenerName];
                    if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
                }
                this.prevMotionValues = (0, $86IoI.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
                if (this.handleChildMotionValue) this.handleChildMotionValue();
            }
        },
        {
            key: "getProps",
            value: function getProps() {
                return this.props;
            }
        },
        {
            /**
     * Returns the variant definition with a given name.
     */ key: "getVariant",
            value: function getVariant(name) {
                return this.props.variants ? this.props.variants[name] : undefined;
            }
        },
        {
            /**
     * Returns the defined default transition on this component.
     */ key: "getDefaultTransition",
            value: function getDefaultTransition() {
                return this.props.transition;
            }
        },
        {
            key: "getTransformPagePoint",
            value: function getTransformPagePoint() {
                return this.props.transformPagePoint;
            }
        },
        {
            key: "getClosestVariantNode",
            value: function getClosestVariantNode() {
                return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
            }
        },
        {
            /**
     * Add a child visual element to our set of children.
     */ key: "addVariantChild",
            value: function addVariantChild(child) {
                var closestVariantNode = this.getClosestVariantNode();
                if (closestVariantNode) {
                    closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
                    return function() {
                        return closestVariantNode.variantChildren.delete(child);
                    };
                }
            }
        },
        {
            /**
     * Add a motion value and bind it to this visual element.
     */ key: "addValue",
            value: function addValue(key, value) {
                // Remove existing value if it exists
                var existingValue = this.values.get(key);
                if (value !== existingValue) {
                    if (existingValue) this.removeValue(key);
                    this.bindToMotionValue(key, value);
                    this.values.set(key, value);
                    this.latestValues[key] = value.get();
                }
            }
        },
        {
            /**
     * Remove a motion value and unbind any active subscriptions.
     */ key: "removeValue",
            value: function removeValue(key) {
                this.values.delete(key);
                var unsubscribe = this.valueSubscriptions.get(key);
                if (unsubscribe) {
                    unsubscribe();
                    this.valueSubscriptions.delete(key);
                }
                delete this.latestValues[key];
                this.removeValueFromRenderState(key, this.renderState);
            }
        },
        {
            /**
     * Check whether we have a motion value for this key
     */ key: "hasValue",
            value: function hasValue(key) {
                return this.values.has(key);
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (this.props.values && this.props.values[key]) return this.props.values[key];
                var value = this.values.get(key);
                if (value === undefined && defaultValue !== undefined) {
                    value = (0, $4WU07.motionValue)(defaultValue === null ? undefined : defaultValue, {
                        owner: this
                    });
                    this.addValue(key, value);
                }
                return value;
            }
        },
        {
            /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ key: "readValue",
            value: function readValue(key, target) {
                var _this_getBaseTargetFromProps;
                var value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_this_getBaseTargetFromProps = this.getBaseTargetFromProps(this.props, key)) !== null && _this_getBaseTargetFromProps !== void 0 ? _this_getBaseTargetFromProps : this.readValueFromInstance(this.current, key, this.options);
                if (value !== undefined && value !== null) {
                    if (typeof value === "string" && ((0, $7xdGn.isNumericalString)(value) || (0, $f8LTG.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
                    value = parseFloat(value);
                    else if (!(0, $jUgxy.findValueType)(value) && (0, $kBIio.complex).test(target)) value = (0, $AeJ3c.getAnimatableNone)(key, target);
                    this.setBaseTarget(key, (0, $ejle5.isMotionValue)(value) ? value.get() : value);
                }
                return (0, $ejle5.isMotionValue)(value) ? value.get() : value;
            }
        },
        {
            /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ key: "setBaseTarget",
            value: function setBaseTarget(key, value) {
                this.baseTarget[key] = value;
            }
        },
        {
            /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ key: "getBaseTarget",
            value: function getBaseTarget(key) {
                var initial = this.props.initial;
                var valueFromInitial;
                if (typeof initial === "string" || (typeof initial === "undefined" ? "undefined" : (0, $cQSqJ._)(initial)) === "object") {
                    var _this_presenceContext;
                    var variant = (0, $6UGQ7.resolveVariantFromProps)(this.props, initial, (_this_presenceContext = this.presenceContext) === null || _this_presenceContext === void 0 ? void 0 : _this_presenceContext.custom);
                    if (variant) valueFromInitial = variant[key];
                }
                /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
                /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ var target = this.getBaseTargetFromProps(this.props, key);
                if (target !== undefined && !(0, $ejle5.isMotionValue)(target)) return target;
                /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
            }
        },
        {
            key: "on",
            value: function on(eventName, callback) {
                if (!this.events[eventName]) this.events[eventName] = new (0, $hIgjE.SubscriptionManager)();
                return this.events[eventName].add(callback);
            }
        },
        {
            key: "notify",
            value: function notify(eventName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _this_events_eventName;
                if (this.events[eventName]) (_this_events_eventName = this.events[eventName]).notify.apply(_this_events_eventName, (0, $e6mbt._)(args));
            }
        },
        {
            key: "scheduleRenderMicrotask",
            value: function scheduleRenderMicrotask() {
                (0, $6kujv.microtask).render(this.render);
            }
        }
    ]);
    return VisualElement;
}();

});
parcelRegister("6kujv", function(module, exports) {

$parcel$export(module.exports, "microtask", function () { return $1ab162b726141312$export$bb76eed83315504c; });

var $7HpLF = parcelRequire("7HpLF");
var /* @__PURE__ */ $1ab162b726141312$var$_createRenderBatcher = (0, $7HpLF.createRenderBatcher)(queueMicrotask, false), $1ab162b726141312$export$bb76eed83315504c = $1ab162b726141312$var$_createRenderBatcher.schedule, $1ab162b726141312$export$3252729004b8456e = $1ab162b726141312$var$_createRenderBatcher.cancel;

});

parcelRegister("lyiyz", function(module, exports) {

$parcel$export(module.exports, "createBox", function () { return $84920b181ccb2452$export$6459fc9e86be362e; });
var $84920b181ccb2452$export$ff25708b37f72782 = function() {
    return {
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    };
};
var $84920b181ccb2452$export$3d227df54007d73a = function() {
    return {
        x: $84920b181ccb2452$export$ff25708b37f72782(),
        y: $84920b181ccb2452$export$ff25708b37f72782()
    };
};
var $84920b181ccb2452$export$6db76765312617ac = function() {
    return {
        min: 0,
        max: 0
    };
};
var $84920b181ccb2452$export$6459fc9e86be362e = function() {
    return {
        x: $84920b181ccb2452$export$6db76765312617ac(),
        y: $84920b181ccb2452$export$6db76765312617ac()
    };
};

});

parcelRegister("jUgxy", function(module, exports) {

$parcel$export(module.exports, "findValueType", function () { return $cddc2095205a1f34$export$950e7e59ea1ffed7; });

var $e6mbt = parcelRequire("e6mbt");

var $4bNpx = parcelRequire("4bNpx");

var $kBIio = parcelRequire("kBIio");

var $bwHVe = parcelRequire("bwHVe");

var $15GBz = parcelRequire("15GBz");
/**
 * A list of all ValueTypes
 */ var $cddc2095205a1f34$var$valueTypes = (0, $e6mbt._)((0, $bwHVe.dimensionValueTypes)).concat([
    (0, $4bNpx.color),
    (0, $kBIio.complex)
]);
/**
 * Tests a value against the list of ValueTypes
 */ var $cddc2095205a1f34$export$950e7e59ea1ffed7 = function(v) {
    return $cddc2095205a1f34$var$valueTypes.find((0, $15GBz.testValueType)(v));
};

});

parcelRegister("lecAh", function(module, exports) {

$parcel$export(module.exports, "isControllingVariants", function () { return $8fab13e6c6c6614e$export$4b3c3bd8d910d78d; });
$parcel$export(module.exports, "isVariantNode", function () { return $8fab13e6c6c6614e$export$ce46fa4165cdec40; });

var $9r2Xu = parcelRequire("9r2Xu");

var $6qGU3 = parcelRequire("6qGU3");

var $ka8Fn = parcelRequire("ka8Fn");
function $8fab13e6c6c6614e$export$4b3c3bd8d910d78d(props) {
    return (0, $9r2Xu.isAnimationControls)(props.animate) || (0, $ka8Fn.variantProps).some(function(name) {
        return (0, $6qGU3.isVariantLabel)(props[name]);
    });
}
function $8fab13e6c6c6614e$export$ce46fa4165cdec40(props) {
    return Boolean($8fab13e6c6c6614e$export$4b3c3bd8d910d78d(props) || props.variants);
}

});
parcelRegister("9r2Xu", function(module, exports) {

$parcel$export(module.exports, "isAnimationControls", function () { return $b19704b623367c46$export$aa71198ceeaf53ce; });

var $cQSqJ = parcelRequire("cQSqJ");
function $b19704b623367c46$export$aa71198ceeaf53ce(v) {
    return v !== null && (typeof v === "undefined" ? "undefined" : (0, $cQSqJ._)(v)) === "object" && typeof v.start === "function";
}

});

parcelRegister("6qGU3", function(module, exports) {

$parcel$export(module.exports, "isVariantLabel", function () { return $e251841023c59dbb$export$720b90e312cea233; });
/**
 * Decides if the supplied variable is variant label
 */ function $e251841023c59dbb$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}

});

parcelRegister("ka8Fn", function(module, exports) {

$parcel$export(module.exports, "variantProps", function () { return $7a7c06dcfc1ab12e$export$1405a65085f40b9; });

var $e6mbt = parcelRequire("e6mbt");
var $7a7c06dcfc1ab12e$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
var $7a7c06dcfc1ab12e$export$1405a65085f40b9 = [
    "initial"
].concat((0, $e6mbt._)($7a7c06dcfc1ab12e$export$16e45afcc206d3a8));

});


parcelRegister("86IoI", function(module, exports) {

$parcel$export(module.exports, "updateMotionValuesFromProps", function () { return $e748920697f3a310$export$9a552858d5197f6e; });

var $4WU07 = parcelRequire("4WU07");

var $ejle5 = parcelRequire("ejle5");
/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function $e748920697f3a310$export$9a552858d5197f6e(element, next, prev) {
    for(var key in next){
        var nextValue = next[key];
        var prevValue = prev[key];
        if ((0, $ejle5.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $ejle5.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $4WU07.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                var existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                var latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $4WU07.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(var key1 in prev)if (next[key1] === undefined) element.removeValue(key1);
    return next;
}

});

parcelRegister("kAf0j", function(module, exports) {

$parcel$export(module.exports, "initPrefersReducedMotion", function () { return $1f7506d637ef20fc$export$ca9f41fb23dded3d; });

var $d5HXs = parcelRequire("d5HXs");
var $1f7506d637ef20fc$var$isBrowser = typeof window !== "undefined";
function $1f7506d637ef20fc$export$ca9f41fb23dded3d() {
    (0, $d5HXs.hasReducedMotionListener).current = true;
    if (!$1f7506d637ef20fc$var$isBrowser) return;
    if (window.matchMedia) {
        var motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        var setReducedMotionPreferences = function() {
            return (0, $d5HXs.prefersReducedMotion).current = motionMediaQuery.matches;
        };
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $d5HXs.prefersReducedMotion).current = false;
}

});
parcelRegister("d5HXs", function(module, exports) {

$parcel$export(module.exports, "prefersReducedMotion", function () { return $2271c3737655c93c$export$ff7706047246b98b; });
$parcel$export(module.exports, "hasReducedMotionListener", function () { return $2271c3737655c93c$export$6476d16e2fd2d0db; });
// Does this device prefer reduced motion? Returns `null` server-side.
var $2271c3737655c93c$export$ff7706047246b98b = {
    current: null
};
var $2271c3737655c93c$export$6476d16e2fd2d0db = {
    current: false
};

});




parcelRegister("9O0P4", function(module, exports) {

$parcel$export(module.exports, "buildHTMLStyles", function () { return $fb5d916c9f1ce7a7$export$bb517f8b40f8e99d; });

var $UwawC = parcelRequire("UwawC");

var $10GvF = parcelRequire("10GvF");

var $lDJGD = parcelRequire("lDJGD");

var $9ws7c = parcelRequire("9ws7c");

var $762vf = parcelRequire("762vf");
function $fb5d916c9f1ce7a7$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    var style = state.style, vars = state.vars, transformOrigin = state.transformOrigin;
    // Track whether we encounter any transform or transformOrigin values.
    var hasTransform = false;
    var hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(var key in latestValues){
        var value = latestValues[key];
        if ((0, $lDJGD.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $9ws7c.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            var valueAsType = (0, $UwawC.getValueAsType)(value, (0, $10GvF.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $762vf.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        var _transformOrigin_originX = transformOrigin.originX, originX = _transformOrigin_originX === void 0 ? "50%" : _transformOrigin_originX, _transformOrigin_originY = transformOrigin.originY, originY = _transformOrigin_originY === void 0 ? "50%" : _transformOrigin_originY, _transformOrigin_originZ = transformOrigin.originZ, originZ = _transformOrigin_originZ === void 0 ? 0 : _transformOrigin_originZ;
        style.transformOrigin = "".concat(originX, " ").concat(originY, " ").concat(originZ);
    }
}

});
parcelRegister("UwawC", function(module, exports) {

$parcel$export(module.exports, "getValueAsType", function () { return $1b20dbb8a7af03e0$export$453ef540a9a1bd6b; });
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var $1b20dbb8a7af03e0$export$453ef540a9a1bd6b = function(value, type) {
    return type && typeof value === "number" ? type.transform(value) : value;
};

});

parcelRegister("762vf", function(module, exports) {

$parcel$export(module.exports, "buildTransform", function () { return $b5eb8a96655dc55f$export$bdc96e0d5c8f914; });

var $UwawC = parcelRequire("UwawC");

var $10GvF = parcelRequire("10GvF");

var $lDJGD = parcelRequire("lDJGD");
var $b5eb8a96655dc55f$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
var $b5eb8a96655dc55f$var$numTransforms = (0, $lDJGD.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $b5eb8a96655dc55f$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    var transformString = "";
    var transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(var i = 0; i < $b5eb8a96655dc55f$var$numTransforms; i++){
        var key = (0, $lDJGD.transformPropOrder)[i];
        var value = latestValues[key];
        if (value === undefined) continue;
        var valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            var parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            var valueAsType = (0, $UwawC.getValueAsType)(value, (0, $10GvF.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                var transformName = $b5eb8a96655dc55f$var$translateAlias[key] || key;
                transformString += "".concat(transformName, "(").concat(valueAsType, ") ");
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    // `pathRotation` composes onto `rotate` as a separate additive term so
    // the user's `rotate` is never clobbered. Deliberately not a slot in
    // `transformPropOrder`.
    var pathRotation = latestValues.pathRotation;
    if (pathRotation) {
        transformIsDefault = false;
        transformString += "rotate(".concat((0, $UwawC.getValueAsType)(pathRotation, (0, $10GvF.numberValueTypes).pathRotation), ") ");
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

});


parcelRegister("6j8zo", function(module, exports) {

$parcel$export(module.exports, "renderHTML", function () { return $3005207eb2242fa5$export$1a32bf6229c258c0; });
function $3005207eb2242fa5$export$1a32bf6229c258c0(element, param, styleProp, projection) {
    var style = param.style, vars = param.vars;
    var elementStyle = element.style;
    var key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection === null || projection === void 0 ? void 0 : projection.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}

});

parcelRegister("d7Mlo", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $56511320465ef736$export$16da615486abaa45; });

var $ejle5 = parcelRequire("ejle5");

var $8dNm2 = parcelRequire("8dNm2");
function $56511320465ef736$export$16da615486abaa45(props, prevProps, visualElement) {
    var _visualElement_getValue;
    var style = props.style;
    var prevStyle = prevProps === null || prevProps === void 0 ? void 0 : prevProps.style;
    var newValues = {};
    if (!style) return newValues;
    for(var key in style)if ((0, $ejle5.isMotionValue)(style[key]) || prevStyle && (0, $ejle5.isMotionValue)(prevStyle[key]) || (0, $8dNm2.isForcedMotionValue)(key, props) || (visualElement === null || visualElement === void 0 ? void 0 : (_visualElement_getValue = visualElement.getValue(key)) === null || _visualElement_getValue === void 0 ? void 0 : _visualElement_getValue.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}

});
parcelRegister("8dNm2", function(module, exports) {

$parcel$export(module.exports, "isForcedMotionValue", function () { return $6b56ecbff775b626$export$6d27ce8e3de1c3cf; });

var $lDJGD = parcelRequire("lDJGD");

var $hgOkG = parcelRequire("hgOkG");
function $6b56ecbff775b626$export$6d27ce8e3de1c3cf(key, param) {
    var layout = param.layout, layoutId = param.layoutId;
    return (0, $lDJGD.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $hgOkG.scaleCorrectors)[key] || key === "opacity");
}

});
parcelRegister("hgOkG", function(module, exports) {

$parcel$export(module.exports, "scaleCorrectors", function () { return $4b6130577bb4cfde$export$91ddd985b97788d1; });

var $81JKW = parcelRequire("81JKW");

var $bPuui = parcelRequire("bPuui");

var $9ws7c = parcelRequire("9ws7c");

var $32aV4 = parcelRequire("32aV4");

var $96oJU = parcelRequire("96oJU");
var $4b6130577bb4cfde$export$91ddd985b97788d1 = {
    borderRadius: (0, $bPuui._)((0, $81JKW._)({}, (0, $32aV4.correctBorderRadius)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $32aV4.correctBorderRadius),
    borderTopRightRadius: (0, $32aV4.correctBorderRadius),
    borderBottomLeftRadius: (0, $32aV4.correctBorderRadius),
    borderBottomRightRadius: (0, $32aV4.correctBorderRadius),
    boxShadow: (0, $96oJU.correctBoxShadow)
};
function $4b6130577bb4cfde$export$de9e7791c71225fd(correctors) {
    for(var key in correctors){
        $4b6130577bb4cfde$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $9ws7c.isCSSVariableName)(key)) $4b6130577bb4cfde$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}

});
parcelRegister("32aV4", function(module, exports) {

$parcel$export(module.exports, "correctBorderRadius", function () { return $c7d268252bee6a02$export$5eafb6257a5844c; });

var $lAqg3 = parcelRequire("lAqg3");
function $c7d268252bee6a02$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ var $c7d268252bee6a02$export$5eafb6257a5844c = {
    correct: function(latest, node) {
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $lAqg3.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ var x = $c7d268252bee6a02$export$fafff692be55225d(latest, node.target.x);
        var y = $c7d268252bee6a02$export$fafff692be55225d(latest, node.target.y);
        return "".concat(x, "% ").concat(y, "%");
    }
};

});

parcelRegister("96oJU", function(module, exports) {

$parcel$export(module.exports, "correctBoxShadow", function () { return $b77ac03fe55b7780$export$eb0bc629e74dcf8; });

var $kBIio = parcelRequire("kBIio");

var $h4uEU = parcelRequire("h4uEU");
var $b77ac03fe55b7780$export$eb0bc629e74dcf8 = {
    correct: function(latest, param) {
        var treeScale = param.treeScale, projectionDelta = param.projectionDelta;
        var original = latest;
        var shadow = (0, $kBIio.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        var template = (0, $kBIio.complex).createTransformer(latest);
        var offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        var xScale = projectionDelta.x.scale * treeScale.x;
        var yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ var averageScale = (0, $h4uEU.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

});





parcelRegister("6sW40", function(module, exports) {

$parcel$export(module.exports, "isSVGElement", function () { return $27f6a70ce6495c25$export$17eda790a720ec57; });

var $4RtNq = parcelRequire("4RtNq");
/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $27f6a70ce6495c25$export$17eda790a720ec57(element) {
    return (0, $4RtNq.isObject)(element) && "ownerSVGElement" in element;
}

});
parcelRegister("4RtNq", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $284c9baa07252ea3$export$a6cdc56e425d0d0a; });

var $cQSqJ = parcelRequire("cQSqJ");
var $284c9baa07252ea3$export$a6cdc56e425d0d0a = function(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $cQSqJ._)(value)) === "object" && value !== null;
};

});


parcelRegister("4WdoH", function(module, exports) {

$parcel$export(module.exports, "isSVGSVGElement", function () { return $76cad0e5a3fa700d$export$66957ea77182581d; });

var $6sW40 = parcelRequire("6sW40");
/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $76cad0e5a3fa700d$export$66957ea77182581d(element) {
    return (0, $6sW40.isSVGElement)(element) && element.tagName === "svg";
}

});

parcelRegister("iPlTo", function(module, exports) {

$parcel$export(module.exports, "ObjectVisualElement", function () { return $5be2f1d8dcd0df29$export$fe67a5eca4e986d6; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $goUpr = parcelRequire("goUpr");

var $lyiyz = parcelRequire("lyiyz");

var $hsHfm = parcelRequire("hsHfm");
function $5be2f1d8dcd0df29$var$isObjectKey(key, object) {
    return key in object;
}
var $5be2f1d8dcd0df29$export$fe67a5eca4e986d6 = /*#__PURE__*/ function(VisualElement) {
    "use strict";
    (0, $goUpr._)(ObjectVisualElement, VisualElement);
    function ObjectVisualElement() {
        (0, $6vyh9._)(this, ObjectVisualElement);
        var _this;
        _this = (0, $enHBd._)(this, ObjectVisualElement, arguments);
        _this.type = "object";
        return _this;
    }
    (0, $l6JfT._)(ObjectVisualElement, [
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                if ($5be2f1d8dcd0df29$var$isObjectKey(key, instance)) {
                    var value = instance[key];
                    if (typeof value === "string" || typeof value === "number") return value;
                }
                return undefined;
            }
        },
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps() {
                return undefined;
            }
        },
        {
            key: "removeValueFromRenderState",
            value: function removeValueFromRenderState(key, renderState) {
                delete renderState.output[key];
            }
        },
        {
            key: "measureInstanceViewportBox",
            value: function measureInstanceViewportBox() {
                return (0, $lyiyz.createBox)();
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues) {
                Object.assign(renderState.output, latestValues);
            }
        },
        {
            key: "renderInstance",
            value: function renderInstance(instance, param) {
                var output = param.output;
                Object.assign(instance, output);
            }
        },
        {
            key: "sortInstanceNodePosition",
            value: function sortInstanceNodePosition() {
                return 0;
            }
        }
    ]);
    return ObjectVisualElement;
}((0, $hsHfm.VisualElement));

});

parcelRegister("eTeMd", function(module, exports) {

$parcel$export(module.exports, "SVGVisualElement", function () { return $cd550017da57253c$export$86bcdffbaf733d84; });

var $enHBd = parcelRequire("enHBd");

var $6vyh9 = parcelRequire("6vyh9");

var $l6JfT = parcelRequire("l6JfT");

var $9t9ku = parcelRequire("9t9ku");

var $j5BSo = parcelRequire("j5BSo");

var $goUpr = parcelRequire("goUpr");

var $lDJGD = parcelRequire("lDJGD");

var $dXezp = parcelRequire("dXezp");

var $lyiyz = parcelRequire("lyiyz");

var $eA0JA = parcelRequire("eA0JA");

var $3TqEi = parcelRequire("3TqEi");

var $7d8ki = parcelRequire("7d8ki");

var $3R8CT = parcelRequire("3R8CT");

var $gqkvU = parcelRequire("gqkvU");

var $wuHVD = parcelRequire("wuHVD");

var $iGi4Q = parcelRequire("iGi4Q");
var $cd550017da57253c$export$86bcdffbaf733d84 = /*#__PURE__*/ function(DOMVisualElement) {
    "use strict";
    (0, $goUpr._)(SVGVisualElement, DOMVisualElement);
    function SVGVisualElement() {
        (0, $6vyh9._)(this, SVGVisualElement);
        var _this;
        _this = (0, $enHBd._)(this, SVGVisualElement, arguments);
        _this.type = "svg";
        _this.isSVGTag = false;
        _this.measureInstanceViewportBox = (0, $lyiyz.createBox);
        return _this;
    }
    (0, $l6JfT._)(SVGVisualElement, [
        {
            key: "getBaseTargetFromProps",
            value: function getBaseTargetFromProps(props, key) {
                return props[key];
            }
        },
        {
            key: "readValueFromInstance",
            value: function readValueFromInstance(instance, key) {
                if ((0, $lDJGD.transformProps).has(key)) {
                    var defaultType = (0, $dXezp.getDefaultValueType)(key);
                    return defaultType ? defaultType.default || 0 : 0;
                }
                key = !(0, $3R8CT.camelCaseAttributes).has(key) ? (0, $3TqEi.camelToDash)(key) : key;
                return instance.getAttribute(key);
            }
        },
        {
            key: "scrapeMotionValuesFromProps",
            value: function scrapeMotionValuesFromProps1(props, prevProps, visualElement) {
                return (0, $iGi4Q.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
            }
        },
        {
            key: "build",
            value: function build(renderState, latestValues, props) {
                (0, $7d8ki.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
            }
        },
        {
            key: "renderInstance",
            value: function renderInstance(instance, renderState, styleProp, projection) {
                (0, $wuHVD.renderSVG)(instance, renderState, styleProp, projection);
            }
        },
        {
            key: "mount",
            value: function mount(instance) {
                this.isSVGTag = (0, $gqkvU.isSVGTag)(instance.tagName);
                (0, $9t9ku._)((0, $j5BSo._)(SVGVisualElement.prototype), "mount", this).call(this, instance);
            }
        }
    ]);
    return SVGVisualElement;
}((0, $eA0JA.DOMVisualElement));

});
parcelRegister("7d8ki", function(module, exports) {

$parcel$export(module.exports, "buildSVGAttrs", function () { return $c6b6771576253ab6$export$5475d24f125d7053; });

var $f7oRS = parcelRequire("f7oRS");

var $9O0P4 = parcelRequire("9O0P4");

var $ezMhr = parcelRequire("ezMhr");
/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ var $c6b6771576253ab6$var$cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $c6b6771576253ab6$export$5475d24f125d7053(state, _param, isSVGTag, transformTemplate, styleProp) {
    var attrX = _param.attrX, attrY = _param.attrY, attrScale = _param.attrScale, pathLength = _param.pathLength, _param_pathSpacing = _param.pathSpacing, pathSpacing = _param_pathSpacing === void 0 ? 1 : _param_pathSpacing, _param_pathOffset = _param.pathOffset, pathOffset = _param_pathOffset === void 0 ? 0 : _param_pathOffset, latest = (0, $f7oRS._)(_param, [
        "attrX",
        "attrY",
        "attrScale",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $9O0P4.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    var attrs = state.attrs, style = state.style;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        var _attrs_transformOrigin;
        style.transformOrigin = (_attrs_transformOrigin = attrs.transformOrigin) !== null && _attrs_transformOrigin !== void 0 ? _attrs_transformOrigin : "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        var _styleProp_transformBox;
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = (_styleProp_transformBox = styleProp === null || styleProp === void 0 ? void 0 : styleProp.transformBox) !== null && _styleProp_transformBox !== void 0 ? _styleProp_transformBox : "fill-box";
        delete attrs.transformBox;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $c6b6771576253ab6$var$cssMotionPathProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (attrs[key] !== undefined) {
                style[key] = attrs[key];
                delete attrs[key];
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $ezMhr.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

});
parcelRegister("ezMhr", function(module, exports) {

$parcel$export(module.exports, "buildSVGPath", function () { return $94b2cf5064c9242a$export$311b43f666da1d82; });
var $94b2cf5064c9242a$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
var $94b2cf5064c9242a$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function $94b2cf5064c9242a$export$311b43f666da1d82(attrs, length) {
    var spacing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, offset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, useDashCase = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    var keys = useDashCase ? $94b2cf5064c9242a$var$dashKeys : $94b2cf5064c9242a$var$camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = "".concat(-offset);
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = "".concat(length, " ").concat(spacing);
}

});


parcelRegister("3R8CT", function(module, exports) {

$parcel$export(module.exports, "camelCaseAttributes", function () { return $8b908c51d78e5e94$export$28931db5d57958e5; });
/**
 * A set of attribute names that are always read/written as camel case.
 */ var $8b908c51d78e5e94$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

});

parcelRegister("gqkvU", function(module, exports) {

$parcel$export(module.exports, "isSVGTag", function () { return $a9091b5f46d658cf$export$6328ce7565ea1049; });
var $a9091b5f46d658cf$export$6328ce7565ea1049 = function(tag) {
    return typeof tag === "string" && tag.toLowerCase() === "svg";
};

});

parcelRegister("wuHVD", function(module, exports) {

$parcel$export(module.exports, "renderSVG", function () { return $2826f62ca765a8e1$export$c5f8399d19a7394b; });

var $3TqEi = parcelRequire("3TqEi");

var $6j8zo = parcelRequire("6j8zo");

var $3R8CT = parcelRequire("3R8CT");
function $2826f62ca765a8e1$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $6j8zo.renderHTML)(element, renderState, undefined, projection);
    for(var key in renderState.attrs)element.setAttribute(!(0, $3R8CT.camelCaseAttributes).has(key) ? (0, $3TqEi.camelToDash)(key) : key, renderState.attrs[key]);
}

});

parcelRegister("iGi4Q", function(module, exports) {

$parcel$export(module.exports, "scrapeMotionValuesFromProps", function () { return $99927811302164ea$export$16da615486abaa45; });

var $ejle5 = parcelRequire("ejle5");

var $lDJGD = parcelRequire("lDJGD");

var $d7Mlo = parcelRequire("d7Mlo");
function $99927811302164ea$export$16da615486abaa45(props, prevProps, visualElement) {
    var newValues = (0, $d7Mlo.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(var key in props)if ((0, $ejle5.isMotionValue)(props[key]) || (0, $ejle5.isMotionValue)(prevProps[key])) {
        var targetKey = (0, $lDJGD.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

});






parcelRegister("ddUPS", function(module, exports) {

$parcel$export(module.exports, "rafThrottle", function () { return $9a0893a85dde1732$export$3d232af6e6cfbfaf; });
$parcel$export(module.exports, "debounce", function () { return $9a0893a85dde1732$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "uniqueId", function () { return $9a0893a85dde1732$export$8b15d37bc3f197d4; });
$parcel$export(module.exports, "isExternalUrl", function () { return $9a0893a85dde1732$export$78234eee43b97e81; });
$parcel$export(module.exports, "fileExtensionFromUrl", function () { return $9a0893a85dde1732$export$c00a32c882a0d2bc; });
$parcel$export(module.exports, "deliberateTarget", function () { return $9a0893a85dde1732$export$95f58b1a47688891; });
$parcel$export(module.exports, "getCookie", function () { return $9a0893a85dde1732$export$4be65e66cfa2648a; });
/**
 * @file Shared cross-cutting JS helpers.
 */ /**
 * Wrap a function so it runs at most once per animation frame.
 *
 * Ideal for high-frequency events that trigger layout reads/writes
 * (resize, scroll): calls arriving within the same frame collapse into a
 * single invocation, avoiding layout thrash. The wrapper always runs with
 * the arguments of the most recent call.
 *
 * @param {Function} fn
 *   The function to throttle.
 * @returns {Function}
 *   The throttled wrapper.
 */ 
var $e6mbt = parcelRequire("e6mbt");
function $9a0893a85dde1732$export$3d232af6e6cfbfaf(fn) {
    var frame = null;
    var lastArgs = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        lastArgs = args;
        if (frame !== null) return;
        frame = requestAnimationFrame(function() {
            frame = null;
            fn.apply(void 0, (0, $e6mbt._)(lastArgs));
        });
    };
}
function $9a0893a85dde1732$export$61fc7d43ac8f84b0(fn, wait) {
    var timer;
    return function debounced() {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timer);
        timer = window.setTimeout(function() {
            return fn.apply(_this, args);
        }, wait);
    };
}
/**
 * Returns a document-unique id with the given prefix.
 *
 * ARIA wiring needs ids — `aria-controls`, `aria-activedescendant`,
 * `aria-describedby` all reference one — so any component building a listbox or
 * a hint has to mint them. Each such component used to keep its own counter at
 * module scope; one counter shared across the theme cannot collide even if two
 * components ever pick the same prefix.
 *
 * @param {string} prefix - Prefix describing what the element is.
 * @returns {string} The id, e.g. "search-ac-3".
 */ var $9a0893a85dde1732$var$idCounter = 0;
function $9a0893a85dde1732$export$8b15d37bc3f197d4(prefix) {
    $9a0893a85dde1732$var$idCounter += 1;
    return "".concat(prefix, "-").concat($9a0893a85dde1732$var$idCounter);
}
function $9a0893a85dde1732$export$78234eee43b97e81(url) {
    try {
        var target = new URL(url, window.location.href);
        if (target.protocol !== "https:" && target.protocol !== "http:") return false;
        return target.hostname !== window.location.hostname;
    } catch (e) {
        return false;
    }
}
function $9a0893a85dde1732$export$c00a32c882a0d2bc(url) {
    try {
        var target = new URL(url, window.location.href);
        if (target.protocol !== "https:" && target.protocol !== "http:") return null;
        var match = target.pathname.match(/\.([a-z0-9]+)$/i);
        return match ? match[1].toLowerCase() : null;
    } catch (e) {
        return null;
    }
}
function $9a0893a85dde1732$export$95f58b1a47688891(link) {
    var target = (link.getAttribute("target") || "").trim();
    return target === "" || target === "_self" ? null : target;
}
function $9a0893a85dde1732$export$4be65e66cfa2648a(name) {
    var escaped = name.replace(/([.*+?^${}()|[\]\\])/g, "\\$1");
    var match = document.cookie.match(new RegExp("(?:^|;\\s*)" + escaped + "=([^;]*)"));
    return match ? decodeURIComponent(match[1]) : null;
}

});

parcelRegister("iyHu2", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("andBP"))($parcel$resolve("80w6d")),
    (parcelRequire("34sDy"))($parcel$resolve("aeWLv")),
    (parcelRequire("34sDy"))($parcel$resolve("fVYx9"))
]).then(function() {
    return parcelRequire('3YmOf');
});

});
parcelRegister("andBP", function(module, exports) {
"use strict";

var $eZGXe = parcelRequire("eZGXe");
module.exports = $eZGXe(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("eZGXe", function(module, exports) {
"use strict";
var $aea8150f0ad1d89a$var$cachedBundles = {};
var $aea8150f0ad1d89a$var$cachedPreloads = {};
var $aea8150f0ad1d89a$var$cachedPrefetches = {};
function $aea8150f0ad1d89a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $aea8150f0ad1d89a$var$cachedPreloads;
        case 'prefetch':
            return $aea8150f0ad1d89a$var$cachedPrefetches;
        default:
            return $aea8150f0ad1d89a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $aea8150f0ad1d89a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("34sDy", function(module, exports) {
"use strict";

var $eZGXe = parcelRequire("eZGXe");
module.exports = $eZGXe(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});


parcelRegister("8brVw", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("andBP"))($parcel$resolve("6Uloa")),
    (parcelRequire("34sDy"))($parcel$resolve("aeWLv")),
    (parcelRequire("34sDy"))($parcel$resolve("azitf"))
]).then(function() {
    return parcelRequire('lt7nD');
});

});

parcelRegister("9J7t2", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("fNBYX")).then(function() {
    return parcelRequire('lWlNJ');
});

});

parcelRegister("keddE", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("jNtOG")).then(function() {
    return parcelRequire('bIERW');
});

});

parcelRegister("koEHl", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("20W7K")).then(function() {
    return parcelRequire('6GIxd');
});

});

parcelRegister("ChThj", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("67n8D")).then(function() {
    return parcelRequire('hzjTq');
});

});

parcelRegister("7yHWh", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("6K6tW")).then(function() {
    return parcelRequire('9mZFG');
});

});

parcelRegister("3p1NJ", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("2oXvM")).then(function() {
    return parcelRequire('bwbPo');
});

});

parcelRegister("gxbVF", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("7RDzm")).then(function() {
    return parcelRequire('cApks');
});

});

parcelRegister("gx1US", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("mawwg")).then(function() {
    return parcelRequire('6Rim2');
});

});

parcelRegister("Ulhy4", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("4huDW")).then(function() {
    return parcelRequire('cl8CF');
});

});

parcelRegister("fuQ7O", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("bvyew")).then(function() {
    return parcelRequire('i7y9A');
});

});

parcelRegister("hoimP", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("lLAg5")).then(function() {
    return parcelRequire('2xr7b');
});

});

parcelRegister("lDIUU", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("5OBhA")).then(function() {
    return parcelRequire('lopuz');
});

});

parcelRegister("etHUl", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("5TMBU")).then(function() {
    return parcelRequire('cS1wW');
});

});

parcelRegister("7ziVG", function(module, exports) {

module.exports = (parcelRequire("34sDy"))($parcel$resolve("7yAbF")).then(function() {
    return parcelRequire('4Yh51');
});

});

var $ba42a74757e00ee2$exports = {};
$parcel$extendImportMap({
    "fVYx9": "image-carousel.111c77c2.js",
    "aeWLv": "image-carousel.0ea93268.js",
    "80w6d": "image-carousel.0d5ee711.css",
    "azitf": "spotlight-carousel.713e7c76.js",
    "6Uloa": "spotlight-carousel.85dc3389.css",
    "fNBYX": "cards-content-carousel.6b6f7286.js",
    "jNtOG": "accordion.b12f3471.js",
    "20W7K": "card-programs-search-result.225a7776.js",
    "67n8D": "hero-image.cf4d03e9.js",
    "6K6tW": "status-message-focus.38e5c5c4.js",
    "2oXvM": "member-registration-links.c56dfe32.js",
    "7RDzm": "desktop.6d6f819a.js",
    "mawwg": "mobile.eb9cc01c.js",
    "4huDW": "search.0f40d23b.js",
    "bvyew": "search-sticky.1482cc60.js",
    "lLAg5": "search-autocomplete.97be9c30.js",
    "5OBhA": "search-facet-a11y.302372ae.js",
    "5TMBU": "back-to-top.a73db290.js",
    "7yAbF": "shopify-deep-link.b962680c.js"
});

// Import CSS.

/* global Drupal, once */ /* IMPORTS GO HERE */ 
var $ap0Jw = parcelRequire("ap0Jw");

var $jRMQN = parcelRequire("jRMQN");
/**
 * @file Main navigation — dropdown toggle with animated transitions.
 */ 
var $e6mbt = parcelRequire("e6mbt");

var $lNXv7 = parcelRequire("lNXv7");
/** Duration in seconds for a full open or close animation. */ var $4b497158affa0eaa$var$DURATION = 0.33;
function $4b497158affa0eaa$export$9c43844ef57ea1d0() {
    var nav = document.getElementById('nav-desktop');
    if (!nav) return;
    var toggles = (0, $e6mbt._)(nav.querySelectorAll('.nav-desktop__toggle'));
    if (!toggles.length) return;
    toggles.forEach(function(toggle) {
        return $4b497158affa0eaa$var$initToggle(toggle, toggles);
    });
    document.addEventListener('keydown', function(e) {
        return $4b497158affa0eaa$var$onDocumentKeydown(e, toggles);
    });
    document.addEventListener('click', function(e) {
        return $4b497158affa0eaa$var$onDocumentClick(e, nav, toggles);
    });
}
// State helpers
/**
 * Returns the dropdown panel associated with a toggle button.
 *
 * @param {HTMLElement} toggle
 * @returns {HTMLElement|null}
 */ var $4b497158affa0eaa$var$getDropdown = function(toggle) {
    return toggle.nextElementSibling;
};
/**
 * Returns true when the dropdown is in its closed (inert) state.
 *
 * @param {HTMLElement} dropdown
 * @returns {boolean}
 */ var $4b497158affa0eaa$var$isClosed = function(dropdown) {
    return dropdown.hasAttribute('inert');
};
// Open / close
/**
 * Animates a dropdown panel open.
 * Motion picks up from the current opacity value if an animation is already running.
 *
 * @param {HTMLElement} toggle
 * @param {HTMLElement} dropdown
 */ function $4b497158affa0eaa$var$animateOpen(toggle, dropdown) {
    dropdown.removeAttribute('inert');
    toggle.setAttribute('aria-expanded', 'true');
    (0, $lNXv7.animate)(dropdown, {
        opacity: 1
    }, {
        duration: $4b497158affa0eaa$var$DURATION
    });
}
/**
 * Animates a dropdown panel closed.
 * Sets inert immediately so the panel leaves the accessibility tree at once,
 * then fades it out visually. Motion picks up from the current opacity if interrupted.
 *
 * @param {HTMLElement} toggle
 * @param {HTMLElement} dropdown
 * @param {boolean} [returnFocus=false] - When true, returns focus to the toggle immediately.
 */ function $4b497158affa0eaa$var$animateClose(toggle, dropdown) {
    var returnFocus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    dropdown.setAttribute('inert', '');
    toggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) toggle.focus();
    (0, $lNXv7.animate)(dropdown, {
        opacity: 0
    }, {
        duration: $4b497158affa0eaa$var$DURATION
    });
}
/**
 * Closes all currently open dropdowns.
 *
 * @param {HTMLElement[]} toggles
 * @param {boolean} [returnFocus=false] - When true, returns focus to the active toggle.
 */ function $4b497158affa0eaa$var$closeAll(toggles) {
    var returnFocus = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    toggles.forEach(function(toggle) {
        var dropdown = $4b497158affa0eaa$var$getDropdown(toggle);
        if (dropdown && !$4b497158affa0eaa$var$isClosed(dropdown)) $4b497158affa0eaa$var$animateClose(toggle, dropdown, returnFocus);
    });
}
// Per-toggle init
/**
 * Wires click behaviour for a single toggle button.
 *
 * @param {HTMLElement} toggle
 * @param {HTMLElement[]} toggles - All toggles in the nav, used to close siblings.
 */ function $4b497158affa0eaa$var$initToggle(toggle, toggles) {
    var dropdown = $4b497158affa0eaa$var$getDropdown(toggle);
    if (!dropdown) return;
    // Enforce closed state regardless of server-rendered attributes.
    dropdown.setAttribute('inert', '');
    dropdown.style.opacity = '0';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function() {
        var opening = $4b497158affa0eaa$var$isClosed(dropdown);
        $4b497158affa0eaa$var$closeAll(toggles);
        if (opening) $4b497158affa0eaa$var$animateOpen(toggle, dropdown);
    });
}
// Document-level listeners
/**
 * Closes all dropdowns on Escape, returning focus to the active toggle.
 *
 * @param {KeyboardEvent} e
 * @param {HTMLElement[]} toggles
 */ function $4b497158affa0eaa$var$onDocumentKeydown(e, toggles) {
    if (e.key !== 'Escape') return;
    $4b497158affa0eaa$var$closeAll(toggles, true);
}
/**
 * Closes all dropdowns when the user clicks outside the nav.
 *
 * @param {MouseEvent} e
 * @param {HTMLElement} nav
 * @param {HTMLElement[]} toggles
 */ function $4b497158affa0eaa$var$onDocumentClick(e, nav, toggles) {
    if (nav.contains(e.target)) return;
    $4b497158affa0eaa$var$closeAll(toggles);
}


/**
 * @file Mobile navigation — drawer toggle and accordion behaviour.
 */ 
var $e6mbt = parcelRequire("e6mbt");

var $lNXv7 = parcelRequire("lNXv7");
var $NCinx = parcelRequire("NCinx");
function $f4f90926f6330026$export$35c8f6884e82cf8d(from, total) {
    if (from === "first") return 0;
    else {
        var lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function $f4f90926f6330026$export$ef0b4d89074db4d0() {
    var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.1, _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_startDelay = _ref.startDelay, startDelay = _ref_startDelay === void 0 ? 0 : _ref_startDelay, _ref_from = _ref.from, from = _ref_from === void 0 ? 0 : _ref_from, ease = _ref.ease;
    return function(i, total) {
        var fromIndex = typeof from === "number" ? from : $f4f90926f6330026$export$35c8f6884e82cf8d(from, total);
        var distance = Math.abs(fromIndex - i);
        var delay = duration * distance;
        if (ease) {
            var maxDelay = total * duration;
            var easingFunction = (0, $NCinx.easingDefinitionToFunction)(ease);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return startDelay + delay;
    };
}



var $ddUPS = parcelRequire("ddUPS");
/** Duration in seconds for drawer and accordion animations. */ var $932c3361f949421d$var$DURATION = 0.25;
var $932c3361f949421d$var$reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
/** Stagger interval between each nav item fade-in, in seconds. */ var $932c3361f949421d$var$STAGGER_INTERVAL = $932c3361f949421d$var$reducedMotion ? 0.01 : 0.04;
/** Duration of each individual nav item fade-in, in seconds. */ var $932c3361f949421d$var$FADE_DURATION = $932c3361f949421d$var$reducedMotion ? 0.01 : 0.2;
function $932c3361f949421d$export$3a2707b50c3b4a73() {
    var nav = document.getElementById('nav-mobile');
    if (!nav) return;
    var toggle = nav.querySelector('.menu-toggle');
    var drawer = document.getElementById('nav-mobile-drawer');
    if (!toggle || !drawer) return;
    $932c3361f949421d$var$initDrawer(toggle, drawer);
    $932c3361f949421d$var$initAccordions(drawer);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !$932c3361f949421d$var$isClosed(drawer)) $932c3361f949421d$var$closeDrawer(toggle, drawer, true);
    });
    // The viewport can change height while the drawer is open (rotation, the
    // mobile browser chrome showing/hiding on scroll) — keep the cap current.
    window.addEventListener('resize', (0, $ddUPS.debounce)(function() {
        if (!$932c3361f949421d$var$isClosed(drawer)) $932c3361f949421d$var$setDrawerMaxHeight(drawer);
    }, 150));
}
// State helpers
/**
 * Returns true when an element is in its closed (inert) state.
 *
 * @param {HTMLElement} el
 * @returns {boolean}
 */ var $932c3361f949421d$var$isClosed = function(el) {
    return el.hasAttribute('inert');
};
// Drawer
/**
 * Caps the drawer's height to the space remaining below it in the viewport,
 * so content taller than that scrolls inside the drawer (via its
 * `overflow-y-auto`) instead of extending past the bottom of the screen
 * with no way to reach it.
 *
 * @param {HTMLElement} drawer
 */ function $932c3361f949421d$var$setDrawerMaxHeight(drawer) {
    var available = window.innerHeight - drawer.getBoundingClientRect().top;
    drawer.style.maxHeight = "".concat(available, "px");
}
/**
 * Wires the hamburger toggle button to open and close the drawer.
 *
 * @param {HTMLElement} toggle
 * @param {HTMLElement} drawer
 */ function $932c3361f949421d$var$initDrawer(toggle, drawer) {
    drawer.setAttribute('inert', '');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function() {
        if ($932c3361f949421d$var$isClosed(drawer)) {
            $932c3361f949421d$var$openDrawer(toggle, drawer);
            return;
        }
        $932c3361f949421d$var$closeDrawer(toggle, drawer);
        // Otherwise the still-focused button keeps the header's :focus-within reveal engaged.
        toggle.blur();
    });
}
/**
 * Opens the navigation drawer.
 *
 * @param {HTMLElement} toggle
 * @param {HTMLElement} drawer
 */ function $932c3361f949421d$var$openDrawer(toggle, drawer) {
    $932c3361f949421d$var$setDrawerMaxHeight(drawer);
    drawer.removeAttribute('inert');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    (0, $lNXv7.animate)(drawer, {
        height: 'auto'
    }, {
        duration: $932c3361f949421d$var$DURATION
    });
    // Collect top-level LIs from both navs in document order so the stagger
    // runs through the main nav items first, then the utility nav items.
    var items = (0, $e6mbt._)(drawer.querySelectorAll('nav[aria-label="Mobile navigation"] > ul > li')).concat((0, $e6mbt._)(drawer.querySelectorAll('nav[aria-label="Utility navigation"] > ul > li')));
    if (items.length) {
        // Reset so re-opens always start from opacity 0.
        items.forEach(function(li) {
            li.style.opacity = '0';
        });
        (0, $lNXv7.animate)(items, {
            opacity: [
                0,
                1
            ]
        }, {
            delay: (0, $f4f90926f6330026$export$ef0b4d89074db4d0)($932c3361f949421d$var$STAGGER_INTERVAL),
            duration: $932c3361f949421d$var$FADE_DURATION
        });
    }
}
/**
 * Closes the navigation drawer and optionally returns focus to the toggle.
 *
 * @param {HTMLElement} toggle
 * @param {HTMLElement} drawer
 * @param {boolean} [returnFocus=false]
 */ function $932c3361f949421d$var$closeDrawer(toggle, drawer) {
    var returnFocus = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    drawer.setAttribute('inert', '');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    (0, $lNXv7.animate)(drawer, {
        height: 0
    }, {
        duration: $932c3361f949421d$var$DURATION
    });
    // Reset LI opacities so the next open always starts from 0.
    drawer.querySelectorAll('nav > ul > li').forEach(function(li) {
        li.style.opacity = '0';
    });
    if (returnFocus) toggle.focus();
}
// Accordions
/**
 * Initialises all accordion toggles found within the drawer.
 *
 * @param {HTMLElement} drawer
 */ function $932c3361f949421d$var$initAccordions(drawer) {
    drawer.querySelectorAll('.nav-mobile__accordion-toggle').forEach(function(toggle) {
        return $932c3361f949421d$var$initAccordion(toggle);
    });
}
/**
 * Wires a single accordion toggle.
 *
 * @param {HTMLElement} toggle
 */ function $932c3361f949421d$var$initAccordion(toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    panel.setAttribute('inert', '');
    panel.style.height = '0';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', function() {
        $932c3361f949421d$var$isClosed(panel) ? $932c3361f949421d$var$openAccordion(toggle, panel) : $932c3361f949421d$var$closeAccordion(toggle, panel);
    });
}
/**
 * Opens an accordion panel.
 *
 * @param {HTMLElement} toggle
 * @param {HTMLElement} panel
 */ function $932c3361f949421d$var$openAccordion(toggle, panel) {
    panel.removeAttribute('inert');
    toggle.setAttribute('aria-expanded', 'true');
    (0, $lNXv7.animate)(panel, {
        height: 'auto'
    }, {
        duration: $932c3361f949421d$var$DURATION
    });
}
/**
 * Closes an accordion panel.
 *
 * @param {HTMLElement} toggle
 * @param {HTMLElement} panel
 */ function $932c3361f949421d$var$closeAccordion(toggle, panel) {
    panel.setAttribute('inert', '');
    toggle.setAttribute('aria-expanded', 'false');
    (0, $lNXv7.animate)(panel, {
        height: 0
    }, {
        duration: $932c3361f949421d$var$DURATION
    });
}


/**
 * @file Keeps --header-wrapper-height in sync with the fixed header's real
 * rendered height (body padding-top and the anchor scroll offset both read
 * this custom property), and hides/reveals the header as the user scrolls.
 *
 * Logged-in editors don't get the fixed/sticky header at all.
 */ 
var $ddUPS = parcelRequire("ddUPS");
/** Modifier class that slides the header out of view. */ var $60d3992227eb8bb0$var$HIDDEN_CLASS = "header-wrapper--hidden";
/**
 * Minimum upward scroll distance, in px, within UP_SCROLL_WINDOW_MS that
 * counts as a deliberate attempt to scroll back to the top — and so reveals
 * the header even mid-page. Tune alongside UP_SCROLL_WINDOW_MS.
 */ var $60d3992227eb8bb0$var$UP_SCROLL_DISTANCE = 200;
/** Time window, in ms, that UP_SCROLL_DISTANCE must occur within. */ var $60d3992227eb8bb0$var$UP_SCROLL_WINDOW_MS = 1000;
function $60d3992227eb8bb0$export$33ec9fcec07f6e7f(headerWrapperEl) {
    // Logged-in editors get a normal, non-fixed header (see header-wrapper.css)
    // — none of the height-sync/hide-on-scroll behavior below applies to them.
    if (document.body.classList.contains("user-logged-in")) return;
    var setHeight = (0, $ddUPS.rafThrottle)(function() {
        document.documentElement.style.setProperty("--header-wrapper-height", "".concat(headerWrapperEl.offsetHeight, "px"));
    });
    new ResizeObserver(setHeight).observe(headerWrapperEl);
    $60d3992227eb8bb0$var$initAutoHide(headerWrapperEl);
}
/**
 * Hides the header while the user scrolls down, and reveals it at the top
 * of the page or on a deliberate upward scroll (see UP_SCROLL_DISTANCE /
 * UP_SCROLL_WINDOW_MS) — the assumption being they're heading back to top.
 *
 * Hiding doesn't engage at all until the user has scrolled down past the
 * header's own height (--header-wrapper-height) — before that, the header
 * hasn't fully cleared the top of the viewport yet, so sliding it away
 * would look premature.
 *
 * @param {HTMLElement} headerWrapperEl
 */ function $60d3992227eb8bb0$var$initAutoHide(headerWrapperEl) {
    var lastScrollY = window.scrollY;
    // Marks the start of the current upward scroll run: the highest scrollY
    // reached before the user started scrolling up, and when that run began.
    var upScrollAnchorY = lastScrollY;
    var upScrollAnchorTime = performance.now();
    var onScroll = (0, $ddUPS.rafThrottle)(function() {
        var currentScrollY = window.scrollY;
        var now = performance.now();
        var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-wrapper-height")) || 0;
        if (currentScrollY <= headerHeight) {
            headerWrapperEl.classList.remove($60d3992227eb8bb0$var$HIDDEN_CLASS);
            upScrollAnchorY = currentScrollY;
            upScrollAnchorTime = now;
        } else if (currentScrollY > lastScrollY) {
            // Scrolling down — hide, and reset the upward-run anchor.
            headerWrapperEl.classList.add($60d3992227eb8bb0$var$HIDDEN_CLASS);
            upScrollAnchorY = currentScrollY;
            upScrollAnchorTime = now;
        } else if (currentScrollY < lastScrollY) {
            // Scrolling up — restart the anchor once its window has expired, so
            // a slow drift up never accumulates into a reveal.
            if (now - upScrollAnchorTime > $60d3992227eb8bb0$var$UP_SCROLL_WINDOW_MS) {
                upScrollAnchorY = currentScrollY;
                upScrollAnchorTime = now;
            }
            if (upScrollAnchorY - currentScrollY >= $60d3992227eb8bb0$var$UP_SCROLL_DISTANCE) headerWrapperEl.classList.remove($60d3992227eb8bb0$var$HIDDEN_CLASS);
        }
        lastScrollY = currentScrollY;
    });
    window.addEventListener("scroll", onScroll, {
        passive: true
    });
}


/* global once */ /**
 * @file Member soft-gate behaviour (Protech SSO).
 *
 * Membership is signalled by the presence of the Protech cookie
 * (`cswe_protech_contact_id`, set by cswe_protech_sso). No Drupal session
 * exists, so the server ships one cached, locked variant to everyone and the
 * reveal happens client-side. The visual blur and the "Member Logout" link are
 * toggled pre-paint by CSS via the `is-member` class (html.html.twig); this
 * module handles only the parts that need JS.
 */ 
var $ddUPS = parcelRequire("ddUPS");
function $85cc5d1a4e13ff0a$export$75a51b2857c61410(context) {
    if ((0, $ddUPS.getCookie)("cswe_protech_contact_id")) /* Members: lift the interaction block from soft-gated content. The blur is
       already removed pre-paint by CSS (is-member), and the utility-nav
       "Member Logout" link is revealed by CSS — no JS needed for either. */ once("ts-cswe-members-only", ".members-only-content", context).forEach(function(region) {
        return region.removeAttribute("inert");
    });
    else /* Guests: open the Protech sign-in flow in a popup. Also enhances any
       future sign-in links pointing at the Protech sign-in endpoint. */ once("ts-cswe-sso-login", 'a[href*="membership.cswe.org/Security/Sign-In"]', context).forEach(function(link) {
        link.addEventListener("click", function(e) {
            e.preventDefault();
            /* Return to this environment's SSO callback after Protech sign-in. */ var url = new URL(link.href);
            url.searchParams.set("returnurl", window.location.origin + "/sso/callback");
            window.open(url.toString(), "sso_login", "width=560,height=680,scrollbars=yes,resizable=yes");
        });
    });
}


/**
 * @file Send links that leave the page to a new tab, and say so.
 *
 * Two kinds of link leave: one that goes off-site, and one that opens a
 * document rather than a page (see document-links.js, which names the file
 * type). They are decided together here because they are one rule — the
 * visitor is taken somewhere the site's navigation and the back button no
 * longer serve them — and because the notice and the `rel` are the same
 * either way.
 *
 * Applied to every link on the page rather than being something an editor sets
 * per link: the behaviour is a site-wide rule, and the text formats deliberately
 * do not expose a target attribute (`editor_advanced_link_link` ships with no
 * enabled attributes, and `filter_html` allows neither `target` nor `rel` on an
 * `<a>`), so there is no editor-facing switch to keep in sync with it.
 *
 * Done in the browser because links reach a page from too many places to catch
 * server-side — body text, link fields on paragraphs and cards, menus, the
 * footer — and every one of them would need its own hook. A visitor without JS
 * follows the link in the same tab, which is the behaviour of an ordinary link
 * and loses them nothing. (The contributed `extlink` module solves it the same
 * way; it is not used here because its per-site settings UI and link icon are
 * more than this needs.)
 *
 * A link opening a new tab must announce it, or a screen reader user is moved
 * without warning and the back button no longer goes back (WCAG 3.2.5). The
 * notice therefore goes on every link that ends up with `target="_blank"` —
 * including the few that arrive with one already, such as the Remote video
 * links Linkit builds (see MediaFileOrRemoteUrl) — and not only on the ones
 * this module retargets.
 */ /* global Drupal, once */ 
var $e6mbt = parcelRequire("e6mbt");

var $ddUPS = parcelRequire("ddUPS");
/**
 * @file Name the file type of links that point at documents.
 *
 * A PDF or an Office file is not a web page: following one hands the visitor
 * off to the browser's document viewer or to another application, where the
 * site's navigation is gone and the back button is the only way out. Screen
 * reader users meet a different document mode with no warning. So the link
 * says what it opens, and opens it beside the page rather than over it — the
 * same bargain external links already make here, for the same reason
 * (WCAG 3.2.5).
 *
 * Done in the browser, and for the same reason external-links.js is: a link
 * reaches a page from body text, link fields on paragraphs and cards, menus
 * and the footer, and catching them server-side would need a hook in each.
 * A visitor without JS follows an ordinary link to an ordinary file.
 *
 * This module only names the file type. Sending the link to a new tab is
 * external-links.js's job: "leaves the page" is one rule with two grounds —
 * off-site, or a document — and splitting the decision across two modules
 * meant neither could be read on its own. It imports isDocumentUrl() from
 * here so the list of extensions has one home.
 *
 * Runs immediately before externalLinks() in main.js, which is now only about
 * how the two notices read: "Handbook (PDF) (opens in a new tab)".
 */ /* global Drupal, once */ 
var $ddUPS = parcelRequire("ddUPS");
/**
 * The file types announced, by extension.
 *
 * Only the formats that take the visitor out of the browsing context are
 * listed. A `.txt` or `.csv` renders as text in the tab it was opened from and
 * needs no warning; the Office formats and PDF do not.
 *
 * `label` is a function so Drupal.t() resolves at the point of use rather than
 * whenever this module happens to be imported, which may be before Drupal is
 * on the page. `announced` matches a name that already says the type — an
 * editor who wrote "(PDF)" into the link text, or a file field printing a name
 * ending ".docx" — so it is not said twice.
 *
 * It matches the extension or the whole label, never the product name alone:
 * "word", "excel" and "presentation" are ordinary English, and "A word from
 * our president.docx" is a link that needs the notice rather than one that
 * already carries it.
 */ var $dc08e7c807f7d34b$var$DOCUMENT_TYPES = {
    pdf: {
        label: function() {
            return Drupal.t("PDF");
        },
        announced: /\bpdf\b/i
    },
    doc: {
        label: function() {
            return Drupal.t("Word document");
        },
        announced: /\bdocx?\b|\bword document\b/i
    },
    xls: {
        label: function() {
            return Drupal.t("Excel spreadsheet");
        },
        announced: /\bxlsx?\b|\bexcel spreadsheet\b/i
    },
    ppt: {
        label: function() {
            return Drupal.t("PowerPoint presentation");
        },
        announced: /\bpptx?\b|\bpowerpoint presentation\b/i
    }
};
/** Maps each recognised extension onto its entry in DOCUMENT_TYPES. */ var $dc08e7c807f7d34b$var$EXTENSIONS = {
    pdf: "pdf",
    doc: "doc",
    docx: "doc",
    xls: "xls",
    xlsx: "xls",
    ppt: "ppt",
    pptx: "ppt"
};
/**
 * Returns the document type a link points at, or null for anything else.
 *
 * @param {string} url - An absolute or relative URL.
 * @returns {{label: function, announced: RegExp}|null}
 */ function $dc08e7c807f7d34b$var$documentType(url) {
    var extension = (0, $ddUPS.fileExtensionFromUrl)(url);
    var _DOCUMENT_TYPES_EXTENSIONS_extension;
    return extension ? (_DOCUMENT_TYPES_EXTENSIONS_extension = $dc08e7c807f7d34b$var$DOCUMENT_TYPES[$dc08e7c807f7d34b$var$EXTENSIONS[extension]]) !== null && _DOCUMENT_TYPES_EXTENSIONS_extension !== void 0 ? _DOCUMENT_TYPES_EXTENSIONS_extension : null : null;
}
function $dc08e7c807f7d34b$export$c2a2408b1e7678e4(url) {
    return $dc08e7c807f7d34b$var$documentType(url) !== null;
}
/**
 * Adds the file-type notice to a link's accessible name.
 *
 * @param {HTMLAnchorElement} link - The link to annotate.
 * @param {string} label - The type to announce, e.g. "PDF".
 */ function $dc08e7c807f7d34b$var$announce(link, label) {
    var ariaLabel = link.getAttribute("aria-label");
    /* An aria-label replaces the link's contents for assistive technology, so on
     a labelled link the notice has to join the label — appended as text it
     would never be read. Same handling as external-links.js. */ if (ariaLabel !== null) {
        link.setAttribute("aria-label", "".concat(ariaLabel, ", ").concat(label));
        return;
    }
    var notice = document.createElement("span");
    /* `visually-hidden` (Drupal core's system/base, on every page) rather than
     the `sr-only` the twig templates use: Tailwind generates a utility only
     where it can see the literal class name, and its content globs do not
     reach this directory. */ notice.className = "visually-hidden";
    notice.textContent = " (".concat(label, ")");
    link.appendChild(notice);
}
function $dc08e7c807f7d34b$export$33834e5fcd2ec3eb(context) {
    once("ts-cswe-document-link", "a[href]", context).forEach(function(link) {
        var type = $dc08e7c807f7d34b$var$documentType(link.href);
        if (!type) return;
        var _link_getAttribute;
        if (!type.announced.test((_link_getAttribute = link.getAttribute("aria-label")) !== null && _link_getAttribute !== void 0 ? _link_getAttribute : link.textContent)) $dc08e7c807f7d34b$var$announce(link, type.label());
    });
}


/**
 * Matches an accessible name that already announces the new tab.
 *
 * Some links say it in their own markup — the social icons pass an aria-label
 * ending "opens in a new tab" — and those must not be told twice.
 */ var $5a9845af0b1228e8$var$ANNOUNCED = /new (tab|window)/i;
/**
 * Returns whether following a link takes the visitor out of this page.
 *
 * The `download` test applies to the document ground only, and the asymmetry
 * is the browsers': a same-origin download writes the file to disk and leaves
 * the page where it is, so there is no new tab and nothing to announce, while
 * `download` on a cross-origin link is ignored for security and the link
 * navigates like any other.
 *
 * @param {HTMLAnchorElement} link - The link to test.
 * @returns {boolean}
 */ function $5a9845af0b1228e8$var$leavesThePage(link) {
    if ((0, $ddUPS.isExternalUrl)(link.href)) return true;
    return (0, $dc08e7c807f7d34b$export$c2a2408b1e7678e4)(link.href) && !link.hasAttribute("download");
}
/**
 * Adds the new-tab notice to a link's accessible name.
 *
 * @param {HTMLAnchorElement} link - The link to annotate.
 */ function $5a9845af0b1228e8$var$announce(link) {
    var label = link.getAttribute("aria-label");
    /* An aria-label replaces the link's contents for assistive technology, so on
     a labelled link (an icon-only one, typically) the notice has to join the
     label — appended as text it would never be read. */ if (label !== null) {
        link.setAttribute("aria-label", "".concat(label, ", ").concat(Drupal.t("opens in a new tab")));
        return;
    }
    var notice = document.createElement("span");
    /* `visually-hidden` (Drupal core's system/base, on every page) rather than
     the `sr-only` the twig templates use: Tailwind generates a utility only
     where it can see the literal class name, and its content globs do not
     reach this directory — `sr-only` written here would be purged. */ notice.className = "visually-hidden";
    notice.textContent = " ".concat(Drupal.t("(opens in a new tab)"));
    link.appendChild(notice);
}
function $5a9845af0b1228e8$export$16e3000e97aa2529(context) {
    once("ts-cswe-external-link", "a[href]", context).forEach(function(link) {
        var target = (0, $ddUPS.deliberateTarget)(link);
        /* A target the markup chose wins: it is a decision about that one link,
       made with more context than a URL has. Not every target attribute is
       such a choice — @see deliberateTarget(). */ if (target && target !== "_blank") return;
        if (!target) {
            if (!$5a9845af0b1228e8$var$leavesThePage(link)) return;
            link.setAttribute("target", "_blank");
        }
        /* Belt and braces: current browsers imply noopener for target="_blank",
       older ones hand the new tab a window.opener it can navigate this one
       with. Any rel the link already carries (nofollow, me) is kept. */ var rel = (link.getAttribute("rel") || "").split(/\s+/).filter(Boolean);
        if (!rel.includes("noopener")) link.setAttribute("rel", (0, $e6mbt._)(rel).concat([
            "noopener"
        ]).join(" "));
        var _link_getAttribute;
        if (!$5a9845af0b1228e8$var$ANNOUNCED.test((_link_getAttribute = link.getAttribute("aria-label")) !== null && _link_getAttribute !== void 0 ? _link_getAttribute : link.textContent)) $5a9845af0b1228e8$var$announce(link);
    });
}




var $ddUPS = parcelRequire("ddUPS");
















/**
 * Initialises theme components found within a context.
 *
 * Runs on initial page load and again for any content Drupal inserts via
 * AJAX (e.g. Views exposed filters). Each component's elements are collected
 * with once() so they are only initialised a single time.
 *
 * @param {HTMLElement|Document} context
 *   The element to scope queries to (document on full page load, the
 *   inserted wrapper on AJAX updates).
 */ function $604fb00e16720e43$var$init(context) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $ap0Jw._)(function() {
        var imageCarousels, imageCarouselJS, spotlightCarousels, spotlightJS, carousels, carouselJS, accordionSections, accordionsJS, programSearchToggles, programSearchCardsJS, heroImageColumns, heroImageJS, errorMessages, statusMessageJS, memberContactId, registrationLinks, registrationLinksJS, tocDesktop, tocDesktopJS, tocMobile, tocMobileJS, searchFilterButtons, searchJS, searchFilterPanels, searchStickyJS, searchAutocompleteInputs, autocompleteJS, facetSelects, facetA11yJS, backToTopBtns, backToTopJS, buyButtonGrids, shopifyDeepLinkJS, headerWrapperEl;
        return (0, $jRMQN._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    /* Load JS for blocks only if they exist on the page */ /* https://parceljs.org/features/code-splitting/ */ // Image Carousel
                    imageCarousels = once("ts-cswe-image-carousel", ".image-carousel", context);
                    if (!(imageCarousels.length > 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (parcelRequire("iyHu2"))
                    ];
                case 1:
                    imageCarouselJS = _state.sent();
                    imageCarouselJS.render(imageCarousels);
                    _state.label = 2;
                case 2:
                    // Spotlight Carousel
                    spotlightCarousels = once("ts-cswe-spotlight-carousel", ".spotlight-carousel", context);
                    if (!(spotlightCarousels.length > 0)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        (parcelRequire("8brVw"))
                    ];
                case 3:
                    spotlightJS = _state.sent();
                    spotlightJS.render(spotlightCarousels);
                    _state.label = 4;
                case 4:
                    // Carousel
                    carousels = once("ts-cswe-cards-carousel", ".cards-carousel .swiper", context);
                    if (!(carousels.length > 0)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        (parcelRequire("9J7t2"))
                    ];
                case 5:
                    carouselJS = _state.sent();
                    carouselJS.render(carousels);
                    _state.label = 6;
                case 6:
                    /* Accordion */ accordionSections = once("ts-cswe-accordion", ".accordion__section", context);
                    if (!(accordionSections.length > 0)) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        (parcelRequire("keddE"))
                    ];
                case 7:
                    accordionsJS = _state.sent();
                    accordionsJS.render(accordionSections);
                    _state.label = 8;
                case 8:
                    /* Program Search Result Cards */ programSearchToggles = once("ts-cswe-program-search-card", ".card-program-search-listing__view-less", context);
                    if (!(programSearchToggles.length > 0)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        (parcelRequire("koEHl"))
                    ];
                case 9:
                    programSearchCardsJS = _state.sent();
                    programSearchCardsJS.render(programSearchToggles);
                    _state.label = 10;
                case 10:
                    /* Hero Image (extend flush to viewport edge on wide screens) */ heroImageColumns = once("ts-cswe-hero-image", ".hero-image__image", context);
                    if (!(heroImageColumns.length > 0)) return [
                        3,
                        12
                    ];
                    return [
                        4,
                        (parcelRequire("ChThj"))
                    ];
                case 11:
                    heroImageJS = _state.sent();
                    heroImageJS.render(heroImageColumns);
                    _state.label = 12;
                case 12:
                    /* Document links (PDF, Word, Excel, PowerPoint): say what file they open.
     Before externalLinks() only so the two notices read in that order —
     "Handbook (PDF) (opens in a new tab)". */ (0, $dc08e7c807f7d34b$export$33834e5fcd2ec3eb)(context);
                    /* Links that leave the page — off-site, or a document: open in a new tab,
     and announce that they do. */ (0, $5a9845af0b1228e8$export$16e3000e97aa2529)(context);
                    /* Error messages: a server-rendered one announces itself to nobody, so focus
     is moved to it. Matched on the tabindex the status-messages template puts on
     error messages only — core's JS-injected messages share the .messages--error
     hook but announce themselves correctly and must be left alone. */ errorMessages = once("ts-cswe-status-message-focus", '[data-drupal-messages] .messages--error[tabindex="-1"]', context);
                    if (!(errorMessages.length > 0)) return [
                        3,
                        14
                    ];
                    return [
                        4,
                        (parcelRequire("7yHWh"))
                    ];
                case 13:
                    statusMessageJS = _state.sent();
                    statusMessageJS.render(errorMessages);
                    _state.label = 14;
                case 14:
                    /* Member soft-gate: reveal members-only content / wire the SSO sign-in. */ (0, $85cc5d1a4e13ff0a$export$75a51b2857c61410)(context);
                    /* American Tradeshow registration links: for a signed-in member, append their
     Protech contact ID. Gated on the cookie first, so guests do no DOM query
     and never load the module. */ memberContactId = (0, $ddUPS.getCookie)("cswe_protech_contact_id");
                    if (!memberContactId) return [
                        3,
                        16
                    ];
                    registrationLinks = once("ts-cswe-registration-links", 'a[href^="https://registration.american-tradeshow.com/"]', context);
                    if (!(registrationLinks.length > 0)) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        (parcelRequire("3p1NJ"))
                    ];
                case 15:
                    registrationLinksJS = _state.sent();
                    registrationLinksJS.render(registrationLinks, memberContactId);
                    _state.label = 16;
                case 16:
                    /* Table of Contents Desktop */ tocDesktop = once("ts-cswe-toc-desktop", ".toc-desktop", context);
                    if (!(tocDesktop.length > 0)) return [
                        3,
                        18
                    ];
                    return [
                        4,
                        (parcelRequire("gxbVF"))
                    ];
                case 17:
                    tocDesktopJS = _state.sent();
                    tocDesktopJS.render(tocDesktop);
                    _state.label = 18;
                case 18:
                    /* Table of Contents Mobile */ tocMobile = once("ts-cswe-toc-mobile", ".toc-mobile", context);
                    if (!(tocMobile.length > 0)) return [
                        3,
                        20
                    ];
                    return [
                        4,
                        (parcelRequire("gx1US"))
                    ];
                case 19:
                    tocMobileJS = _state.sent();
                    tocMobileJS.render(tocMobile);
                    _state.label = 20;
                case 20:
                    /* Search Filters */ searchFilterButtons = once("ts-cswe-search-filters", ".search-filter-button", context);
                    if (!(searchFilterButtons.length > 0)) return [
                        3,
                        22
                    ];
                    return [
                        4,
                        (parcelRequire("Ulhy4"))
                    ];
                case 21:
                    searchJS = _state.sent();
                    searchJS.render(searchFilterButtons);
                    _state.label = 22;
                case 22:
                    /* Search Filters — unpin the sticky panel when it outgrows the viewport. */ searchFilterPanels = once("ts-cswe-search-sticky", ".search-filters", context);
                    if (!(searchFilterPanels.length > 0)) return [
                        3,
                        24
                    ];
                    return [
                        4,
                        (parcelRequire("fuQ7O"))
                    ];
                case 23:
                    searchStickyJS = _state.sent();
                    searchStickyJS.render(searchFilterPanels);
                    _state.label = 24;
                case 24:
                    /* Search Keyword Autocomplete */ searchAutocompleteInputs = once("ts-cswe-search-autocomplete", "input.js-search-autocomplete", context);
                    if (!(searchAutocompleteInputs.length > 0)) return [
                        3,
                        26
                    ];
                    return [
                        4,
                        (parcelRequire("hoimP"))
                    ];
                case 25:
                    autocompleteJS = _state.sent();
                    autocompleteJS.render(searchAutocompleteInputs);
                    _state.label = 26;
                case 26:
                    /* Search Facet Selects — drop the Tagify-replaced selects from the a11y tree. */ facetSelects = once("ts-cswe-search-facet-a11y", "select.tagify-select-widget", context);
                    if (!(facetSelects.length > 0)) return [
                        3,
                        28
                    ];
                    return [
                        4,
                        (parcelRequire("lDIUU"))
                    ];
                case 27:
                    facetA11yJS = _state.sent();
                    facetA11yJS.render(facetSelects);
                    _state.label = 28;
                case 28:
                    /* Back to Top */ backToTopBtns = once("ts-cswe-back-to-top", ".btn-back-to-top", context);
                    if (!(backToTopBtns.length > 0)) return [
                        3,
                        30
                    ];
                    return [
                        4,
                        (parcelRequire("etHUl"))
                    ];
                case 29:
                    backToTopJS = _state.sent();
                    backToTopJS.render(backToTopBtns);
                    _state.label = 30;
                case 30:
                    if (!new URLSearchParams(window.location.search).has("product")) return [
                        3,
                        32
                    ];
                    buyButtonGrids = once("ts-cswe-shopify-deep-link", '[id^="collection-component-"]', context);
                    if (!(buyButtonGrids.length > 0)) return [
                        3,
                        32
                    ];
                    return [
                        4,
                        (parcelRequire("7ziVG"))
                    ];
                case 31:
                    shopifyDeepLinkJS = _state.sent();
                    shopifyDeepLinkJS.render(buyButtonGrids);
                    _state.label = 32;
                case 32:
                    /* Global Components — run once on the initial full-document attach only. */ if (once("ts-cswe-global", "body", context).length > 0) {
                        (0, $4b497158affa0eaa$export$9c43844ef57ea1d0)();
                        (0, $932c3361f949421d$export$3a2707b50c3b4a73)();
                        headerWrapperEl = document.querySelector(".header-wrapper");
                        if (headerWrapperEl) (0, $60d3992227eb8bb0$export$33ec9fcec07f6e7f)(headerWrapperEl);
                    }
                    return [
                        2
                    ];
            }
        });
    })();
}
/* Initialize site scripts on page load and after every Drupal AJAX update. */ Drupal.behaviors.tsCswe = {
    attach: function(context) {
        $604fb00e16720e43$var$init(context);
    }
};



})();
//# sourceMappingURL=motif.js.map
